"use strict";

require("core-js/modules/esnext.global-this.js");

require("core-js/modules/esnext.string.replace-all.js");

var e,
    t = require("react"),
    n = (e = t) && "object" == typeof e && "default" in e ? e.default : e,
    r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function o(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function i(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var a = i(function (e) {
  var t = function (e) {
    var t = Object.prototype,
        n = t.hasOwnProperty,
        r = "function" == typeof Symbol ? Symbol : {},
        o = r.iterator || "@@iterator",
        i = r.asyncIterator || "@@asyncIterator",
        a = r.toStringTag || "@@toStringTag";

    function c(e, t, n, r) {
      var o = t && t.prototype instanceof u ? t : u,
          i = Object.create(o.prototype),
          a = new E(r || []);
      return i._invoke = function (e, t, n) {
        var r = "suspendedStart";
        return function (o, i) {
          if ("executing" === r) throw new Error("Generator is already running");

          if ("completed" === r) {
            if ("throw" === o) throw i;
            return S();
          }

          for (n.method = o, n.arg = i;;) {
            var a = n.delegate;

            if (a) {
              var c = x(a, n);

              if (c) {
                if (c === s) continue;
                return c;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if ("suspendedStart" === r) throw r = "completed", n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = "executing";
            var u = l(e, t, n);

            if ("normal" === u.type) {
              if (r = n.done ? "completed" : "suspendedYield", u.arg === s) continue;
              return {
                value: u.arg,
                done: n.done
              };
            }

            "throw" === u.type && (r = "completed", n.method = "throw", n.arg = u.arg);
          }
        };
      }(e, n, a), i;
    }

    function l(e, t, n) {
      try {
        return {
          type: "normal",
          arg: e.call(t, n)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    e.wrap = c;
    var s = {};

    function u() {}

    function d() {}

    function f() {}

    var p = {};

    p[o] = function () {
      return this;
    };

    var m = Object.getPrototypeOf,
        g = m && m(m(k([])));
    g && g !== t && n.call(g, o) && (p = g);
    var h = f.prototype = u.prototype = Object.create(p);

    function v(e) {
      ["next", "throw", "return"].forEach(function (t) {
        e[t] = function (e) {
          return this._invoke(t, e);
        };
      });
    }

    function b(e) {
      var t;

      this._invoke = function (r, o) {
        function i() {
          return new Promise(function (t, i) {
            !function t(r, o, i, a) {
              var c = l(e[r], e, o);

              if ("throw" !== c.type) {
                var s = c.arg,
                    u = s.value;
                return u && "object" == typeof u && n.call(u, "__await") ? Promise.resolve(u.__await).then(function (e) {
                  t("next", e, i, a);
                }, function (e) {
                  t("throw", e, i, a);
                }) : Promise.resolve(u).then(function (e) {
                  s.value = e, i(s);
                }, function (e) {
                  return t("throw", e, i, a);
                });
              }

              a(c.arg);
            }(r, o, t, i);
          });
        }

        return t = t ? t.then(i, i) : i();
      };
    }

    function x(e, t) {
      var n = e.iterator[t.method];

      if (void 0 === n) {
        if (t.delegate = null, "throw" === t.method) {
          if (e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method)) return s;
          t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return s;
      }

      var r = l(n, e.iterator, t.arg);
      if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, s;
      var o = r.arg;
      return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, s) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, s);
    }

    function y(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function w(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function E(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(y, this), this.reset(!0);
    }

    function k(e) {
      if (e) {
        var t = e[o];
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var r = -1,
              i = function t() {
            for (; ++r < e.length;) {
              if (n.call(e, r)) return t.value = e[r], t.done = !1, t;
            }

            return t.value = void 0, t.done = !0, t;
          };

          return i.next = i;
        }
      }

      return {
        next: S
      };
    }

    function S() {
      return {
        value: void 0,
        done: !0
      };
    }

    return d.prototype = h.constructor = f, f.constructor = d, f[a] = d.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, a in e || (e[a] = "GeneratorFunction")), e.prototype = Object.create(h), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, v(b.prototype), b.prototype[i] = function () {
      return this;
    }, e.AsyncIterator = b, e.async = function (t, n, r, o) {
      var i = new b(c(t, n, r, o));
      return e.isGeneratorFunction(n) ? i : i.next().then(function (e) {
        return e.done ? e.value : i.next();
      });
    }, v(h), h[a] = "Generator", h[o] = function () {
      return this;
    }, h.toString = function () {
      return "[object Generator]";
    }, e.keys = function (e) {
      var t = [];

      for (var n in e) {
        t.push(n);
      }

      return t.reverse(), function n() {
        for (; t.length;) {
          var r = t.pop();
          if (r in e) return n.value = r, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, e.values = k, E.prototype = {
      constructor: E,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(w), !e) for (var t in this) {
          "t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var t = this;

        function r(n, r) {
          return a.type = "throw", a.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
              a = i.completion;
          if ("root" === i.tryLoc) return r("end");

          if (i.tryLoc <= this.prev) {
            var c = n.call(i, "catchLoc"),
                l = n.call(i, "finallyLoc");

            if (c && l) {
              if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return r(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
            } else {
              if (!l) throw new Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return r(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];

          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, s) : this.complete(a);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), s;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), w(n), s;
        }
      },
      catch: function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];

          if (n.tryLoc === e) {
            var r = n.completion;

            if ("throw" === r.type) {
              var o = r.arg;
              w(n);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, t, n) {
        return this.delegate = {
          iterator: k(e),
          resultName: t,
          nextLoc: n
        }, "next" === this.method && (this.arg = void 0), s;
      }
    }, e;
  }(e.exports);

  try {
    regeneratorRuntime = t;
  } catch (e) {
    Function("r", "regeneratorRuntime = r")(t);
  }
});

function c(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function l(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function s(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? l(Object(n), !0).forEach(function (t) {
      c(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function u(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

function d(e, t) {
  if (null == e) return {};

  var n,
      r,
      o = function (e, t) {
    if (null == e) return {};
    var n,
        r,
        o = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
    }

    return o;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
  }

  return o;
}

function f(e) {
  return function (e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = new Array(e.length); t < e.length; t++) {
        n[t] = e[t];
      }

      return n;
    }
  }(e) || function (e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

function p(e, t) {
  if (!e) return !1;
  if (!t || 0 === e.length) return !1;
  var n = e.filter(function (e) {
    return e.questionToShow === t;
  }),
      r = n.some(function (e) {
    return "and" === e.behavior;
  }) ? "and" : "or";
  if (0 === n.length) return !1;

  if ("and" === r) {
    if (n.every(function (e) {
      return !0 === e.canShow;
    })) return !1;
  } else if (n.some(function (e) {
    return !0 === e.canShow;
  })) return !1;

  return !0;
}

function m() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = arguments.length > 1 ? arguments[1] : void 0,
      n = e.conditions || [];
  return !t || 0 === n.length || !p(n, t);
}

function g(e, t) {
  var n = e.question || e.placeholder;

  if (Array.isArray(e.value)) {
    if (e.value[0] && "object" == typeof e.value[0]) {
      if (!m(t, n)) return {
        canSend: !0,
        visible: m(t, n)
      };
      var r = !0;
      return e.value.forEach(function (e) {
        m(t, e.question || e.placeholder) && e.isRequired && !e.value && (r = !1);
      }), {
        value: e.value.filter(function (e) {
          return e.value;
        }).map(function (e) {
          return e.question ? "\n" + e.question + ": " + e.value : e.value;
        }).join(", "),
        canSend: r,
        visible: m(t, n),
        error: e.value.find(function (e) {
          return e.error;
        })
      };
    }

    return e.value = e.value.filter(function (e) {
      return e;
    }), {
      canSend: !m(t, n) || !e.isRequired || e.value.length > 0,
      value: e.value.join(", "),
      visible: m(t, n),
      error: !!e.error
    };
  }

  return {
    canSend: !m(t, n) || !e.isRequired || !!e.value,
    value: e.value,
    visible: m(t, n),
    error: !!e.error
  };
}

var h = function h() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = arguments.length > 1 ? arguments[1] : void 0,
      n = e.pages || [],
      r = {};
  return n.forEach(function (n) {
    (n.blocks || []).forEach(function (n) {
      if ("contact" !== n.type && "matrix" !== n.type) {
        var o = g(n, e).value;
        t && n.files && (o += n.files.map(function (e) {
          return "\n".concat(e.url);
        })), o && (r[n.question || n.placeholder] = o);
      } else {
        (n.value || []).forEach(function (t) {
          var n = g(t, e),
              o = n.value,
              i = n.canSend;
          o && i && (r[t.question || t.placeholder || t.title] = o);
        });
      }
    });
  }), e.extraData && Object.keys(e.extraData).forEach(function (t) {
    r[t] = e.extraData[t];
  }), r;
};

function v() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = e.pages || [],
      n = [];
  return t.forEach(function (e) {
    (e.blocks || []).forEach(function (e) {
      if ("contact" === e.type || "matrix" === e.type) return n.push(e), void (e.value || []).forEach(function (e) {
        n.push(e);
      });
      n.push(e);
    });
  }), n;
}

var b = process.env.REACT_APP_NATIVE_FORMS,
    x = {
  LOCATION_API_URL: "https://pro.ip-api.com/json/?key=kgNLgHSjzWRCLx5",
  NATIVE_FORMS_ADDRESS: "https://nativeforms.com",
  MAX_UPLOAD_FILES_NUMBER: 20
};
"labs" === b && (x.SERVER_URL = "https://us-central1-nativeforms-labs.cloudfunctions.net/backend", x.STORAGE_URL = "https://storage.googleapis.com/nativeforms-labs.appspot.com", x.STORAGE_BUCKET = "nativeforms-labs.appspot.com", x.STRIPE_PUBLIC_KEY = "pk_test_O1481hcamvg6uAOlTbh9vZ6M005tp15O8u"), "production" === b && (x.SERVER_URL = "https://us-central1-nativeforms-prod.cloudfunctions.net/backend", x.STORAGE_URL = "https://storage.googleapis.com/nativeforms-prod.appspot.com", x.STORAGE_BUCKET = "nativeforms-prod.appspot.com", x.STRIPE_PUBLIC_KEY = "pk_live_9DHV2qfrpAgcSHqytMtd7tYo00KZzy04QP"), b || (x.SERVER_URL = "https://us-central1-nativeforms-prod.cloudfunctions.net/backend", x.STORAGE_URL = "https://storage.googleapis.com/nativeforms-prod.appspot.com", x.STORAGE_BUCKET = "nativeforms-prod.appspot.com", x.STRIPE_PUBLIC_KEY = "pk_live_9DHV2qfrpAgcSHqytMtd7tYo00KZzy04QP");

var y = function y(e, t) {
  var n = e.map(function (e) {
    return e.count;
  }).reduce(function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
    return e + t;
  }, 0);
  return e.forEach(function (e) {
    e.count ? e.percent = Number.parseFloat(e.count / n * 100).toFixed(t) : e.percent = 0;
  }), e;
};

function w(e) {
  return Array.isArray(e) ? function (e) {
    for (var t = new Array(e.length), n = 0; n < e.length; n++) {
      t[n] = w(e[n]);
    }

    return t;
  }(e) : "object" == typeof e ? function (e) {
    if (!e) return null;
    var t = {};

    for (var n in e) {
      t[n] = w(e[n]);
    }

    return t;
  }(e) : e;
}

function E(e) {
  if (!e) return 0;
  if (0 === e.length) return 0;
  var t = e[0],
      n = !0;
  return e.forEach(function (e, r) {
    var o = e.count || 0,
        i = t.count || 0;
    o > i && (t = e, n = !0), o === i && 0 !== r && (n = !1);
  }), n ? (t.highest = !0, t.count) : null;
}

function k(e) {
  for (var t = e.length, n = 0; n < t; n++) {
    for (var r = 0; r < t - n - 1; r++) {
      if ((e[r].count || 0) < (e[r + 1].count || 0)) {
        var o = Object.assign(e[r]);
        e[r] = e[r + 1], e[r + 1] = o;
      }
    }
  }

  return e;
}

function S(e) {
  var t, n;
  return a.async(function (r) {
    for (;;) {
      switch (r.prev = r.next) {
        case 0:
          return r.next = 2, a.awrap(fetch(e.customSubmitFormURL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              form: e
            })
          }));

        case 2:
          return t = r.sent, r.next = 5, a.awrap(t.json());

        case 5:
          if (n = r.sent, t.ok) {
            r.next = 8;
            break;
          }

          return r.abrupt("return", e);

        case 8:
          return r.abrupt("return", n);

        case 9:
        case "end":
          return r.stop();
      }
    }
  });
}

var C = function C(e) {
  var t, n, r, o, i, c, l, s, u;
  return a.async(function (d) {
    for (;;) {
      switch (d.prev = d.next) {
        case 0:
          return t = e.parameters, n = void 0 === t ? {} : t, r = e.preview, o = e.search, i = e.queryParams, c = n.l, l = n.f, s = void 0 === l ? "" : l, d.next = 4, a.awrap(fetch(x.SERVER_URL + "/form-inbox/opened", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              license: c,
              slug: o,
              formName: s,
              preview: !!r,
              queryParams: i
            })
          }));

        case 4:
          return u = d.sent, d.abrupt("return", u.json());

        case 6:
        case "end":
          return d.stop();
      }
    }
  });
},
    N = function N(e) {
  var t, n, r;
  return a.async(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          return t = e.license, n = e.formID, o.next = 3, a.awrap(fetch(x.SERVER_URL + "/form-inbox/completed-form", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              license: t,
              formID: n
            })
          }));

        case 3:
          return r = o.sent, o.abrupt("return", r.json());

        case 5:
        case "end":
          return o.stop();
      }
    }
  });
},
    z = function z(e, t) {
  return t ? {
    json: function json() {}
  } : fetch(e.customServerURL || "".concat(x.SERVER_URL, "/form-inbox/completed"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      license: e.license,
      formData: e
    })
  });
},
    T = function T(e) {
  var t, n, r, o, i, c, l;
  return a.async(function (s) {
    for (;;) {
      switch (s.prev = s.next) {
        case 0:
          return t = e.form, n = e.fromDate, r = void 0 === n ? 1 : n, o = e.toDate, i = void 0 === o ? new Date().getTime() : o, c = t.customServerEndpoint || x.SERVER_URL, s.next = 4, a.awrap(fetch(c + "/api/inbox", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              license: t.license,
              form: t,
              fromDate: r,
              toDate: i
            })
          }));

        case 4:
          if (!(l = s.sent).ok) {
            s.next = 7;
            break;
          }

          return s.abrupt("return", l.json());

        case 7:
          return s.abrupt("return", null);

        case 8:
        case "end":
          return s.stop();
      }
    }
  });
},
    O = function O(e) {
  var t, n, r, o, i;
  return a.async(function (c) {
    for (;;) {
      switch (c.prev = c.next) {
        case 0:
          return t = e.poll.includeAllQuestions, n = {
            summary: [],
            total: 0
          }, c.next = 4, a.awrap(T({
            form: e
          }));

        case 4:
          if (r = c.sent) {
            c.next = 7;
            break;
          }

          return c.abrupt("return", n);

        case 7:
          return o = [], i = [], v(e).forEach(function (e) {
            if (e.question && "contact" !== e.type && "files" !== e.type && "image" !== e.type && "video" !== e.type && "stripe" !== e.type && "description" !== e.type && (t || "selection" === e.type)) if (e.select) {
              var n = e.select.map(function (e) {
                return {
                  name: e
                };
              });
              i.push({
                question: e.question,
                answers: n,
                type: e.type || "selection"
              });
            } else if (e.answers) i.push({
              question: e.question,
              multipleValues: e.multiSelect,
              answers: e.answers.map(function (e) {
                return {
                  name: e.value
                };
              }),
              type: e.type || "selection"
            });else if ("number-scale" !== e.type) "stars" !== e.type ? i.push({
              question: e.question,
              answers: [],
              type: e.type || "contact"
            }) : i.push({
              question: e.question,
              answers: [{
                name: "5 stars"
              }, {
                name: "4 stars"
              }, {
                name: "3 stars"
              }, {
                name: "2 stars"
              }, {
                name: "1 star"
              }],
              type: e.type
            });else {
              var r = (e.scale ? f(e.scale) : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]).map(function (e) {
                return {
                  name: e
                };
              }).reverse();
              i.push({
                question: e.question,
                type: e.type,
                answers: r
              });
            }
          }), r.forEach(function (e) {
            var t = h(e);
            Object.keys(t).forEach(function (e) {
              var n = i.find(function (t) {
                return t.question === e;
              });

              if (n) {
                (n.multipleValues ? t[e].split(", ") : [t[e].toString()]).forEach(function (e) {
                  var t;
                  "stars" === n.type && (e = "😠" === (t = e) ? "1 star" : "🙁" === t ? "2 stars" : "😐" === t ? "3 stars" : "😃" === t ? "4 stars" : "😍" === t ? "5 stars" : t);
                  var r = n.answers.find(function (t) {
                    return t.name.toString() === e.toString();
                  });
                  r ? r.count ? r.count += 1 : r.count = 1 : n.answers.push({
                    name: e,
                    count: 1
                  });
                });
              }
            }), o.push(e);
          }), i.forEach(function (e) {
            var t = e.answers,
                n = e.type;
            "selection" === n && "stars" === n && "number-scale" === n || (e.answers = k(t).slice(0, 10)), y(t, 2);
            var r = E(t);
            r && (e.highestValue = r);
          }), n.summary = w(i), n.total = r.length, c.abrupt("return", n);

        case 16:
        case "end":
          return c.stop();
      }
    }
  });
},
    P = function P(e) {
  var t = e.size,
      r = e.color;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: t || 22,
    height: t || 22,
    fill: r || "inherit",
    viewBox: "0 0 24 24"
  }, n.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), n.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
},
    _ = function _(e) {
  var t = e.size,
      r = e.color;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: t || 16,
    height: t || 16,
    fill: r || "inherit",
    viewBox: "0 0 24 24"
  }, n.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), n.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
  }));
},
    j = function j(e) {
  var t = e.size,
      r = e.selected;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: t || 16,
    height: t || 16,
    fill: r ? "#f6b745" : "#eeeeee"
  }, n.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), n.createElement("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
  }), n.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
},
    q = function q(e) {
  var t = e.size,
      r = e.color;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: t || 26,
    height: t || 26,
    fill: r || "inherit",
    viewBox: "0 0 24 24"
  }, n.createElement("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
  }), n.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
},
    M = function M() {
  return n.createElement("svg", {
    viewBox: "0 0 18 18",
    width: "18",
    fill: "#ffffff",
    height: "18",
    xmlns: "http://www.w3.org/2000/svg"
  }, n.createElement("path", {
    d: "m8.6 1.3-8.4 15a.5.5 0 0 0 .4.7h16.8a.5.5 0 0 0 .5-.5.5.5 0 0 0-.1-.2l-8.4-15a.5.5 0 0 0-.8 0ZM10 14.7a.3.3 0 0 1-.3.3H8.3a.3.3 0 0 1-.3-.3v-1.4a.3.3 0 0 1 .3-.3h1.4a.3.3 0 0 1 .3.3Zm0-3a.3.3 0 0 1-.3.3H8.3a.3.3 0 0 1-.3-.3v-6a.3.3 0 0 1 .3-.2h1.4a.3.3 0 0 1 .3.3Z"
  }));
},
    I = function I() {
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    viewBox: "0 0 212 212"
  }, n.createElement("path", {
    d: "M92 1a106 106 0 0 1 113 67 105 105 0 0 1 0 76 106 106 0 0 1-52 56 104 104 0 0 1-58 11 105 105 0 0 1-69-36 107 107 0 0 1-26-73 106 106 0 0 1 26-66A107 107 0 0 1 92 1m4 9a98 98 0 0 0-46 17 96 96 0 0 0-13 146 96 96 0 0 0 58 29 169 169 0 0 0 23 0 97 97 0 0 0 81-72c4-11 3-23 3-35a97 97 0 0 0-20-48c-8-10-17-19-28-25a97 97 0 0 0-58-12z",
    fill: "#f3617a"
  }), n.createElement("path", {
    d: "M101 44h9v100h-9V44zM101 154h9v13h-9v-13z",
    fill: "#EA1034"
  }));
},
    L = function L() {
  return n.createElement("svg", {
    width: "80",
    height: "80",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }, n.createElement("path", {
    fill: "#b9d3b0",
    d: "M59.45 3.6a59.83 59.83 0 0145 15.08 60.03 60.03 0 0119.57 37.33 59.16 59.16 0 01-10.87 42.12 59.67 59.67 0 01-38.12 23.77 59.81 59.81 0 01-43.01-8.92A59.81 59.81 0 018.03 81.62a59.89 59.89 0 014.71-47.82C22.12 16.88 40.15 5.16 59.45 3.6m-3.26 5.58a54.31 54.31 0 00-33.93 20.15 54.12 54.12 0 00-10.18 45.44 54.31 54.31 0 0064.09 41.21 54.25 54.25 0 0035.49-25.27 54.31 54.31 0 00-17-73.45 54.55 54.55 0 00-38.47-8.08z"
  }), n.createElement("path", {
    fill: "#76a964",
    d: "M86.49 48.49c3.05-3.12 6.12-6.23 9.44-9.08 1.85.55 3.72 1.68 4.18 3.7.24 1.64-1.15 2.83-2.14 3.92-13.68 13.6-27.27 27.29-40.95 40.9a8.4 8.4 0 01-4.4-2.54c-5.99-6.05-12.07-12.02-18.03-18.09-3.27-2.42 1.42-8.29 4.3-5.15 5.96 5.46 11.27 11.6 17.4 16.88 9.72-10.51 20.17-20.33 30.2-30.54z"
  }));
},
    R = function R() {
  return n.createElement("svg", {
    width: "18",
    height: "36",
    viewBox: "0 0 102 207",
    xmlns: "http://www.w3.org/2000/svg"
  }, n.createElement("g", {
    fill: "#444"
  }, n.createElement("path", {
    d: "M41.81 77.81c3.03-4.59 5.51-9.56 9.06-13.79 3.93 5.25 7.03 11.05 10.6 16.54 3.29 5.52 7.2 10.68 9.96 16.51-13.81.38-27.64.33-41.44.03 3.58-6.65 7.91-12.84 11.82-19.29zM29.9 110.09c13.98-.17 27.96-.15 41.94 0-6.94 9.77-13.68 19.71-20.97 29.22-3.39-3.75-6.11-8.02-9.03-12.13-3.94-5.73-8.22-11.21-11.94-17.09z"
  })));
},
    D = function D(e) {
  var t = e.size,
      r = void 0 === t ? 24 : t,
      o = e.fill,
      i = void 0 === o ? "inherit" : o;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    fill: i,
    viewBox: "0 0 24 24"
  }, n.createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  }), n.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
},
    A = function A(e) {
  var t = e.size,
      r = void 0 === t ? 24 : t,
      o = e.fill,
      i = void 0 === o ? "inherit" : o;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    fill: i,
    viewBox: "0 0 24 24"
  }, n.createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  }), n.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
},
    F = function F(e) {
  var t = e.size,
      r = void 0 === t ? 18 : t,
      o = e.fill,
      i = void 0 === o ? "inherit" : o;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    fill: i,
    viewBox: "0 0 24 24"
  }, n.createElement("path", {
    d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
  }), n.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
},
    B = function B(e) {
  var t = e.width,
      r = e.height,
      o = e.fill;
  return n.createElement("svg", {
    width: t,
    height: r,
    fill: o,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, n.createElement("path", {
    d: "M15.7 15.7A46.6 46.6 0 0147 4h162a46.6 46.6 0 0147 45.6v118a46.8 46.8 0 01-47.2 45.8c-.6 10.8 0 21.7-.2 32.5-1 7.1-10.8 10.7-16 5.6-9.5-8.9-18.8-18-28-27-5.8-6.2-14.1-10-22.6-9.9H51A47.1 47.1 0 010 171V49.5c.3-12.8 6-25.3 15.7-33.8m62.6 58.8C71.9 76 68 84 71 89.9c1.6 4.4 6.3 7 11 7.1h92c4.7 0 9.4-2.6 11-7.1 3.5-7-2.4-15.9-10-15.9H85c-2.2 0-4.6-.3-6.7.5m-.8 46.6a14.3 14.3 0 00-7.4 8.5v4.8c1.2 3.7 3.8 6.9 7.5 8.5 5.8.6 11.6.5 17.4.4 16.2-.2 32.3.5 48.5-.4 4-2 7.8-6 7.6-10.8.3-5-3.5-9-7.6-11-9.8-.8-19.6-.3-29.4-.4-12.2.1-24.4-.5-36.6.4z"
  }));
},
    V = function V(e) {
  var t = e.size,
      r = void 0 === t ? 24 : t,
      o = e.fill,
      i = void 0 === o ? "inherit" : o;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: r,
    height: r,
    fill: i
  }, n.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), n.createElement("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
  }));
},
    W = function W() {
  return n.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, n.createElement("path", {
    d: "M55.6 99.6c10.9-12.2 23-23.3 34.3-35 .3 17.1 0 34.3.1 51.4h75c0-17.2-.2-34.3.1-51.4 20.8 21.3 42.3 42 63.3 63.1-21.1 21-42.6 41.4-63.3 62.7-.3-16.8 0-33.6-.1-50.4H90c0 16.8.2 33.6-.1 50.4-5.3-5.2-10.2-10.7-16-15.4l-47-47.2c9.8-9 19-18.9 28.7-28.2z"
  }));
},
    H = function H(e) {
  var t = e.size,
      r = void 0 === t ? 24 : t,
      o = e.fill,
      i = void 0 === o ? "inherit" : o;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    fill: i,
    viewBox: "0 0 512 512"
  }, n.createElement("path", {
    d: "M290.4 13.2l-11.5 219 204.7-78.6A219.2 219.3 0 00290.4 13.2zM239 60.8A219.2 219.3 0 0038.6 206.2a219.2 219.3 0 0077.3 251 219.2 219.3 0 00262.5-3.1 219.2 219.3 0 0071.3-252.7L245.1 280l12.2-219a219.2 219.3 0 00-18.3-.2z"
  }));
},
    U = function U(e) {
  var t = e.size,
      r = void 0 === t ? 24 : t,
      o = e.fill,
      i = void 0 === o ? "inherit" : o;
  return n.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    fill: i,
    viewBox: "0 0 24 24"
  }, n.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), n.createElement("path", {
    d: "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
  }));
},
    J = function J(e) {
  var t = e.size,
      r = void 0 === t ? 22 : t;
  return n.createElement("svg", {
    width: r,
    height: r,
    fill: "#8A96A3",
    viewBox: "1 1 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, n.createElement("path", {
    d: "M8 4a2 2 0 0 0-2 2v.5a2 2 0 1 0 4 0V6a2 2 0 0 0-2-2z"
  }), n.createElement("path", {
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm-2.9-4.1-1 1A5.5 5.5 0 0 1 8 2.5a5.5 5.5 0 0 1 3.9 9.4l-1-1a3 3 0 0 0-2.1-.9H7.2a3 3 0 0 0-2 .9z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }));
};

function G(e) {
  var t = e.error,
      r = e.form,
      o = (void 0 === r ? {} : r) || {},
      i = o.customErrorTitle,
      a = void 0 === i ? "Ooops" : i,
      c = o.customErrorDescription,
      l = void 0 === c ? t : c;
  return n.createElement("div", {
    className: "nf-error-container"
  }, n.createElement(I, null), n.createElement("span", {
    className: "nf-error-header"
  }, a), n.createElement("span", {
    className: "nf-error-description"
  }, l));
}

function Y() {
  return n.createElement("div", {
    className: "nf-loading-container"
  }, n.createElement("div", {
    className: "nf-spinner-primary"
  }));
}

function X() {
  if (!window || !window.location) return !1;
  if (!window) return !1;

  try {
    return window.self !== window.top;
  } catch (e) {
    return !0;
  }
}

var $ = function $(e, t) {
  if (!e.isReactNative && document) {
    var n = document.getElementById("nf-form-container");
    if (e.isNativeSlides && (n = document.getElementsByClassName("ns-root")[0]), n) if ("form_loaded" !== t && "form_font_loaded" !== t) {
      var r = n.getBoundingClientRect();
      setTimeout(function () {
        var t = n.getBoundingClientRect();

        if (r.width !== t.width || r.height !== t.height) {
          var o = JSON.stringify({
            nf_event: {
              event: "form_dimension_change",
              dimensions: JSON.stringify(n.getBoundingClientRect()),
              form: JSON.stringify(e)
            }
          });
          Z(o);
        }
      });
    } else {
      var o = JSON.stringify({
        nf_event: {
          event: "form_dimension_change",
          dimensions: JSON.stringify(n.getBoundingClientRect()),
          form: JSON.stringify(e)
        }
      });
      Z(o);
    }
  }
},
    Q = function Q(e) {
  var t = JSON.stringify({
    nf_event: {
      event: "form_fetch_error",
      form: JSON.stringify(e)
    }
  });
  Z(t);
},
    K = function K(e, t) {
  var n = JSON.stringify({
    nf_event: {
      event: "form_send",
      form: JSON.stringify(e),
      json: JSON.stringify(t)
    }
  });
  Z(n);
},
    Z = function Z(e) {
  try {
    window.ReactNativeWebView && window.ReactNativeWebView.postMessage(e), window.postMessage && window.postMessage(e, "*"), X() && (window.parent && window.parent.postMessage(e, "*"), window.opener && window.opener.postMessage(e, "*"));
  } catch (e) {}
},
    ee = {
  main: "#2200FF",
  error: "#EA1034",
  success: "#0F9D58",
  required: "#EA1034",
  add: "#007A5A",
  dropZone: "#b2eecb",
  border: "#ced6dd",
  white: "#ffffff",
  black: "#000000",
  darkgrey: "#424d57",
  grey: "#647384",
  lightgrey: "#9da6b2",
  placeholder: "#757575",
  toastError: "#C9242D",
  toastSuccess: "#1bb257",
  toastWarning: "#efa842",
  toastInfo: "#5ca8f5",
  primary: "#000000",
  disabled: "#E3E4E5",
  overlay: "rgba(0, 0, 0, 0.5)",
  highest: "#0D66D0",
  blue: "#0099FF"
},
    te = function te(e) {
  window.gtag && window.gtag("event", "".concat(e.label, " - Form Opened"), {
    event_category: e.label || "",
    event_label: e.formName || ""
  });
},
    ne = function ne(e) {
  window.gtag && window.gtag("event", "".concat(e.label, " - Form Completed"), {
    event_category: e.label || "",
    event_label: e.formName || ""
  });
},
    re = {
  email: {
    label: "Email"
  },
  name: {
    label: "Name"
  },
  phone: {
    label: "Phone"
  },
  avatar: {
    label: "Avatar"
  },
  address: {
    label: "Address"
  },
  city: {
    label: "City"
  },
  state: {
    label: "State"
  },
  zip: {
    label: "Zip"
  },
  country: {
    label: "Country"
  },
  company: {
    label: "Company"
  },
  title: {
    label: "Title"
  },
  countryCode: {
    label: "Country Code"
  }
},
    oe = ["preview", "template", "complete", "error"],
    ie = "Form does not exist or the link is broken",
    ae = ["https://storage.googleapis.com/nativeforms-prod.appspot.com/ratings/rating1.png", "https://storage.googleapis.com/nativeforms-prod.appspot.com/ratings/rating2.png", "https://storage.googleapis.com/nativeforms-prod.appspot.com/ratings/rating3.png", "https://storage.googleapis.com/nativeforms-prod.appspot.com/ratings/rating4.png", "https://storage.googleapis.com/nativeforms-prod.appspot.com/ratings/rating5.png"],
    ce = ["Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "AndorrA", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, The Democratic Republic of the", "Cook Islands", "Costa Rica", "Cote D'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and Mcdonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic Of", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People'S Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan", "Lao People'S Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia, The Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "RWANDA", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province of China", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Viet Nam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"],
    le = function le(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = new Date(e),
      r = n.getDate(),
      o = ue(n.getMonth());
  t.customMonths && t.customMonths[n.getMonth()] && (o = t.customMonths[n.getMonth()]);
  var i = n.getFullYear();
  return r + " " + o + " " + i;
},
    se = function se(e, t) {
  return Array.isArray(e) ? e.map(function (e) {
    return le(e, t);
  }).join(", ") : le(e, t);
};

function ue(e) {
  return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][e];
}

function de() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
  return e && e.split(",")[1] ? e.split(",")[1].substring(7) : /\((.*)\)/.exec(new Date().toString())[1];
}

function fe(e) {
  var t = e;

  try {
    t = decodeURIComponent(e);
  } catch (e) {}

  return t;
}

function pe(e) {
  return e.match(/^\d+$/);
}

var me = ["$"];

function ge(e) {
  var t = e.min,
      n = e.max,
      r = e.percentage,
      o = void 0 === r ? 0 : r,
      i = e.percentage2,
      a = void 0 === i ? 0 : i,
      c = e.rangeSelect,
      l = e.leftSide,
      s = e.parseToLocal;
  if (!n || !t) return c ? "".concat(a, "% - ").concat(o, "%") : "".concat(o, "%");
  var u = t.toString(),
      d = n.toString();

  if (pe(u) && pe(d)) {
    var f = parseInt(u, 10),
        p = parseInt(d, 10),
        m = Math.round(f + o / 100 * (p - f)),
        g = Math.round(f + a / 100 * (p - f));
    return c ? "".concat(g.toString(), " - ").concat(m.toString()) : m.toString();
  }

  var h = !!u.match(/\d/g) && u.match(/\d/g).length > 0,
      v = !!d.match(/\d/g) && d.match(/\d/g).length > 0;

  if (h && v) {
    var b = t.split("").filter(function (e) {
      return !pe(e);
    }).join("");
    b.includes(",") && (b = b.replace(/,/g, "")), b.includes(".") && (b = b.replace(/\./g, ""));
    var x = parseInt(u.match(/\d/g).join(""), 10),
        y = parseInt(d.match(/\d/g).join(""), 10),
        w = Math.round(x + o / 100 * (y - x)),
        E = Math.round(x + a / 100 * (y - x));
    return (u.includes(",") || d.includes(",")) && (s = !0), s && (w = w.toLocaleString(), E = E.toLocaleString()), me.includes(b) || l ? c ? "".concat(b).concat(E, " - ").concat(b).concat(w) : "".concat(b).concat(w) : c ? "".concat(E).concat(b, " - ").concat(w).concat(b) : "".concat(w).concat(b);
  }

  return c ? "".concat(a, "% - ").concat(o, "%") : "".concat(o, "%");
}

var he = function he() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
  return fe(e.toLowerCase());
};

function ve(e) {
  if (!e) return {};
  var t = e.split("?")[1];
  if (!t) return {};
  var n = t.split("&"),
      r = {};
  return n.forEach(function (e) {
    e = e.split("="), r[e[0]] = fe(e[1] || "");
  }), JSON.parse(JSON.stringify(r));
}

var be = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    xe = function xe(e) {
  var t,
      n,
      r,
      o,
      i,
      a = "",
      c = "",
      l = "",
      s = 0;

  do {
    r = (t = e.charCodeAt(s++)) >> 2, o = (3 & t) << 4 | (n = e.charCodeAt(s++)) >> 4, i = (15 & n) << 2 | (c = e.charCodeAt(s++)) >> 6, l = 63 & c, isNaN(n) ? i = l = 64 : isNaN(c) && (l = 64), a = a + be.charAt(r) + be.charAt(o) + be.charAt(i) + be.charAt(l), t = n = c = "", r = o = i = l = "";
  } while (s < e.length);

  return a;
},
    ye = function ye(e) {
  var t,
      n,
      r,
      o,
      i = "",
      a = "",
      c = "",
      l = 0;
  e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");

  do {
    t = be.indexOf(e.charAt(l++)) << 2 | (r = be.indexOf(e.charAt(l++))) >> 4, n = (15 & r) << 4 | (o = be.indexOf(e.charAt(l++))) >> 2, a = (3 & o) << 6 | (c = be.indexOf(e.charAt(l++))), i += String.fromCharCode(t), 64 != o && (i += String.fromCharCode(n)), 64 != c && (i += String.fromCharCode(a)), t = n = a = "", r = o = c = "";
  } while (l < e.length);

  return i;
};

function we(e) {
  var t,
      n,
      r,
      o = ye(Ee(e));
  return t = o.replace(/\0/g, ""), n = t.split("&"), r = {}, n.forEach(function (e) {
    e = e.split("="), r[e[0]] = fe(e[1] || "");
  }), JSON.parse(JSON.stringify(r));
}

function Ee(e) {
  return e.split("").reverse().join("");
}

function ke() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
      t = arguments.length > 1 ? arguments[1] : void 0;
  if (!e) return {};
  var n = e.split("/")[3];

  if (t) {
    var r = we(n);
    return {
      parameters: r,
      search: t
    };
  }

  if (n || (n = e.split("/")[1]), !n) return {};
  -1 !== n.indexOf("?") && (n = n.substring(0, n.indexOf("?"))), -1 !== n.indexOf("#") && (n = n.substring(0, n.indexOf("#")));
  var o = we(n);
  return {
    parameters: o,
    search: n
  };
}

var Se = function Se() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
      t = e.toLowerCase();
  return "name" === t || "your name" === t || "first name" === t || "full name" === t ? "name" : t.includes("email") || t.includes("mail") ? "email" : t.includes("phone") ? "tel" : t.includes("address") ? "address" : t.includes("city") ? "city" : t.includes("state") ? "state" : t.includes("zip") ? "zip" : t.includes("country") ? "country" : void 0;
};

function Ce(e) {
  var t = e.title,
      r = e.form,
      o = e.onClose,
      i = e.borderRadius,
      a = void 0 === i ? 0 : i,
      c = r || {},
      l = c.headerBackgroundColor,
      s = void 0 === l ? ee.white : l,
      u = c.headerTextColor,
      d = void 0 === u ? ee.primary : u,
      f = c.headerTitle || t || "",
      p = {
    backgroundColor: s,
    borderBottomColor: ee.border,
    borderTopLeftRadius: a,
    borderTopRightRadius: a
  },
      m = {
    color: d
  };
  return n.createElement("div", {
    className: "nf-header-container",
    style: p
  }, n.createElement("span", {
    className: "nf-header",
    style: m
  }, f), n.createElement("div", {
    className: "nf-header-close",
    onClick: o
  }, n.createElement(P, {
    color: d,
    size: 20
  })));
}

var Ne = function Ne(e, t) {
  return function (n) {
    return n.replace(e, t);
  };
},
    ze = Ne(/\[([^\[]+)\]\(([^\)]+)\)/g, function (e, t, n) {
  return '<a style="cursor: pointer; color: #2200ff; text-decoration: none; font-weight: 500;" target="_blank" rel="noopener noreferrer" href="' + n + '">' + t + "</a>";
}),
    Te = Ne(/\n(#+\s*)(.*)/g, function (e, t, n) {
  return "\n<h" + t.trim().length + ' style="padding: 0; margin: 8px 0;">' + n + "</h" + t.trim().length + ">";
}),
    Oe = Ne(/(\*{1,2})(.*?)\1/g, function (e, t, n) {
  return "<" + (1 === t.trim().length ? "em" : "strong") + ">" + n + "</" + (1 === t.trim().length ? "em" : "strong") + ">";
}),
    Pe = function Pe(e) {
  return e ? function (e) {
    return Oe(Te(ze(e)));
  }(e) : "";
};

function _e(e) {
  var t,
      r,
      o = e.form,
      i = e.status,
      a = e.style,
      c = o || {},
      l = c.textColor,
      u = void 0 === l ? ee.primary : l,
      d = c.backgroundColor,
      f = void 0 === d ? ee.white : d,
      p = c.submitScreenAction,
      m = o.type,
      g = o.complete || {};

  switch (i) {
    case "preview":
    case "template":
    case "complete":
      t = g.title, r = g.description;
      break;

    case "error":
      m = "error", t = "Ooops", r = "Something went wrong.";
  }

  var h = s({
    paddingTop: 80,
    paddingBottom: 80,
    paddingLeft: 20,
    paddingRight: 20
  }, a);
  return n.createElement("div", {
    className: "nf-status-container",
    style: {
      backgroundColor: f
    }
  }, n.createElement("div", {
    className: "nf-status-wrapper",
    style: h
  }, n.createElement("div", {
    className: "nf-status-icon-wrapper"
  }, "error" !== m ? n.createElement(L, null) : n.createElement(I, null)), n.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: Pe(t)
    },
    className: "nf-status-header",
    style: {
      color: u
    }
  }), n.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: Pe(r)
    },
    className: "nf-status-description",
    style: {
      color: u
    }
  }), p && n.createElement("a", {
    href: p.url,
    className: "nf-submit-screen-action"
  }, p.label, " ", p.label && n.createElement(A, {
    size: 20,
    fill: ee.main
  }))));
}

function je(e) {
  var t = e.form,
      r = t || {},
      o = r.backgroundColor,
      i = void 0 === o ? ee.white : o,
      a = r.theme,
      c = t.poweredBy || {},
      l = t.source || "unknown",
      s = c.color || ("dark" === a ? ee.white : ee.main),
      u = c.link || "".concat(x.NATIVE_FORMS_ADDRESS, "?utm_source=powered_by&utm_medium=").concat(l).concat(t.license ? "&utm_campaign=".concat(t.license) : "");
  return n.createElement("div", {
    className: "nf-powered-by-container",
    style: {
      backgroundColor: i
    }
  }, n.createElement("a", {
    tabIndex: "-1",
    href: u,
    rel: "noopener noreferrer",
    className: "nf-link",
    target: "_blank",
    style: {
      textDecoration: "none",
      fontSize: 10,
      color: "dark" === a ? ee.white : ee.primary
    }
  }, n.createElement("span", {
    style: {
      fontSize: 10,
      color: "dark" === a ? ee.white : ee.primary,
      fontWeight: 400
    }
  }, "Powered by", " ", c.company ? n.createElement("strong", {
    style: {
      color: s
    }
  }, c.company) : n.createElement(n.Fragment, null, n.createElement("strong", {
    style: {
      color: s
    }
  }, "NativeForms")))));
}

var qe = function qe(e) {
  var t = e.href,
      r = e.label,
      o = e.style;
  return n.createElement("a", {
    className: "nf-link",
    onClick: function onClick(e) {
      t && e.stopPropagation();
    },
    style: o,
    href: t,
    rel: "noopener noreferrer",
    target: "_blank"
  }, r);
};

function Me(e) {
  var r = e.form,
      o = e.isPreview,
      i = r || {},
      a = i.color,
      c = void 0 === a ? ee.main : a,
      l = i.textColor,
      s = void 0 === l ? ee.primary : l,
      d = i.backgroundColor,
      f = void 0 === d ? ee.white : d,
      p = i.legal,
      m = i.theme,
      g = p || {},
      h = g.terms,
      v = g.policy,
      b = g.customLegal,
      x = g.error,
      y = u(t.useState(!!p.acceptedAt), 2),
      w = y[0],
      E = y[1],
      k = {
    backgroundColor: w ? c : f,
    borderColor: x ? ee.error : w ? "transparent" : "dark" === m ? ee.white : ee.lightgrey,
    borderWidth: 1,
    borderStyle: "solid"
  },
      S = {
    fontSize: 14,
    lineHeight: "22px",
    color: s
  },
      C = {
    fontSize: 14,
    fontWeight: "500",
    lineHeight: "22px",
    color: c
  };
  return n.createElement("div", {
    className: "nf-policy-wrapper",
    id: "nf-policy-terms"
  }, n.createElement("div", {
    onClick: function onClick() {
      o || (p.acceptedAt ? (delete p.acceptedAt, delete p.acceptedTimestamp, r.extraData = r.extraData || {}, delete r.extraData["Terms and Policy accepted at"], E(!1)) : (p.acceptedAt = new Date().toString(), p.acceptedTimestamp = new Date().getTime(), r.extraData = r.extraData || {}, r.extraData["Terms and Policy accepted at"] = p.acceptedAt, delete r.legal.error, E(!0)));
    },
    className: "nf-policy-container"
  }, n.createElement("div", {
    className: "nf-policy-checkbox",
    style: k
  }, w && n.createElement(_, {
    size: 14,
    color: ee.white
  })), n.createElement("div", {
    className: "nf-policy-text"
  }, b ? n.createElement("span", {
    style: S,
    dangerouslySetInnerHTML: {
      __html: Pe(b)
    }
  }) : n.createElement(n.Fragment, null, n.createElement("span", {
    style: S
  }, "By completing this form you agree to our", " "), n.createElement(qe, {
    href: h,
    style: C,
    label: "Terms & Conditions"
  }), n.createElement("span", {
    style: S
  }, " and "), n.createElement(qe, {
    href: v,
    style: C,
    label: "Privacy Policy."
  })))), x && n.createElement("span", {
    className: "nf-policy-terms-error"
  }, r.legal.customError || "Accepting our terms and policy is required."));
}

var Ie = ".nf-policy-wrapper{display:flex;flex-direction:column;width:100%;max-width:600px;box-sizing:border-box;padding:4px 28px 20px 28px}.nf-policy-container{width:100%;display:flex;flex-direction:row;align-self:flex-start;align-items:center;cursor:pointer;transition:opacity .2s ease-out}.nf-policy-container:active{opacity:.7}.nf-policy-checkbox{display:flex;flex-shrink: 0;flex-direction:column;align-items:center;justify-content:center;width:18px;height:18px;border-radius:2px;}.nf-policy-text{flex-direction:row;flex-wrap:wrap;align-items:flex-start;justify-content:flex-start;max-width:84%;margin: 0 16px}.nf-policy-terms-error{font-size:13px;line-height:1.4;color:".concat(ee.error, ";box-sizing:border-box;padding: 10px 0 0 0}");

function Le(e) {
  var t = e.children,
      r = e.id;
  return n.createElement("div", {
    className: "nf-question".concat(r ? " question-".concat(r) : "")
  }, t);
}

function Re(e, t, n) {
  if (!e) return !0;
  var r,
      o = e.blocks || [],
      i = !0,
      a = !1,
      c = !1;
  return o.forEach(function (e) {
    n && function (e, t) {
      "contact" !== e.type ? "matrix" !== e.type ? "open" !== e.type ? !!e.isRequired && !!m(t, e.question || e.placeholder) && !e.value && (e.error = e.error || e.requiredError || t.requiredError || "This question is required.") : !!e.isRequired && !!m(t, e.question || e.placeholder) && !e.value && (e.error = e.error || e.requiredError || t.requiredError || "This field is required.") : (e.value || []).forEach(function (e) {
        !!e.isRequired && !!m(t, e.question || e.placeholder) && !e.value && (e.error = e.requiredError || t.requiredError || "This row is required.");
      }) : (e.value || []).forEach(function (e) {
        !!e.isRequired && !!m(t, e.question || e.placeholder) && !e.value && (e.error = e.requiredError || t.requiredError || "This field is required.");
      });
    }(e, t);
    var o = g(e, t),
        l = o.canSend,
        s = o.value,
        u = o.error;
    u && (r || (r = u.id ? u.id : e.id), c = !0), !a && s && (a = !0), l || (i = !1);
  }), {
    isCompleted: i,
    hasValues: a,
    hasError: c,
    firstErrorQuestionID: r
  };
}

function De(e) {
  var t = e.progress,
      r = e.max,
      o = e.color,
      i = e.textColor,
      a = e.showFormProgressCount,
      c = Math.round(t / r * 100),
      l = {
    backgroundColor: "".concat(o, "22")
  },
      s = {
    backgroundColor: o,
    width: "".concat(c, "%")
  };
  return n.createElement("div", {
    className: "nf-progress-container"
  }, n.createElement("span", {
    className: "nf-progress-text",
    style: {
      color: i
    }
  }, a ? "".concat(t, " / ").concat(r) : "".concat(c || 0, "%")), n.createElement("div", {
    className: "nf-progress-line-container",
    style: l
  }, n.createElement("div", {
    className: "nf-progress-line",
    style: s
  })));
}

function Ae(e, t, n) {
  var r = e.pagesStack || e.pages || [],
      o = e.countOnlyMandatory,
      i = [];
  return r.forEach(function (r) {
    "number" == typeof r && (r = e.pages[r]), r.blocks && r.blocks.forEach(function (r) {
      if (!t || "image" !== r.type && "description" !== r.type && "video" !== r.type) if ("contact" === r.type || !n && "matrix" === r.type) (r.value || []).forEach(function (t) {
        if (m(e, r.question || r.placeholder) && m(e, t.question || t.placeholder)) {
          if (!t.isRequired && o) return;
          i.push(t);
        }
      });else if (m(e, r.question || r.placeholder)) {
        if (!r.isRequired && o) return;
        i.push(r);
      }
    });
  }), i;
}

function Fe(e) {
  var r = e.form,
      o = e.changePageIndex,
      i = e.currentPage,
      a = e.isSending,
      c = e.uploadingProgress,
      l = e.isLastPage,
      s = r.color,
      u = void 0 === s ? ee.main : s,
      d = r.backgroundColor,
      f = void 0 === d ? ee.white : d,
      p = r.textColor,
      m = void 0 === p ? ee.primary : p,
      h = r.submitTextColor,
      v = void 0 === h ? ee.white : h,
      b = r.showFormProgressCount,
      x = r.poweredBy,
      y = r.leftArrowText,
      w = r.rightArrowText,
      E = r.rightArrowSendText,
      k = window.innerWidth <= 600,
      S = "quiz" === a,
      C = 0 === i;
  r.pagesStack && (C = r.pagesStack[0] === i);

  var N = function N(e) {
    if (r.pagesStack) {
      var t = r.pagesStack.indexOf(i);

      if ("back" === e) {
        var n = r.pagesStack[t - 1];
        o(n, "back");
      }

      if ("forward" === e) {
        var a = r.pagesStack[t + 1];
        o(a, a ? "forward" : "send");
      }
    } else "back" === e && o(i - 1), "forward" === e && o(i + 1);
  };

  t.useEffect(function () {
    var e = function e(_e2) {
      var t = _e2.target.nodeName.toLowerCase();

      return "input" === t || "textarea" === t || "select" === t || (37 === _e2.keyCode ? N("back") : 39 === _e2.keyCode && (l || N("forward"))), !0;
    };

    return document.addEventListener("keyup", e, !0), function () {
      document.removeEventListener("keyup", e, !0);
    };
  }, [o, l]);

  var z = Ae(r, !0).length,
      T = function (e) {
    var t = 0,
        n = e.countOnlyMandatory;
    return (e.pagesStack || e.pages || []).forEach(function (r) {
      "number" == typeof r && (r = e.pages[r]), (r.blocks || []).forEach(function (e) {
        if ("contact" !== e.type && "matrix" !== e.type) {
          var r = g(e),
              o = r.value,
              i = r.canSend;

          if (o && i) {
            if (!e.isRequired && n) return;
            t++;
          }
        } else {
          (e.value || []).forEach(function (e) {
            var r = g(e),
                o = r.value,
                i = r.canSend;

            if (o && i) {
              if (!e.isRequired && n) return;
              t++;
            }
          });
        }
      });
    }), t;
  }(r),
      O = Re(r.pages[i], r),
      P = O.isCompleted,
      _ = O.hasError,
      j = P && !_,
      q = {
    opacity: a ? .8 : 1,
    border: "1px solid ".concat(ee.border),
    backgroundColor: f,
    fill: 0 === i ? ee.disabled : m
  },
      M = {
    opacity: a ? .8 : 1,
    border: "1px solid ".concat(l && j ? u : ee.border),
    backgroundColor: j && l ? u : f,
    fill: j ? l ? v : m : ee.disabled
  };

  return S && (q.opacity = 1, M.opacity = 1, M.border = "1px solid ".concat(ee.border), M.fill = l ? ee.disabled : m, M.backgroundColor = f, l && (M.display = "none")), n.createElement("div", {
    className: "nf-page-controller",
    style: {
      paddingBottom: "hide" === x ? 24 : 16
    }
  }, !C && n.createElement("button", {
    key: "back",
    type: "button",
    onClick: function onClick() {
      N("back");
    },
    className: "nf-arrow-button nf-left-arrow-button",
    style: q
  }, n.createElement(D, null), y && n.createElement("span", {
    className: "nf-arrow-left-text",
    style: {
      lineHeight: 1,
      fontSize: k ? 13 : 14,
      color: 0 === i ? ee.disabled : m,
      paddingRight: "4px",
      paddingLeft: "2px"
    }
  }, y)), n.createElement(De, {
    color: u,
    textColor: m,
    progress: T,
    max: z,
    showFormProgressCount: b
  }), n.createElement("button", {
    key: l ? "submit" : "next",
    type: "button",
    onClick: function onClick() {
      N("forward");
    },
    className: "nf-arrow-button nf-right-arrow-button",
    style: M
  }, a ? n.createElement(n.Fragment, null, S ? n.createElement(n.Fragment, null, w && n.createElement("span", {
    className: "nf-arrow-right-text",
    style: {
      lineHeight: 1,
      fontSize: k ? 13 : 14,
      paddingRight: "2px",
      paddingLeft: "4px",
      color: j ? l ? v : m : ee.disabled
    }
  }, w), n.createElement(A, null)) : "sending_files" === a ? n.createElement("span", {
    className: "nf-arrow-right-text",
    style: {
      lineHeight: 1,
      color: v,
      fontSize: k ? 13 : 14,
      fontWeight: "bold"
    }
  }, c, "%") : n.createElement("div", {
    className: "nf-spinner"
  })) : l ? n.createElement(n.Fragment, null, E && n.createElement("span", {
    className: "nf-arrow-right-submit-text",
    style: {
      lineHeight: 1,
      fontSize: k ? 13 : 14,
      paddingRight: "8px",
      paddingLeft: "4px",
      fontWeight: "bold",
      color: j ? l ? v : m : ee.disabled
    }
  }, E), n.createElement(F, null)) : n.createElement(n.Fragment, null, w && n.createElement("span", {
    className: "nf-arrow-right-text",
    style: {
      lineHeight: 1,
      fontSize: k ? 13 : 14,
      paddingRight: "2px",
      paddingLeft: "4px",
      color: j ? l ? v : m : ee.disabled
    }
  }, w), n.createElement(A, null))));
}

var Be = n.lazy(function () {
  return new Promise(function (e) {
    e(require("./index-13b1701d.js"));
  });
});

function Ve(e) {
  var r = e.form,
      o = e.isPreview,
      i = r || {},
      a = i.textColor,
      c = void 0 === a ? ee.primary : a,
      l = i.backgroundColor,
      s = void 0 === l ? ee.white : l,
      d = i.theme,
      f = i.signature,
      p = f.label,
      m = f.error,
      g = t.useRef(),
      h = u(t.useState(), 2),
      v = h[0],
      b = h[1];
  t.useEffect(function () {
    o && g.current && f.points && g.current.fromData(JSON.parse(f.points));
  }, [o, g, f]);
  var x = {
    position: "relative",
    backgroundColor: s,
    borderColor: "dark" === d ? ee.white : ee.lightgrey,
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 8
  };
  m && (x.borderColor = ee.error);
  return n.createElement("div", {
    className: "nf-signature-wrapper",
    id: "nf-signature"
  }, n.createElement("div", {
    className: "nf-signature-container"
  }, p && n.createElement("span", {
    style: {
      color: c,
      fontSize: 13.5,
      lineHeight: 1.5,
      fontWeight: "500",
      boxSizing: "border-box",
      padding: "8px 4px"
    }
  }, p, " ", n.createElement("span", {
    style: {
      fontSize: 13.5,
      fontWeight: "bold",
      color: ee.required
    }
  }, "*")), n.createElement("div", {
    className: "nf-signature",
    style: x
  }, !o && n.createElement("div", {
    style: {
      position: "absolute",
      top: 6,
      right: 6,
      opacity: .5,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    },
    onClick: function onClick(e) {
      e.stopPropagation(), e.preventDefault(), g.current.clear(), delete f.points, delete f.signedTimestamp, r.extraData = r.extraData || {}, delete r.extraData["Form signed at"], v && b(!1);
    }
  }, n.createElement(P, {
    size: 20,
    color: c
  })), n.createElement(t.Suspense, {
    fallback: n.createElement("div", {
      style: {
        height: 127
      }
    })
  }, n.createElement(Be, {
    ref: g,
    onEnd: function onEnd() {
      f.points = JSON.stringify(g.current.toData()), f.signedTimestamp = new Date().getTime(), r.extraData = r.extraData || {}, r.extraData["Form signed at"] = new Date().toString(), delete f.error, b(!0);
    },
    penColor: c,
    canvasProps: {
      width: 300,
      height: 120
    }
  })), o && n.createElement("div", {
    onClick: function onClick(e) {
      e.stopPropagation(), e.preventDefault();
    },
    style: {
      blinder: {
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1
      }
    }
  }))), m && n.createElement("span", {
    className: "nf-signature-error"
  }, r.signature.customError || "Signing the form is required."));
}

var We = ".nf-signature-wrapper{display:flex;flex-direction:column;width:100%;max-width:600px;box-sizing:border-box;padding:4px 12px 24px 24px}.nf-signature-container{display:flex;flex-direction:column;align-self:flex-start;align-items:flex-start;justify-content:flex-start;cursor:pointer;transition:opacity .2s ease-out}.nf-signature-error{font-size:13px;line-height:1.4;color:".concat(ee.error, ";box-sizing:border-box;padding: 10px 4px 0 4px}");

function He(e) {
  var r = e.form,
      o = e.isPreview,
      i = r.customRecaptchaText,
      a = r.recaptchaError,
      c = u(t.useState(o), 2),
      l = c[0],
      s = c[1];
  return n.createElement("div", {
    className: "nf-recaptcha-container",
    id: "nf-recaptcha"
  }, n.createElement("div", {
    className: "nf-recaptcha-wrapper",
    style: {
      borderColor: a ? ee.error : "#d3d3d3"
    }
  }, l ? n.createElement("div", {
    className: "nf-recaptcha-accepted"
  }, n.createElement(_, {
    size: 26,
    color: ee.success
  })) : n.createElement("div", {
    onClick: function onClick() {
      l || (r.acceptedRecaptcha = new Date().getTime(), delete r.recaptchaError, s(!0));
    },
    className: "nf-recaptcha-checkbox",
    style: {
      borderColor: a ? ee.error : "#c1c1c1"
    }
  }), n.createElement("span", {
    style: {
      color: "#333",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "17px",
      flex: 1
    }
  }, i || "I'm not a robot"), n.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 13px 0 13px"
    }
  }, n.createElement("div", {
    className: "nf-recaptcha-logo"
  }), n.createElement("span", {
    style: {
      fontSize: "10px",
      fontWeight: "400",
      lineHeight: "10px",
      marginTop: "8px",
      textAlign: "center",
      color: "#555"
    }
  }, "reCAPTCHA"))), a && n.createElement("span", {
    className: "nf-recaptcha-error"
  }, r.customRecaptchaError || "Confirm that you are not a robot."));
}

var Ue = ".nf-recaptcha-container{display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;width:100%;max-width:600px;box-sizing:border-box;padding:4px 12px 20px 24px}.nf-recaptcha-wrapper{display:flex;flex-direction:row;align-items:center;justify-content:center;border-radius:8px;box-shadow:0 0 4px 1px rgba(0,0,0,.05);height:70px;width:90%;max-width:280px;background:#f9f9f9;color:#333;border:1px solid #d3d3d3}.nf-recaptcha-checkbox{cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;border-width:1px;border-style:solid;border-radius:2px;background-color:#fff;border:2px solid #c1c1c1;margin-left:12px;margin-right:12px;height:22px;width:22px}.nf-recaptcha-accepted{margin-left:12px;margin-right:12px;-webkit-animation-name:nf-fade-in;animation-name:nf-fade-in;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-timing-function:linear;animation-timing-function:linear}.nf-recaptcha-logo{background:url(https://www.gstatic.com/recaptcha/api2/logo_48.png);background-size:32px;height:32px;width:32px}.nf-recaptcha-error{font-size:13px;line-height:1.4;color:".concat(ee.error, ";box-sizing:border-box;padding: 10px 4px 0 4px}");

function Je(e) {
  var t = e.isSending,
      r = e.sendForm,
      o = e.isPreview,
      i = e.form,
      a = e.currentPage,
      c = e.changePageIndex,
      l = e.uploadingProgress,
      s = i.poweredBy,
      u = i.button,
      d = i.submitTextColor,
      f = void 0 === d ? ee.white : d,
      p = i.color,
      m = void 0 === p ? ee.main : p,
      g = i.isNativeSlides,
      h = i.pages.length > 1,
      v = a === i.pages.length - 1;
  if (i.pagesStack && (v = i.pagesStack[i.pagesStack.length - 1] === a), "quiz" === t && !h) return null;
  if ("quiz" === t && g) return null;
  if (h && !g) return n.createElement(Le, null, i.legal && v && n.createElement(Me, {
    isPreview: o,
    form: i
  }), i.signature && v && n.createElement(Ve, {
    isPreview: o,
    form: i
  }), i.recaptcha && v && n.createElement(He, {
    isPreview: o,
    form: i
  }), n.createElement(Fe, {
    form: i,
    isSending: t,
    currentPage: a,
    changePageIndex: c,
    isPreview: o,
    uploadingProgress: l,
    isLastPage: v
  }));
  if (g && !v) return null;
  var b = {
    backgroundColor: m || ee.main,
    color: f
  };
  return t && (b.opacity = .8), n.createElement(Le, null, i.legal && n.createElement(Me, {
    isPreview: o,
    form: i
  }), i.signature && n.createElement(Ve, {
    isPreview: o,
    form: i
  }), i.recaptcha && n.createElement(He, {
    isPreview: o,
    form: i
  }), n.createElement("div", {
    className: "nf-submit-button-container",
    style: {
      paddingBottom: "hide" === s ? 24 : 12
    }
  }, n.createElement("button", {
    type: "submit",
    className: "nf-submit-button",
    id: "nf-submit-button",
    onClick: r,
    style: b
  }, t ? n.createElement(n.Fragment, null, "sending_files" === t && n.createElement("span", {
    className: "nf-uploading-progress",
    style: {
      color: f
    }
  }, l, "%"), n.createElement("div", {
    className: "nf-spinner"
  })) : u)));
}

function Ge(e) {
  return new RegExp("^(http|https)", "i").test(e) ? e : "https://" + e;
}

function Ye(e) {
  var t = e.logo,
      r = e.form,
      o = t.url,
      i = t.link,
      a = t.size,
      c = void 0 === a ? 40 : a,
      l = t.paddingTop,
      s = void 0 === l ? 20 : l,
      u = t.fullWidth,
      d = (r || {}).backgroundColor,
      f = void 0 === d ? ee.white : d,
      p = n.createElement(Le, null, n.createElement("img", {
    alt: "logo",
    src: o,
    className: "nf-logo",
    style: {
      width: u ? "100%" : "auto",
      maxWidth: 600,
      height: u ? "auto" : "".concat(c, "px")
    }
  }));
  return i ? n.createElement("div", {
    className: "nf-logo-container",
    style: {
      backgroundColor: f,
      paddingTop: s
    }
  }, n.createElement("a", {
    href: Ge(i),
    rel: "noopener noreferrer",
    target: "_blank"
  }, p)) : n.createElement("div", {
    className: "nf-logo-container",
    style: {
      backgroundColor: f,
      paddingTop: s
    }
  }, p);
}

function Xe() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
      r = e.type,
      o = e.value;

  if (e.conditionQuestionID) {
    var i = t.find(function (t) {
      return t.id === e.conditionQuestionID;
    });
    i && (e.conditionQuestion = i.question || i.placeholder);
  }

  if (e.questionToShowID) {
    var a = t.find(function (t) {
      return t.id === e.questionToShowID;
    });
    a && (e.questionToShow = a.question || a.placeholder);
  }

  return !(!e.conditionQuestion || !e.questionToShow) && !("has any value" !== r && !o) && !!n.includes(e.conditionQuestion) && !!n.includes(e.questionToShow);
}

function $e(e) {
  if (e && (Array.isArray(e.value) ? "object" == typeof e.value[0] ? e.value.forEach(function (e) {
    e.value && delete e.value, e.error && delete e.error, e.shuffled && delete e.shuffled, e.defaultValue && (e.multiSelect ? e.value = e.defaultValue.split(",") : e.value = e.defaultValue);
  }) : delete e.value : (e.value && delete e.value, e.error && delete e.error, e.percentage && delete e.percentage, e.percentage2 && delete e.percentage2, e.files && delete e.files, e.time && delete e.time, e.timezone && delete e.timezone), e.showOther && delete e.showOther, e.other && delete e.other.input, e.blockedColumns && delete e.blockedColumns, e.shuffled && delete e.shuffled, e.defaultValue)) if ("slider" === e.type) e.percentage = e.defaultValue, e.value = ge(e);else if ("date" === e.type) {
    var t = new Date(e.defaultValue),
        n = e.timezone || de(),
        r = t.getTime();
    e.value = se(t, e), e.time = r, e.timezone = n;
  } else e.value = e.defaultValue;
}

var Qe = function Qe(e) {
  try {
    if (!window) return;
    if (!window.localStorage) return;
    var t = JSON.stringify(e);
    window.localStorage.setItem("nativeForms-".concat(e.formName), t);
  } catch (e) {
    console.error(e);
  }
},
    Ke = function Ke(e) {
  try {
    return !!window && !!window.localStorage && (window.localStorage.removeItem("nativeForms-".concat(e.formName)), !0);
  } catch (e) {
    return console.error(e), !1;
  }
};

function Ze(e, t) {
  for (var n, r = v(e), o = 0; o < r.length; o++) {
    if (r[o].question === t || r[o].placeholder === t) {
      n = r[o];
      break;
    }
  }

  return n;
}

function et(e) {
  var t = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.conditions || [],
        n = [],
        r = v(e),
        o = r.map(function (e) {
      return e.question || e.placeholder;
    });
    return t.forEach(function (e) {
      Xe(e, r, o) && n.push(e);
    }), n;
  }(e),
      n = !1;

  if (0 === t.length) return {
    conditions: t,
    hasChanges: n
  };
  var r = h(e);
  return t.forEach(function (t) {
    var o = t.type,
        i = t.value,
        a = t.canShow;

    if ("has any value" === o) {
      var c = !!r[t.conditionQuestion];
      if (a !== c && !window.nf_saved_form_loading) $e(Ze(e, t.questionToShow)), n = !0;
      t.canShow = c;
    }

    if ("is equal to" === o) {
      var l = !!r[t.conditionQuestion] && r[t.conditionQuestion].toString().toLowerCase().trim() === i.toString().toLowerCase().trim();
      if (a !== l && !window.nf_saved_form_loading) $e(Ze(e, t.questionToShow)), n = !0;
      t.canShow = l;
    }

    if ("is not equal to" === o) {
      var s = !!r[t.conditionQuestion] && r[t.conditionQuestion].toString().toLowerCase().trim() !== i.toString().toLowerCase().trim();
      if (a !== s && !window.nf_saved_form_loading) $e(Ze(e, t.questionToShow)), n = !0;
      t.canShow = s;
    }

    if ("includes" === o) {
      var u = !!r[t.conditionQuestion] && r[t.conditionQuestion].toString().toLowerCase().trim().includes(i.toString().toLowerCase().trim());
      if (a !== u && !window.nf_saved_form_loading) $e(Ze(e, t.questionToShow)), n = !0;
      t.canShow = u;
    }

    if ("does not include" === o) {
      var d = !!r[t.conditionQuestion] && !r[t.conditionQuestion].toString().toLowerCase().trim().includes(i.toString().toLowerCase().trim());
      if (a !== d && !window.nf_saved_form_loading) $e(Ze(e, t.questionToShow)), n = !0;
      t.canShow = d;
    }
  }), window.nf_saved_form_loading && (window.nf_saved_form_loading = !1), {
    conditions: t,
    hasChanges: n
  };
}

function tt(e, n) {
  var r = u(t.useState(et(e).conditions), 2),
      o = r[0],
      i = r[1],
      a = t.useCallback(function (t, r, o) {
    t && t.dueDate && (e.dueDate = t.value), r && ("due-date" === r.type && (e.dueDate = r.value), "due-date-time" === r.type && (e.dueDateTime = r.value)), function (e) {
      var t = e.block,
          n = e.form,
          r = e.field;

      if (t) {
        var o = {
          nf_event: {
            event: "form_value_change",
            block: JSON.stringify(t),
            form: JSON.stringify(n)
          }
        };
        r && (o.nf_event.field = JSON.stringify(r));
        var i = JSON.stringify(o);
        $(n, "form_value_change"), Z(i);
      }
    }({
      block: t,
      field: r,
      form: e
    }), window.nf_form_value_change && window.nf_form_value_change(t, r), n && n({
      block: t,
      field: r,
      form: e
    }), e.saveProgress && Qe(e), o || (t.error && delete t.error, r && r.error && delete r.error);
    var a = et(e);
    i(f(a.conditions));
  }, [e]);
  return t.useEffect(function () {
    var t = et(e).conditions;
    e.conditions = t, i(t);
  }, [e]), {
    conditions: o,
    onFormValueChange: a
  };
}

function nt(e) {
  var t = e.id,
      n = e.type;
  return n ? t ? "".concat(n, "-").concat(t) : n : "";
}

function rt(e) {
  var t = e.color,
      r = e.value,
      o = e.backgroundColor,
      i = e.theme,
      a = e.block,
      c = nt({
    id: (void 0 === a ? {} : a).id,
    type: "badge"
  }),
      l = {
    backgroundColor: o,
    borderColor: "dark" === i ? ee.darkgrey : ee.border,
    borderWidth: 1,
    borderStyle: "solid",
    color: t
  };
  return r ? n.createElement("div", {
    className: "nf-badge-container container-".concat(c)
  }, n.createElement("span", {
    className: "nf-badge ".concat(c),
    style: l
  }, r)) : null;
}

function ot(e) {
  var t = e.form,
      r = e.block,
      o = e.blockIndex,
      i = void 0 === o ? 0 : o,
      a = e.questionNumber,
      c = t.backgroundColor,
      l = void 0 === c ? ee.white : c,
      s = t.color,
      u = void 0 === s ? ee.main : s,
      d = t.textColor,
      f = void 0 === d ? ee.primary : d,
      p = t.theme,
      m = t.hideQuestionsNumbers,
      g = r.question,
      h = r.isRequired,
      v = r.badge,
      b = r.type,
      x = r.textAlign,
      y = void 0 === x ? "center" : x,
      w = r.error,
      E = r.id,
      k = !m && "description" !== b,
      S = nt({
    id: r.id,
    type: "header"
  }),
      C = {
    backgroundColor: l,
    marginBottom: "description" === b || "video" === b ? -1 : 0,
    borderBottomColor: "dark" === p ? ee.darkgrey : ee.border,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderTopWidth: 0 === i ? 0 : 1,
    borderTopColor: "dark" === p ? ee.darkgrey : ee.border,
    borderTopStyle: "solid"
  },
      N = {
    color: f || ee.primary,
    textAlign: y
  },
      z = {
    color: u || ee.main
  };
  return g ? n.createElement(n.Fragment, null, n.createElement("div", {
    className: "nf-question-wrapper wrapper-".concat(S),
    style: C,
    id: E
  }, n.createElement("div", {
    className: "nf-question-container container-".concat(S)
  }, n.createElement("span", {
    className: "nf-question-header ".concat(S),
    style: N
  }, k && n.createElement("span", {
    className: "nf-question-number number-".concat(S),
    style: z
  }, a, ")", " "), n.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: Pe(g)
    }
  }), " ", h && n.createElement("span", {
    className: "nf-question-required required-".concat(S)
  }, "*")), w && n.createElement("span", {
    className: "nf-question-error error-question-".concat(S),
    dangerouslySetInnerHTML: {
      __html: Pe(w)
    }
  }))), !1 !== v && n.createElement(rt, {
    backgroundColor: l,
    color: u,
    value: v,
    theme: p,
    block: r
  })) : null;
}

var it = ".nf-question-header{font-size:14.5px;line-height:1.7;width:100%;max-width:600px;white-space:pre-wrap;word-break:break-word;}.nf-question-container{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;max-width:600px;box-sizing:border-box;padding:22px 28px}.nf-question-wrapper{background-color:transparent;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;width:100%;box-sizing:border-box}.nf-question-number{font-size:13px;line-height:15px;font-weight:600}.nf-question-error{font-size:13px;line-height:1.5;color:".concat(ee.error, ";box-sizing:border-box;padding:4px 0 0 0}.nf-question-required{color:").concat(ee.required, ";font-weight:600}@media (max-width:600px){.nf-question-header{font-size:14px;}.nf-question-container{padding:21px 24px}}"),
    at = function at(e) {
  var t = e.block,
      r = e.form,
      o = e.blockIndex,
      i = e.questionNumber;
  return n.createElement(Le, {
    id: t.id
  }, n.createElement(ot, {
    form: r,
    block: t,
    blockIndex: o,
    questionNumber: i
  }));
},
    ct = n.lazy(function () {
  return new Promise(function (e) {
    e(require("./Dropdown-26ab8fac.js"));
  });
});

function lt(e) {
  var r = e.select,
      o = e.onValueChange,
      i = e.value,
      a = e.isPreview,
      c = e.borderColor,
      l = e.inputBackgroundColor,
      s = e.inputTextColor,
      f = e.placeholder,
      p = e.label,
      m = e.field,
      g = e.className,
      h = d(e, ["select", "onValueChange", "value", "isPreview", "borderColor", "inputBackgroundColor", "inputTextColor", "placeholder", "label", "field", "className"]),
      v = u(t.useState(""), 2),
      b = v[0],
      x = v[1],
      y = u(t.useState(!1), 2),
      w = y[0],
      E = y[1],
      k = u(t.useState(!1), 2),
      S = k[0],
      C = k[1],
      N = t.createRef(),
      z = (m || {}).disableSearch,
      T = t.useMemo(function () {
    return r.filter(function (e) {
      return "object" == typeof e ? e.value.toLowerCase().includes(b.toLowerCase()) : e.toLowerCase().includes(b.toLowerCase());
    });
  }, [b, r]),
      O = function O() {
    a || (E(!0), x(""), o(""), C(!0));
  },
      P = function P(e) {
    o(e), E(!1), x("");
  },
      _ = function _(e) {
    x(e.target.value);
  },
      j = function j() {
    C(!1), E(!1), x("");
  },
      q = function q(e) {
    a || (e.preventDefault(), e.stopPropagation(), C(!0));
  };

  return n.createElement("div", {
    ref: N,
    style: {
      width: "100%",
      position: "relative"
    }
  }, n.createElement(t.Suspense, {
    fallback: n.createElement("div", {
      style: {
        height: 60
      }
    })
  }, n.createElement(ct, {
    isVisible: S,
    placement: "bottom-start",
    onClose: j,
    triggerRenderer: function triggerRenderer(e) {
      var t = e.ref;
      return n.createElement("div", {
        onClick: q,
        ref: t,
        style: {
          width: "100%",
          position: "relative",
          display: "flex"
        }
      }, n.createElement("input", {
        name: "native-forms-select",
        autoComplete: "off",
        value: w ? b : i,
        id: h.customId || p || f,
        onChange: _,
        onFocus: O,
        maxLength: 5e3,
        className: "nf-select-field-input input-".concat(g),
        style: {
          cursor: w ? "text" : "pointer",
          color: s,
          borderColor: c,
          backgroundColor: l,
          WebkitTextFillColor: b || i ? s : s + "99"
        },
        readOnly: a || z,
        placeholder: a ? "" : w ? z ? f || "- Select an option -" : "" : f || "- Select an option -"
      }), !a && n.createElement("div", {
        alt: "arrows",
        style: {
          pointerEvents: "none",
          position: "absolute",
          right: 10,
          display: "flex",
          alignItems: "center",
          height: "100%"
        }
      }, n.createElement(R, null)));
    }
  }, n.createElement("div", {
    className: "nf-select-field-items-container items-container-".concat(g),
    style: {
      backgroundColor: l
    }
  }, 0 === T.length && n.createElement("span", {
    style: {
      boxSizing: "border-box",
      padding: "13px 12px",
      color: "#647384",
      fontSize: "13.5px"
    }
  }, "No results..."), T.map(function (e) {
    return "object" == typeof e ? n.createElement("button", {
      type: "button",
      key: e.value,
      onClick: function onClick() {
        a || (P(e.value), j());
      },
      className: "nf-select-field-item field-item-".concat(g),
      style: {
        color: s
      }
    }, e.value, e.description && n.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: Pe(e.description)
      }
    })) : n.createElement("button", {
      type: "button",
      key: e,
      onClick: function onClick() {
        a || (P(e), j());
      },
      className: "nf-select-field-item field-item-".concat(g),
      style: {
        color: s
      }
    }, e);
  })))));
}

function st(e) {
  var t = e.select,
      r = e.value,
      o = void 0 === r ? "" : r,
      i = e.onValueChange,
      a = e.isPreview,
      c = e.borderColor,
      l = e.inputBackgroundColor,
      s = e.inputTextColor,
      u = e.placeholder;
  return n.createElement("select", {
    value: o,
    className: "nf-select-field-mobile",
    disabled: a,
    placeholder: u || "- Select an option -",
    onChange: function onChange(e) {
      a || i(e.target.value);
    },
    style: {
      color: s,
      borderColor: c,
      backgroundColor: l,
      WebkitTextFillColor: o ? s : s + "99"
    }
  }, n.createElement("option", {
    value: "",
    disabled: !0
  }, u || "- Select an option -"), t && t.map(function (e, t) {
    return n.createElement("option", {
      key: "".concat(e, "-").concat(t),
      value: e
    }, e);
  }));
}

function ut(e) {
  return window.innerWidth <= 767 ? n.createElement(st, e) : n.createElement(lt, e);
}

function dt() {
  var e,
      t,
      n,
      r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "#ffffff";
  return r.match(/^rgb/) ? (e = (r = r.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/))[1], t = r[2], n = r[3]) : (e = (r = +("0x" + r.slice(1).replace(r.length < 5 && /./g, "$&$&"))) >> 16, t = r >> 8 & 255, n = 255 & r), Math.sqrt(e * e * .299 + t * t * .587 + n * n * .114) > 127.5 ? "light" : "dark";
}

var ft = ["#4CAF50", "#0186c0", "#bb3355", "#e2445c", "#ff652e", "#579bfc"];

function pt(e) {
  if (!e) return "#34a095";
  var t = 0;
  if (0 === e.length) return t;

  for (var n = 0; n < e.length; n++) {
    t = e.charCodeAt(n) + ((t << 5) - t), t &= t;
  }

  return ft[t = (t % ft.length + ft.length) % ft.length];
}

var mt = t.memo(function (e) {
  var r = e.profile,
      o = e.size,
      i = void 0 === o ? 42 : o,
      a = e.marginLeft,
      c = void 0 === a ? 0 : a,
      l = r.avatar,
      d = r.name,
      f = r.email,
      p = r.uid,
      m = u(t.useState(!1), 2),
      g = m[0],
      h = m[1],
      v = d || f || "?",
      b = {
    width: i,
    height: i,
    fontSize: i / 2
  };
  return "unassigned" === p ? n.createElement("div", {
    className: "nf-avatar",
    style: s({
      marginLeft: c
    }, b),
    title: d || f
  }, n.createElement(J, null)) : l && !g ? n.createElement("div", {
    className: "nf-avatar",
    style: s({
      marginLeft: c
    }, b)
  }, n.createElement("img", {
    style: s({}, b, {
      borderRadius: "50%"
    }),
    src: l,
    onError: function onError() {
      return h(!0);
    },
    title: d || f,
    alt: "avatar"
  })) : n.createElement("div", {
    className: "nf-avatar",
    style: s({
      backgroundColor: pt(f || d),
      marginLeft: c
    }, b),
    title: d || f
  }, v.charAt(0).toUpperCase());
}),
    gt = n.lazy(function () {
  return new Promise(function (e) {
    e(require("./Dropdown-26ab8fac.js"));
  });
});

function ht(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 32;
  return "status" === e && window.nt_returnStatusIcon ? window.nt_returnStatusIcon(t) : "priority" === e && window.nt_returnPriorityIcon ? window.nt_returnPriorityIcon(t) : "assignee" === e ? n.createElement(mt, {
    size: r,
    profile: t
  }) : null;
}

function vt(e) {
  var r = e.form,
      o = e.type,
      i = e.onValueChange,
      a = e.isPreview,
      c = e.borderColor,
      l = e.inputBackgroundColor,
      s = e.inputTextColor,
      f = e.label,
      p = e.field,
      m = e.className,
      g = d(e, ["form", "type", "onValueChange", "isPreview", "borderColor", "inputBackgroundColor", "inputTextColor", "label", "field", "className"]),
      h = window.innerWidth <= 767,
      v = (r || {}).color,
      b = void 0 === v ? ee.main : v,
      x = u(t.useState(""), 2),
      y = x[0],
      w = x[1],
      E = u(t.useState(!1), 2),
      k = E[0],
      S = E[1],
      C = t.createRef(),
      N = (p || {}).disableSearch,
      z = function (e, t, n) {
    var r;

    if ("status" === t && n.status) {
      var o = n.statuses,
          i = (void 0 === o ? [] : o).find(function (e) {
        return e.id == n.status.id;
      });
      i && (r = [i]);
    }

    if ("priority" === t && n.priority) {
      var a = n.priorities,
          c = (void 0 === a ? [] : a).find(function (e) {
        return e.id == n.priority.id;
      });
      c && (r = [c]);
    }

    if ("assignee" === t && n.assignee) {
      var l = n.users,
          s = void 0 === l ? [] : l,
          u = n.assignee.map(function (e) {
        return s.find(function (t) {
          return t.uid == e.uid;
        });
      }).filter(function (e) {
        return e;
      });
      u.length > 0 && (r = u);
    }

    return r && (e.value = r), r;
  }(p, o, r) || [],
      T = "assignee" === o,
      O = function (e, t) {
    if ("status" === t) {
      var n = e.statuses;
      return void 0 === n ? [] : n;
    }

    if ("priority" === t) {
      var r = e.priorities;
      return void 0 === r ? [] : r;
    }

    if ("assignee" === t) {
      var o = e.users;
      return void 0 === o ? [] : o;
    }

    return [];
  }(r, o).filter(function (e) {
    var t = e.name;
    return "assignee" === o && (t = (e.name || "") + e.email), t.toLowerCase().includes(y.toLowerCase());
  }),
      P = g.placeholder || function (e) {
    return "status" === e ? "- Select status -" : "priority" === e ? "- Select priority -" : "assignee" === e ? "- Select assignee -" : "- Select an option -";
  }(o),
      _ = function _(e) {
    i(e), w("");
  },
      j = function j(e) {
    w(e.target.value);
  },
      q = function q() {
    S(!1), w("");
  },
      M = function M(e) {
    a || (e.preventDefault(), e.stopPropagation(), S(!0), C.current && !h && C.current.focus());
  };

  return n.createElement("div", {
    style: {
      width: "100%",
      position: "relative"
    }
  }, n.createElement(t.Suspense, {
    fallback: n.createElement("div", {
      style: {
        height: 60
      }
    })
  }, n.createElement(gt, {
    isVisible: k,
    placement: "bottom-start",
    onClose: q,
    triggerRenderer: function triggerRenderer(e) {
      var t = e.ref;
      return n.createElement("div", {
        onClick: M,
        ref: t,
        className: "nf-multi-select-field-container input-".concat(m),
        style: {
          borderColor: c,
          backgroundColor: l,
          padding: "assignee" === o && z.length > 0 ? "8px 13px" : "12px 13px"
        }
      }, z.map(function (e) {
        return n.createElement("div", {
          key: e.id || e.uid,
          className: "nf-multi-select-item-selected",
          style: {
            color: s
          }
        }, ht(o, e, 26), n.createElement("span", {
          className: "nf-multi-select-item-label",
          style: {
            paddingLeft: 10
          }
        }, e.name || e.email));
      }), n.createElement("input", {
        value: y,
        ref: C,
        name: "native-forms-multi-select",
        autoComplete: "off",
        id: g.customId || f || P,
        onChange: j,
        maxLength: 5e3,
        className: "nf-multi-select-field-input input-".concat(m),
        style: {
          cursor: k ? "text" : "pointer",
          color: s,
          width: y ? 50 + 7 * y.length : 20 + 7 * P.length
        },
        readOnly: a || h || N,
        placeholder: a || k || z.length > 0 ? "" : P
      }), !a && n.createElement("div", {
        alt: "arrows",
        style: {
          pointerEvents: "none",
          position: "absolute",
          right: 10,
          display: "flex",
          alignItems: "center"
        }
      }, n.createElement(R, null)));
    }
  }, n.createElement("div", {
    className: "nf-select-field-items-container items-container-".concat(m),
    style: {
      backgroundColor: l
    }
  }, 0 === O.length && n.createElement("span", {
    style: {
      boxSizing: "border-box",
      padding: "17px 20px",
      color: "#647384",
      fontSize: "13.5px"
    }
  }, "No options..."), O.map(function (e) {
    var t = e.id || e.uid,
        i = "assignee" === o ? "uid" : "id",
        c = z.some(function (e) {
      return e[i] === t;
    }),
        l = "assignee" === o && r.hideAssigneeEmail;
    return n.createElement("button", {
      type: "button",
      key: t,
      onClick: function onClick() {
        if (!a) if (e.value = e.name || e.email, T) {
          var n = p.value || [];
          c ? 0 === (n = n.filter(function (e) {
            return e[i] !== t;
          })).length && (n = "") : n.push(e), "assignee" === o && (r.assignee = n), _(n), q();
        } else c ? ("priority" === o && delete r.priority, "status" === o && delete r.status, _("")) : ("priority" === o && (r.priority = e), "status" === o && (r.status = e), _([e])), q();
      },
      className: "nf-multi-select-item multi-field-item-".concat(m),
      style: {
        color: s,
        padding: "assignee" === o ? "12px 20px" : "17px 20px"
      }
    }, n.createElement(bt, {
      color: b,
      value: c,
      radio: !T
    }), ht(o, e), n.createElement("div", {
      className: "nf-multi-select-item-column"
    }, n.createElement("span", {
      className: "nf-multi-select-item-label"
    }, e.name), e.email && !l && n.createElement("span", {
      className: "nf-multi-select-item-description",
      style: {
        color: "".concat(s, "99")
      }
    }, e.email)));
  })))));
}

function bt(e) {
  var t = e.color,
      r = e.radio,
      o = e.value,
      i = {
    backgroundColor: o ? t || ee.main : ee.white,
    borderRadius: r ? "50%" : "2px",
    border: o ? "none" : "1px solid ".concat(ee.grey),
    marginRight: 14
  };
  return n.createElement("div", {
    className: "nf-multi-select-item-checkbox",
    color: t,
    radio: r,
    checked: o,
    style: i
  }, o && n.createElement(_, {
    size: 12,
    color: "white"
  }));
}

var xt = n.lazy(function () {
  return new Promise(function (e) {
    e(require("./LocationInput-69cce5d1.js"));
  });
}),
    yt = n.lazy(function () {
  return new Promise(function (e) {
    e(require("./MaskedInput-05b9d48b.js"));
  });
});

function wt(e) {
  var r = e.label,
      o = e.description,
      i = e.required,
      a = e.error,
      c = e.name,
      l = e.textColor,
      s = (e.backgroundColor, e.inputBackgroundColor),
      u = e.inputTextColor,
      f = e.color,
      p = e.multiline,
      m = e.select,
      g = e.onValueChange,
      h = (e.index, e.blockIndex, e.margin),
      v = e.stripe,
      b = e.field,
      x = void 0 === b ? {} : b,
      y = d(e, ["label", "description", "required", "error", "name", "textColor", "backgroundColor", "inputBackgroundColor", "inputTextColor", "color", "multiline", "select", "onValueChange", "index", "blockIndex", "margin", "stripe", "field"]),
      w = {
    color: l
  },
      E = {
    color: u,
    borderColor: a ? ee.error : "dark" === dt(s) ? ee.darkgrey : ee.border,
    backgroundColor: s,
    WebkitTextFillColor: y.value ? u : u + "99"
  },
      k = c || Se(r),
      S = "single";
  v && (S = "stripe"), p && (S = "multiline"), m && (S = "select"), "status" === x.type && (S = "status"), "priority" === x.type && (S = "priority"), "assignee" === x.type && (S = "assignee"), "due-date" === x.type && (S = "due-date"), "due-date-time" === x.type && (S = "due-date-time");
  var C = nt({
    id: x.id,
    type: S
  });
  return n.createElement("div", {
    className: "nf-input-container container-".concat(C),
    style: {
      marginBottom: h
    },
    id: x.id
  }, n.createElement("span", {
    className: "nf-input-label label-".concat(C),
    style: w
  }, n.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: Pe(r)
    }
  }), " ", i && r && n.createElement("span", {
    className: "nf-input-required required-".concat(C)
  }, "*")), "due-date" === x.type && n.createElement("input", Object.assign({}, y, {
    type: "date",
    maxLength: 1e4,
    name: k,
    className: "nf-input input-".concat(C),
    style: E,
    id: y.customId || r || y.placeholder
  })), "due-date-time" === x.type && n.createElement("input", Object.assign({}, y, {
    type: "datetime-local",
    maxLength: 1e4,
    name: k,
    className: "nf-input input-".concat(C),
    style: E,
    id: y.customId || r || y.placeholder
  })), ("status" === S || "priority" === S || "assignee" === S) && n.createElement(vt, Object.assign({
    form: y.form,
    type: S,
    onValueChange: g,
    textColor: l,
    color: f,
    borderColor: E.borderColor,
    inputBackgroundColor: s,
    inputTextColor: u,
    label: r,
    className: C,
    field: x
  }, y)), "select" === S && n.createElement(ut, Object.assign({
    select: m,
    onValueChange: g,
    textColor: l,
    color: f,
    borderColor: E.borderColor,
    inputBackgroundColor: s,
    inputTextColor: u,
    label: r,
    className: C
  }, y)), "multiline" === S && (x.masked ? n.createElement(t.Suspense, {
    fallback: n.createElement("div", {
      style: {
        height: 118
      }
    })
  }, n.createElement(yt, Object.assign({}, y, {
    className: "nf-textarea textarea-".concat(C),
    inputStyle: E,
    label: r,
    field: x,
    multiline: !0,
    rows: y.rows || 4
  }))) : n.createElement("textarea", Object.assign({}, y, {
    rows: y.rows || 4,
    maxLength: 25e3,
    name: k,
    className: "nf-textarea textarea-".concat(C),
    style: E,
    id: y.customId || r || y.placeholder
  }))), "single" === S && ("country" === k ? n.createElement(ut, Object.assign({
    select: ce,
    onValueChange: g,
    textColor: l,
    color: f,
    borderColor: E.borderColor,
    inputBackgroundColor: s,
    inputTextColor: u,
    label: r,
    className: C
  }, y)) : "localization" === k ? n.createElement(t.Suspense, {
    fallback: n.createElement("div", {
      style: {
        height: 60
      }
    })
  }, n.createElement(xt, Object.assign({}, y, {
    uniqueClassName: C,
    inputStyle: E,
    label: r,
    field: x
  }))) : x.masked ? n.createElement(t.Suspense, {
    fallback: n.createElement("div", {
      style: {
        height: 60
      }
    })
  }, n.createElement(yt, Object.assign({}, y, {
    className: "nf-input input-".concat(C),
    inputStyle: E,
    label: r,
    field: x
  }))) : n.createElement("input", Object.assign({}, y, {
    maxLength: 1e4,
    name: k,
    className: "nf-input input-".concat(C),
    style: E,
    id: y.customId || r || y.placeholder
  }))), a && n.createElement("span", {
    className: "nf-input-error error-".concat(C),
    dangerouslySetInnerHTML: {
      __html: Pe(a)
    }
  }), o && !a && n.createElement("span", {
    className: "nf-input-description description-".concat(C),
    dangerouslySetInnerHTML: {
      __html: Pe(o)
    }
  }));
}

var Et = ".nf-input-container{width:100%;display:flex;flex-direction:column;align-items:stretch}.nf-input-label{font-size:13.5px;text-align:left;line-height:1.5;font-weight:500;box-sizing:border-box;padding-left:5px;padding-right:5px}.nf-input-required{font-size:14px;font-weight:500;color:".concat(ee.required, "}.nf-textarea{-webkit-appearance:none;border-width:1px;border-style:solid;border-radius:8px;box-sizing:border-box;padding:12px;margin-top:5px;margin-bottom:6px;width:100%;font-size:14px;box-shadow: 0 1px 3px rgba(50, 50, 93, 0.05);min-height:48px;line-height:20px;resize:vertical;max-height:400px}.nf-input{-webkit-appearance:none;border-width:1px;border-style:solid;border-radius:8px;box-sizing:border-box;padding:12px;margin-top:5px;margin-bottom:6px;width:100%;font-size:14px;height:48px;box-shadow: 0 1px 3px rgba(50, 50, 93, 0.05);}.nf-input-error{font-size:13px;line-height:1.4;color:").concat(ee.error, ";box-sizing:border-box;padding:2px 4px}.nf-input-description{font-size:13px;line-height:1.4;color:").concat(ee.grey, ";box-sizing:border-box;padding:2px 5px}@media (max-width:600px){.nf-input-label{font-size:13px;}}");

function kt(e) {
  var t = e.value,
      n = e.prefix,
      r = e.suffix;
  return n && (t = n + (t = t.replaceAll(n, ""))).length <= n.length && (t = ""), r && (t = t.replaceAll(r, ""), (t += r).length <= r.length && (t = "")), t;
}

function St(e, t) {
  if (!e) return e;
  var n = t.currency,
      r = void 0 === n ? "USD" : n,
      o = t.locale,
      i = new Intl.NumberFormat(o || (null != navigator.languages ? navigator.languages[0] || "en-US" : navigator.language || "en-US"), {
    style: "currency",
    currency: r,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  return e = e.replace(/[^0-9.]/g, ""), (e = i.format(parseInt(e, 10))).includes("NaN") ? "" : e;
}

function Ct(e) {
  var t = e.block,
      r = e.form,
      o = e.isPreview,
      i = e.blockIndex,
      a = e.pageIndex,
      c = e.questionNumber,
      l = e.onFormValueChange,
      s = r || {},
      u = s.color,
      d = void 0 === u ? ee.main : u,
      f = s.textColor,
      p = void 0 === f ? ee.primary : f,
      m = s.backgroundColor,
      g = void 0 === m ? ee.white : m,
      h = s.inputBackgroundColor,
      v = void 0 === h ? ee.white : h,
      b = s.inputTextColor,
      x = void 0 === b ? ee.primary : b,
      y = nt({
    id: t.id,
    type: t.type
  });
  return n.createElement(Le, {
    id: t.id
  }, n.createElement(ot, {
    form: r,
    block: t,
    blockIndex: i,
    pageIndex: a,
    questionNumber: c
  }), n.createElement("div", {
    className: "nf-open-container container-".concat(y)
  }, n.createElement(wt, {
    multiline: !0,
    readOnly: o,
    inputStyle: {
      minHeight: 120,
      marginBottom: 4,
      marginTop: 4
    },
    onChange: function onChange(e) {
      var n = e.target.value;
      t.currency && (n = St(n, t.currency)), (t.inputPrefix || t.inputSuffix) && (n = kt({
        value: n,
        prefix: t.inputPrefix,
        suffix: t.inputSuffix
      })), t.value = n, l(t);
    },
    value: t.value,
    rows: 5,
    placeholder: t.placeholder || "",
    onBlur: function onBlur() {
      t.validator && (new RegExp(t.validator, t.validatorType || "gm").test(t.value) ? t.error = !1 : t.error = t.validatorError || "Invalid value.", l(t, null, !0));
    },
    error: !!t.error && " ",
    description: t.description,
    color: d,
    textColor: p,
    backgroundColor: g,
    inputBackgroundColor: v,
    inputTextColor: x,
    customId: t.question || t.placeholder,
    field: t
  })));
}

function Nt(e) {
  var t = e.block,
      r = e.form,
      o = e.isPreview,
      i = e.blockIndex,
      a = e.questionNumber,
      c = e.onFormValueChange,
      l = r || {},
      s = l.inputBackgroundColor,
      u = void 0 === s ? ee.white : s,
      d = l.inputTextColor,
      f = void 0 === d ? ee.primary : d,
      p = l.color,
      m = void 0 === p ? ee.main : p,
      g = l.textColor,
      h = void 0 === g ? ee.primary : g,
      v = l.theme,
      b = t.scale,
      x = void 0 === b ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] : b,
      y = t.min,
      w = t.max,
      E = x.length > 10,
      k = nt({
    id: t.id,
    type: t.type
  }),
      S = {
    color: m,
    fontWeight: "bold"
  };
  return n.createElement(Le, {
    id: t.id
  }, n.createElement(ot, {
    form: r,
    block: t,
    blockIndex: i,
    questionNumber: a
  }), n.createElement("div", {
    className: "nf-number-scale-container container-".concat(k)
  }, x.map(function (e) {
    var r = e == t.value,
        i = {
      zIndex: r ? 2 : 1,
      borderColor: r ? m : "dark" === v ? ee.darkgrey : ee.border,
      backgroundColor: r ? m : u,
      borderWidth: 1,
      borderStyle: "solid",
      padding: 8,
      minWidth: E ? 52 : 56,
      height: E ? 52 : 56
    },
        a = {
      fontWeight: r ? "bold" : "500",
      color: r ? u : f
    };
    return n.createElement("div", {
      key: e,
      className: "nf-number-container number-container-".concat(k),
      style: i,
      onClick: function onClick() {
        return n = e, void (o || (t.value = "".concat(n), c(t)));
        var n;
      }
    }, n.createElement("span", {
      className: "nf-number number-".concat(k),
      style: a
    }, e));
  })), n.createElement("div", {
    className: "nf-number-scale-legend legend-".concat(k)
  }, y && n.createElement("span", {
    className: "nf-number-scale-text min-text-".concat(k),
    style: {
      color: h
    }
  }, n.createElement("strong", {
    style: S
  }, x[0]), " - ", y), w && n.createElement("span", {
    className: "nf-number-scale-text max-text-".concat(k),
    style: {
      color: h
    }
  }, n.createElement("strong", {
    style: S
  }, x[x.length - 1]), " -", " ", w)));
}

function zt(e) {
  var t = e.selectedStars,
      r = e.onStarSelected,
      o = e.index,
      i = e.minText,
      a = e.maxText,
      c = e.theme,
      l = e.emojis,
      s = e.text2,
      u = e.text3,
      d = e.text4,
      f = e.textColor,
      p = e.customImage,
      m = void 0 === p ? {} : p,
      g = l && !m.url ? t === o : t >= o,
      h = window.innerWidth <= 600,
      v = {
    marginTop: h ? 4 : 12,
    marginBottom: h ? 4 : 12,
    marginLeft: h ? l || m.url ? 8 : 4 : l || m.url ? 12 : 6,
    marginRight: h ? l || m.url ? 8 : 4 : l || m.url ? 12 : 6
  };
  s && u && d && h && (v.marginLeft = 2, v.marginRight = 2);
  var b = g ? {} : {
    opacity: "dark" === c ? .2 : 1
  };
  return n.createElement("div", {
    onClick: r(o),
    className: "nf-star-container",
    style: v
  }, m.url ? n.createElement("img", {
    alt: "star-".concat(o),
    src: m.url,
    className: g ? "nf-star-animation" : "",
    style: {
      width: m.size || 48,
      filter: g ? "" : "grayscale(1) opacity(0.3)",
      marginBottom: 4
    }
  }) : l ? n.createElement("img", {
    alt: "star-".concat(o),
    src: ae[o - 1],
    className: g ? "nf-star-animation" : "",
    style: {
      width: 48,
      height: 48,
      filter: g ? "" : "grayscale(1) opacity(0.3)",
      marginBottom: 4
    }
  }) : n.createElement("div", {
    key: "star-".concat(t),
    className: g ? "nf-star-animation" : "",
    style: b
  }, n.createElement(j, {
    size: h ? 57.6 : 64,
    selected: g
  })), 1 === o && i && n.createElement("span", {
    className: "nf-star-label",
    style: {
      color: f
    }
  }, i), 2 === o && s && n.createElement("span", {
    className: "nf-star-label",
    style: {
      color: f
    }
  }, s), 3 === o && u && n.createElement("span", {
    className: "nf-star-label",
    style: {
      color: f
    }
  }, u), 4 === o && d && n.createElement("span", {
    className: "nf-star-label",
    style: {
      color: f
    }
  }, d), 5 === o && a && n.createElement("span", {
    className: "nf-star-label",
    style: {
      color: f
    }
  }, a));
}

function Tt(e) {
  var t = e.block,
      r = e.form,
      o = e.isPreview,
      i = e.blockIndex,
      a = e.questionNumber,
      c = e.onFormValueChange,
      l = r.theme,
      s = r.textColor,
      u = void 0 === s ? ee.primary : s,
      d = t.min,
      f = t.max,
      p = t.emojis,
      m = t.text2,
      g = t.text3,
      h = t.text4,
      v = t.customImage,
      b = t.value ? parseInt(t.value.charAt(0), 10) : 0,
      x = nt({
    id: t.id,
    type: t.type
  }),
      y = function y(e) {
    return function () {
      o || (t.value = "".concat(e, 1 === e ? " star" : " stars"), c(t));
    };
  };

  return n.createElement(Le, {
    id: t.id
  }, n.createElement(ot, {
    form: r,
    block: t,
    blockIndex: i,
    questionNumber: a
  }), n.createElement("div", {
    className: "nf-stars-container container-".concat(x)
  }, [1, 2, 3, 4, 5].map(function (e) {
    return n.createElement(zt, {
      selectedStars: b,
      index: e,
      key: "star" + e,
      onStarSelected: y,
      minText: d,
      maxText: f,
      text2: m,
      text3: g,
      text4: h,
      theme: l,
      emojis: p,
      textColor: u,
      customImage: v
    });
  })));
}

function Ot(e) {
  var t = e.form,
      r = e.value,
      o = e.margin,
      i = e.label,
      a = e.onChange,
      c = e.isPreview,
      l = e.required,
      s = e.field,
      u = t || {},
      d = u.color,
      f = void 0 === d ? ee.main : d,
      p = u.textColor,
      m = void 0 === p ? ee.primary : p,
      g = u.backgroundColor,
      h = void 0 === g ? ee.white : g,
      v = u.theme,
      b = nt({
    id: s.id,
    type: "checkbox"
  }),
      x = {
    backgroundColor: r ? f : h,
    borderColor: s.error ? ee.error : r ? "transparent" : "dark" === v ? ee.white : ee.lightgrey,
    borderWidth: 1,
    borderStyle: "solid"
  },
      y = {
    color: m
  };
  return n.createElement("div", {
    className: "nf-input-container container-".concat(b),
    style: {
      marginBottom: o
    }
  }, n.createElement("button", {
    type: "button",
    onClick: function onClick() {
      c || a(r ? "" : "Yes");
    },
    className: "nf-checkbox-container checkbox-container-".concat(b)
  }, n.createElement("div", null, n.createElement("div", {
    className: "nf-checkbox ".concat(b),
    style: x
  }, r && n.createElement(_, {
    size: 14,
    color: ee.white
  }))), n.createElement("div", {
    className: "nf-checkbox-label label-".concat(b)
  }, n.createElement("span", {
    style: y,
    dangerouslySetInnerHTML: {
      __html: Pe(i)
    }
  }), l && n.createElement("span", {
    className: "nf-input-required required-".concat(b)
  }, " ", "*"))));
}

function Pt(e) {
  var t = e.block,
      r = e.form,
      o = e.isPreview,
      i = e.blockIndex,
      a = e.questionNumber,
      c = e.conditions,
      l = e.onFormValueChange,
      u = r || {},
      f = u.color,
      m = void 0 === f ? ee.main : f,
      g = u.textColor,
      h = void 0 === g ? ee.primary : g,
      v = u.backgroundColor,
      b = void 0 === v ? ee.white : v,
      x = u.inputBackgroundColor,
      y = void 0 === x ? ee.white : x,
      w = u.inputTextColor,
      E = void 0 === w ? ee.primary : w,
      k = t.value,
      S = void 0 === k ? [] : k,
      C = nt({
    id: t.id,
    type: t.type
  }),
      N = function N(e) {
    return function (n) {
      var o = S[e],
          i = n.target ? n.target.value : n;
      o.currency && (i = St(i, o.currency)), (o.inputPrefix || o.inputSuffix) && (i = kt({
        value: i,
        prefix: o.inputPrefix,
        suffix: o.inputSuffix
      })), "title" === t.value[e].type && (r.title = i), t.value[e].value = i, l(t, t.value[e]);
    };
  };

  return n.createElement(Le, {
    id: t.id
  }, n.createElement(ot, {
    form: r,
    block: t,
    blockIndex: i,
    questionNumber: a
  }), n.createElement("div", {
    className: "nf-inputs-wrapper wrapper-".concat(C)
  }, S.map(function (e, a) {
    var u = e.isRequired,
        f = e.question,
        g = e.multiline,
        v = e.select,
        x = e.margin,
        w = e.checkbox,
        k = e.isHidden,
        C = d(e, ["isRequired", "question", "multiline", "select", "margin", "checkbox", "isHidden"]);
    if (k) return n.createElement("div", null);
    if ("title" === e.type && (e.value = r.title || "", C.value = e.value), p(c, f || e.placeholder)) return n.createElement("div", null);
    var z = e.type || Se(f || e.placeholder || e.title);
    1 === S.length && (f || e.placeholder || e.type || (e.title = t.question));
    var T = s({
      onChange: N(a),
      onValueChange: N(a),
      required: u,
      readOnly: o,
      isPreview: o,
      name: z,
      label: f,
      textColor: h,
      color: m,
      onBlur: function onBlur() {
        C.validator && C.value && (new RegExp(C.validator, C.validatorType || "gm").test(C.value) ? e.error = !1 : e.error = C.validatorError || "Invalid value.", l(t, e, !0));
      },
      backgroundColor: b,
      inputBackgroundColor: y,
      inputTextColor: E,
      margin: x || (f ? 12 : 10),
      form: r,
      field: e,
      block: t,
      onFormValueChange: l
    }, C);
    return w ? n.createElement(Ot, Object.assign({
      key: a,
      index: a,
      blockIndex: i
    }, T)) : n.createElement(wt, Object.assign({
      select: v,
      multiline: g,
      key: a,
      index: a,
      blockIndex: i
    }, T));
  })));
}

var _t = n.lazy(function () {
  return Promise.resolve().then(function () {
    return Rr;
  });
}),
    jt = function jt(e) {
  var r = e.block,
      o = e.form,
      i = e.isPreview,
      a = e.blockIndex,
      c = e.questionNumber,
      l = e.onFormValueChange;
  return n.createElement(Le, {
    id: r.id
  }, n.createElement(ot, {
    form: o,
    block: r,
    blockIndex: a,
    questionNumber: c
  }), n.createElement(t.Suspense, {
    fallback: n.createElement("div", {
      style: {
        height: 206
      }
    })
  }, n.createElement(_t, {
    block: r,
    form: o,
    onFormValueChange: l,
    isPreview: i
  })));
};

function qt(e, t) {
  var n = document.getElementById(t);
  if (n) n.innerHTML = e;else {
    var r = document.createElement("style");
    r.innerHTML = e, t && (r.id = t), document.head.appendChild(r);
  }
}

var Mt = n.lazy(function () {
  return new Promise(function (e) {
    e(require("./index-24da6cc1.js"));
  });
});

function It(e) {
  var r = e.block,
      o = e.form,
      i = e.isPreview,
      a = e.blockIndex,
      c = e.questionNumber,
      l = e.onFormValueChange,
      s = o || {},
      u = s.color,
      d = void 0 === u ? ee.main : u,
      p = s.textColor,
      m = void 0 === p ? ee.primary : p,
      g = r.numberOfMonths,
      h = void 0 === g ? 1 : g,
      v = r.multipleDays,
      b = r.disablePast,
      x = r.disableFuture,
      y = r.disabledWeekdays,
      w = r.timezone || de(),
      E = function (e) {
    return e.time ? Array.isArray(e.time) ? e.time : [e.time] : [];
  }(r),
      k = nt({
    id: r.id,
    type: r.type
  });

  t.useEffect(function () {
    qt(".rdp { position: relative; display: inline-block; -webkit-box-sizing: border-box; box-sizing: border-box; } .rdp-months { display: -webkit-box; display: -ms-flexbox; display: flex; } .rdp-caption { margin-bottom: 0.75em; text-align: left; font-weight: 600; font-size: 1.25em; color: ".concat(m, "; } .rdp[dir='rtl'] .rdp-caption { text-align: right; } .rdp-month { margin: 1em; } .rdp-month_table { border-collapse: collapse; } .rdp-head_weeknumber { font-variant-numeric: tabular-nums; } .rdp-head_weekname { padding-bottom: 0.5em; font-weight: normal; font-size: 0.75em; color: ").concat(m, "88; } .rdp-weeknumber { padding-bottom: 0.5em; min-width: 1.25em; text-align: right; font-weight: normal; font-size: 0.625em; } .rdp-week_day { text-align: center; } .rdp-nav { position: absolute; top: 1em; right: 1em; display: flex; cursor: } .rdp[dir='rtl'] .rdp-nav { right: auto; left: 1em; } .rdp-day:hover { opacity: 0.5; } .rdp-day { text-align:center; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; align-items: center; -ms-flex-align: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; -webkit-box-sizing: border-box; box-sizing: border-box; margin: 0; min-width: 2.4em; max-width: 2.4em; height: 2.4em; border: 0; background: none; color: ").concat(m, "; font-size: 1em; outline: none; -webkit-appearance: none; -moz-appearance: none; appearance: none; cursor: pointer; transition: opacity 200ms ease-out; } .rdp-day_wrapper { outline: none; } .rdp-day_disabled { opacity: 0.25; } .rdp-day_outside { opacity: 0.25; } .rdp-day_today { position: relative; color: #fc466b; border-radius: 100%; font-weight: 500; outline: none; } .rdp-day_selected:hover { opacity: 1; } .rdp-day_selected { border-radius: 100%; background-color: ").concat(d, "; color: white; outline: none; }"), "date-picker");
  }, []);
  var S = [{}];
  return b && (S[0].before = new Date()), x && (S[0].after = new Date().getTime() - 864e5), y && S.push(function (e) {
    return y.includes(e.getDay());
  }), n.createElement(Le, {
    id: r.id
  }, n.createElement(ot, {
    form: o,
    block: r,
    blockIndex: a,
    questionNumber: c
  }), n.createElement("div", {
    className: "nf-date-picker-container ".concat(k)
  }, n.createElement(t.Suspense, {
    fallback: n.createElement("div", {
      style: {
        height: 340
      }
    })
  }, n.createElement(Mt, {
    initialMonth: new Date(E[0] || new Date().getTime()),
    selected: E.map(function (e) {
      return new Date(e);
    }),
    onDayClick: function onDayClick(e) {
      if (!i) {
        var t = e.getTime();
        v ? (E.includes(t) ? r.time = E.filter(function (e) {
          return e !== t;
        }) : r.time = [].concat(f(E), [t]), r.value = se(r.time, r)) : r.time === t ? (delete r.time, delete r.value) : (r.time = t, r.value = se(r.time, r)), r.timezone = w, l(r);
      }
    },
    numberOfMonths: h,
    disabled: S,
    block: r
  }))));
}

function Lt(e) {
  var r = e.block,
      o = e.form,
      i = e.blockIndex,
      a = o.backgroundColor,
      c = void 0 === a ? ee.white : a,
      l = o.textColor,
      s = void 0 === l ? ee.primary : l,
      d = o.theme,
      f = u(t.useState(!1), 2),
      p = f[0],
      m = f[1],
      g = r.url,
      h = r.scale,
      v = void 0 === h ? 1 : h,
      b = r.fullWidth,
      x = r.video,
      y = window.innerWidth <= 600,
      w = (y ? window.innerWidth - 20 : 580) * v,
      E = nt({
    id: r.id,
    type: r.type
  });
  t.useEffect(function () {
    m(!1);
  }, [r.url, r.video]);
  var k = {
    backgroundColor: c,
    marginBottom: -1,
    borderBottomColor: "dark" === d ? ee.darkgrey : ee.border,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderTopWidth: 0 === i ? 0 : 1,
    borderTopColor: "dark" === d ? ee.darkgrey : ee.border,
    borderTopStyle: "solid"
  },
      S = {
    color: s,
    fontSize: 15,
    padding: "16px 8px"
  };

  if (x) {
    var C = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/,
          n = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/,
          r = e.match(t);
      if (r) return {
        id: r[5],
        videoURL: "https://player.vimeo.com/video/".concat(r[5])
      };
      var o = e.match(n);
      return o ? {
        id: o[7],
        videoURL: "https://www.youtube.com/embed/".concat(o[7])
      } : {};
    }(x.url).videoURL;

    return n.createElement("div", {
      className: "nf-video-container video-container-".concat(E),
      style: k
    }, p || !x.url ? n.createElement("span", {
      style: S
    }, "Video not found.") : C ? n.createElement("iframe", {
      id: "player-".concat(i),
      title: "player-".concat(i),
      type: "text/html",
      width: "100%",
      height: y ? "200px" : "338px",
      src: C,
      onError: function onError() {
        return m(!0);
      },
      frameBorder: "0",
      style: {
        width: "100%",
        maxWidth: 600,
        border: "none"
      }
    }) : n.createElement("video", {
      id: "player-".concat(i),
      title: "player-".concat(i),
      width: "100%",
      height: y ? "200" : "338",
      controls: !0,
      onError: function onError() {
        return m(!0);
      },
      style: {
        width: "100%",
        maxWidth: 600,
        border: "none"
      }
    }, n.createElement("source", {
      src: x.url,
      type: "video/".concat(x.url.split(".").pop())
    }), "Your browser does not support the video tag."));
  }

  return n.createElement("div", {
    className: "nf-image-container container-".concat(E),
    style: k
  }, !p && g ? n.createElement("img", {
    alt: "",
    src: g,
    className: "nf-image ".concat(E),
    onError: function onError() {
      return m(!0);
    },
    style: {
      width: b ? "100%" : "".concat(w, "px"),
      maxWidth: "100%"
    }
  }) : n.createElement("span", {
    style: S
  }, "Image not found."));
}

function Rt(e, t) {
  if (!1 === e) return !1;
  if (e) return e;

  switch (t) {
    case "contact":
      return "Fill in fields below";

    case "files":
      return "Drop files in the box below";

    case "date":
      return "Select date";

    case "open":
      return "Write in the box below";

    case "number-scale":
      return "Pick number";

    case "selection":
      return "Select answer";

    case "single-selection":
      return "Select one";

    case "stars":
      return "Tap stars to rate";

    case "multi-selection":
      return "Select one or more";

    case "slider":
      return "Drag to select";

    case "matrix":
      return "Select one answer per row";

    case "stripe":
      return "Enter card details below";

    default:
      return !1;
  }
}

function Dt(e) {
  if (!e) return e;

  for (var t, n, r = e.length; 0 !== r;) {
    n = Math.floor(Math.random() * r), t = e[r -= 1], e[r] = e[n], e[n] = t;
  }

  return e;
}

function At() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
    t[n] = arguments[n];
  }

  return Array.prototype.slice.call(t).reduce(function (e, t) {
    return "string" == typeof t || Array.isArray(t) ? e.concat(t) : e;
  }, []).filter(Boolean).join(" ");
}

function Ft(e) {
  var t = e.form,
      r = e.block,
      o = e.isPreview,
      i = e.blockIndex,
      a = e.questionNumber,
      c = e.onFormValueChange,
      l = e.isSending,
      u = t.textColor,
      d = void 0 === u ? ee.primary : u,
      p = t.backgroundColor,
      m = void 0 === p ? ee.white : p,
      g = t.inputBackgroundColor,
      h = void 0 === g ? ee.white : g,
      v = t.inputTextColor,
      b = void 0 === v ? ee.primary : v,
      x = t.color,
      y = void 0 === x ? ee.main : x,
      w = t.theme,
      E = t.isRTL,
      k = r.multiSelect,
      S = r.inline,
      C = r.hideBox,
      N = r.questionRandomization,
      z = r.maxAnswers,
      T = r.minAnswers,
      O = r.minAnswersError,
      P = r.other,
      j = P ? [].concat(f(r.answers), [P]) : r.answers,
      q = r.value || [],
      M = "quiz" === l,
      I = !!r.answers && r.answers.some(function (e) {
    return e.isCorrect;
  });
  t.quiz && t.quiz.gradeMode && (I = !1);
  var L = nt({
    id: r.id,
    type: r.type
  });
  !N || o || M || r.shuffled || (r.shuffled = !0, Dt(r.answers));

  var R = function R(e) {
    return function () {
      if (!o && !M) {
        var t = q.includes(e.value);

        if (k) {
          if (P && e.isOther) {
            if (r.showOther = !r.showOther, !r.showOther && r.value) {
              var n = r.value.indexOf(P.input);
              n > -1 && (r.value.splice(n, 1), 0 === r.value.length && delete r.value, delete P.input, r.other = P);
            }

            return void c(r);
          }

          var i = t ? q.filter(function (t) {
            return t !== e.value;
          }) : [].concat(f(q), [e.value]);
          if (z && i.length > z) return;
          T && (i.length < T ? setTimeout(function () {
            r.error = O || "Select more answers.";
          }) : delete r.error), r.value = i, 0 === i.length && delete r.value;
        } else {
          if (P && e.isOther) return r.showOther = !r.showOther, delete r.value, delete P.input, r.other = P, void c(r);
          var a = t ? [] : [e.value];
          r.value = a, 0 === a.length && delete r.value, r.showOther && (r.showOther = !1);
        }

        c(r);
      }
    };
  };

  return n.createElement(Le, {
    id: r.id
  }, n.createElement(ot, {
    form: t,
    block: r,
    blockIndex: i,
    questionNumber: a
  }), n.createElement("div", {
    className: S ? "nf-selection-inline-container inline-container-".concat(L) : "nf-selection-container container-".concat(L)
  }, j.map(function (e, t) {
    var o = e.value,
        i = e.image,
        a = e.isOther ? r.showOther : q.includes(o),
        c = !(!M || !I) && (a ? e.isCorrect ? ee.success : ee.error : !!e.isCorrect && ee.success),
        l = {
      borderColor: c ? "".concat(c, "80") : a ? y + "80" : "dark" === w ? ee.darkgrey : ee.border,
      backgroundColor: c ? "".concat(c, "10") : a ? "".concat(y, "10") : h
    },
        u = {
      backgroundColor: a ? c || y : m,
      borderColor: a ? "transparent" : "dark" === w ? ee.white : ee.grey,
      borderRadius: k ? 2 : 16,
      marginRight: E ? 0 : S ? 10 : 12,
      marginLeft: E ? S ? 10 : 12 : 0
    },
        d = {
      fontWeight: a || c ? "500" : "400",
      color: c || (a ? y : b)
    };
    return n.createElement("button", {
      type: "button",
      key: o + t,
      onClick: R(e),
      className: At(S ? "nf-selection-inline-answer inline-answer-".concat(L) : "nf-selection-answer answer-".concat(L), a ? S ? "nf-selection-selected-inline-answer selected-inline-answer-".concat(L) : "nf-selection-selected-answer selected-answer-".concat(L) : ""),
      style: l
    }, !C && n.createElement("div", {
      className: "nf-selection-checkbox checkbox-".concat(L),
      style: u
    }, a && n.createElement(_, {
      size: 12,
      color: ee.white
    })), i ? n.createElement("div", {
      className: "nf-selection-image-answer"
    }, i.showAnswer && n.createElement("div", {
      className: "nf-answer-label label-".concat(L),
      style: s({}, d, {
        paddingBottom: 12
      }),
      dangerouslySetInnerHTML: {
        __html: Pe(o)
      }
    }), n.createElement("img", {
      src: i.url,
      height: i.size,
      alt: o,
      className: "nf-selection-image",
      style: {
        maxWidth: "100%",
        height: i.size
      }
    })) : n.createElement("div", {
      className: "nf-answer-label label-".concat(L),
      style: d,
      dangerouslySetInnerHTML: {
        __html: Pe(o)
      }
    }));
  }), r.showOther && n.createElement(wt, {
    multiline: !0,
    readOnly: o,
    onChange: function onChange(e) {
      if (P) {
        if (k) {
          r.value || (r.value = []);
          var t = r.value.indexOf(P.input);
          t > -1 ? r.value[t] = e.target.value : r.value.push(e.target.value);
        } else r.value = [e.target.value];

        P.input = e.target.value, r.other = P, c(r);
      }
    },
    label: P.label,
    value: P.input,
    required: r.isRequired,
    placeholder: P.placeholder || "",
    description: P.description,
    color: y,
    textColor: d,
    backgroundColor: m,
    inputBackgroundColor: h,
    inputTextColor: b,
    field: P
  })));
}

function Bt(e) {
  var r = e.block,
      o = e.form,
      i = e.isPreview,
      a = e.editMode,
      c = e.blockIndex,
      l = e.questionNumber,
      s = e.onFormValueChange,
      d = o.color,
      f = void 0 === d ? ee.main : d,
      p = o.textColor,
      m = void 0 === p ? ee.primary : p,
      g = o.backgroundColor,
      h = void 0 === g ? ee.white : g,
      v = r.min,
      b = r.max,
      x = r.rangeSelect,
      y = r.increment,
      w = void 0 === y ? 1 : y,
      E = t.useRef(),
      k = r.percentage || 0,
      S = r.percentage2 || 0,
      C = u(t.useState(!1), 2),
      N = C[0],
      z = C[1],
      T = u(t.useState(!1), 2),
      O = T[0],
      P = T[1],
      _ = nt({
    id: r.id,
    type: r.type
  });

  t.useEffect(function () {
    x && (r.value && !a || (r.percentage = r.defaultProgress, r.percentage2 = r.defaultProgress2, r.value = ge(r), s(r)));
  }, [x]), t.useEffect(function () {
    !r.defaultProgress || r.value && !a || (r.percentage = r.defaultProgress, r.value = ge(r));
  }, [r.defaultProgress]), t.useEffect(function () {
    !r.defaultProgress2 || r.value && !a || (r.percentage2 = r.defaultProgress2, r.value = ge(r));
  }, [r.defaultProgress2]);
  var j = {
    backgroundColor: f,
    width: "".concat(k, "%")
  };
  x && (j.left = "".concat(S, "%"), j.width = "".concat(k - S, "%"));

  var q = function q(e) {
    if (!i && E.current) {
      var t = E.current.getBoundingClientRect(),
          n = t.width,
          o = e - t.x,
          a = Math.round(o / n * 100);
      a < 0 && (a = 0), a > 100 && (a = 100), 1 !== w && (a = w * Math.round(a / w)), x && a <= S && (a = S), r.percentage = a, r.value = ge(r), s(r);
    }
  },
      M = function M(e) {
    if (!i && E.current) {
      var t = E.current.getBoundingClientRect(),
          n = t.width,
          o = e - t.x,
          a = Math.round(o / n * 100);
      a < 0 && (a = 0), a > 100 && (a = 100), 1 !== w && (a = w * Math.round(a / w)), x && a >= k && (a = k), r.percentage2 = a, r.value = ge(r), s(r);
    }
  };

  return t.useEffect(function () {
    var e = function e(_e3) {
      if (N) {
        if (_e3.touches) return void q(_e3.touches[0].clientX);
        q(_e3.clientX);
      }
    },
        t = function t() {
      N && z(!1);
    };

    return document.addEventListener("mousemove", e), document.addEventListener("touchmove", e), document.addEventListener("mouseup", t), document.addEventListener("touchend", t), function () {
      document.removeEventListener("mousemove", e), document.removeEventListener("touchmove", e), document.removeEventListener("mouseup", t), document.removeEventListener("touchend", t);
    };
  }, [N]), t.useEffect(function () {
    var e = function e(_e4) {
      if (O) {
        if (_e4.touches) return void M(_e4.touches[0].clientX);
        M(_e4.clientX);
      }
    },
        t = function t() {
      O && P(!1);
    };

    return document.addEventListener("mousemove", e), document.addEventListener("touchmove", e), document.addEventListener("mouseup", t), document.addEventListener("touchend", t), function () {
      document.removeEventListener("mousemove", e), document.removeEventListener("touchmove", e), document.removeEventListener("mouseup", t), document.removeEventListener("touchend", t);
    };
  }, [O]), n.createElement(Le, {
    id: r.id
  }, n.createElement(ot, {
    form: o,
    block: r,
    blockIndex: c,
    questionNumber: l
  }), n.createElement("div", {
    dir: "ltr",
    className: "nf-slider-container container-".concat(_)
  }, n.createElement("span", {
    className: "nf-slider-value value-".concat(_),
    style: {
      color: m
    }
  }, ge(r)), n.createElement("div", {
    ref: E,
    className: "nf-slider-line-container line-container-".concat(_),
    style: {
      backgroundColor: "".concat(f, "22")
    }
  }, n.createElement("div", {
    className: "nf-slider-line line-".concat(_),
    style: j
  }), x && n.createElement("div", {
    style: {
      backgroundColor: f,
      left: "".concat(S, "%"),
      marginLeft: -17,
      fill: h,
      zIndex: S > 90 ? 2 : 1
    },
    className: "nf-slider-thumb thumb-".concat(_),
    role: "slider",
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": S,
    "aria-labelledby": r.question,
    onMouseDown: function onMouseDown(e) {
      P(!0), M(e.clientX);
    },
    onMouseUp: function onMouseUp() {
      O && P(!1);
    },
    onTouchStart: function onTouchStart(e) {
      P(!0), M(e.touches[0].clientX);
    },
    onTouchEnd: function onTouchEnd() {
      O && P(!1);
    }
  }, n.createElement(D, null)), n.createElement("div", {
    style: {
      backgroundColor: f,
      left: "".concat(k, "%"),
      marginLeft: -17,
      fill: h
    },
    className: "nf-slider-thumb thumb-".concat(_),
    role: "slider",
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": k,
    "aria-labelledby": r.question,
    onMouseDown: function onMouseDown(e) {
      z(!0), q(e.clientX);
    },
    onMouseUp: function onMouseUp() {
      N && z(!1);
    },
    onTouchStart: function onTouchStart(e) {
      z(!0), q(e.touches[0].clientX);
    },
    onTouchEnd: function onTouchEnd() {
      N && z(!1);
    }
  }, x ? n.createElement(A, null) : n.createElement(W, null))), n.createElement("div", {
    className: "nf-slider-legend legend-".concat(_)
  }, n.createElement("span", {
    className: "nf-slider-legend-text min-text-".concat(_),
    style: {
      color: m
    }
  }, v), n.createElement("span", {
    className: "nf-slider-legend-text max-text-".concat(_),
    style: {
      color: m
    }
  }, b))));
}

function Vt(e) {
  var t = e.block,
      r = e.form,
      o = e.isPreview,
      i = e.blockIndex,
      a = e.questionNumber,
      c = e.onFormValueChange,
      l = e.conditions,
      u = r || {},
      d = u.color,
      m = void 0 === d ? ee.main : d,
      g = u.textColor,
      h = void 0 === g ? ee.primary : g,
      v = u.inputBackgroundColor,
      b = void 0 === v ? ee.white : v,
      x = u.theme,
      y = t.value,
      w = void 0 === y ? [] : y,
      E = t.columns,
      k = void 0 === E ? [] : E,
      S = t.multiSelect,
      C = t.uniqueColumn,
      N = nt({
    id: t.id,
    type: t.type
  }),
      z = function z(e) {
    var n = e.column,
        r = e.index;
    o || (S ? t.value[r].value ? t.value[r].value.includes(n.value) ? t.value[r].value = t.value[r].value.filter(function (e) {
      return e !== n.value;
    }) : t.value[r].value = [].concat(f(t.value[r].value), [n.value]) : t.value[r].value = [n.value] : t.value[r].value === n.value ? t.value[r] = s({}, t.value[r], {
      value: ""
    }) : t.value[r] = s({}, t.value[r], {
      value: n.value
    }), C && function (e) {
      var t = e.block,
          n = [];
      t.value.forEach(function (e) {
        e.value && (Array.isArray(e.value) ? n.push.apply(n, f(e.value)) : n.push(e.value));
      }), t.blockedColumns = n;
    }({
      block: t
    }), c(t, t.value[r]));
  },
      T = {
    color: h
  },
      O = {
    color: h
  };

  return n.createElement(Le, {
    id: t.id
  }, n.createElement(ot, {
    form: r,
    block: t,
    blockIndex: i,
    questionNumber: a
  }), n.createElement("div", {
    className: "nf-matrix-container container-".concat(N)
  }, n.createElement("div", {
    className: "nf-matrix-columns-container columns-container-".concat(N)
  }, n.createElement("div", {
    className: "nf-matrix-column"
  }), k.map(function (e, t) {
    return n.createElement("div", {
      key: "".concat(e.value, "-").concat(t),
      className: "nf-matrix-column column-".concat(N, "-").concat(t),
      style: O
    }, e.value);
  })), w.map(function (e, r) {
    var o = e.isRequired,
        i = e.error,
        a = e.question;
    return p(l, a) ? n.createElement("div", null) : n.createElement("div", {
      key: "".concat(e.question, "-").concat(r),
      className: "nf-matrix-rows-container rows-container-".concat(N, "-").concat(r),
      id: e.id
    }, n.createElement("div", {
      className: "nf-matrix-row row-".concat(N, "-").concat(r),
      style: T
    }, n.createElement("span", {
      className: "nf-matrix-row-text row-text-".concat(N, "-").concat(r)
    }, n.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: Pe(e.question)
      }
    }), " ", o && n.createElement("span", {
      className: "nf-matrix-required"
    }, "*"))), k.map(function (o, a) {
      var c = C && t.blockedColumns || [],
          l = Array.isArray(e.value) ? e.value.includes(o.value) : e.value === o.value,
          s = !l && c.includes(o.value),
          u = {
        backgroundColor: l ? m : b,
        borderColor: i ? ee.error : l ? "transparent" : "dark" === x ? ee.white : ee.grey,
        borderRadius: S ? 2 : 16,
        opacity: s ? .4 : 1,
        cursor: s ? "not-allowed" : "pointer"
      };
      return n.createElement("div", {
        key: "".concat(o.value, "-").concat(a),
        className: "nf-matrix-column column-".concat(N, "-").concat(r),
        style: {
          backgroundColor: "".concat(m, "05"),
          padding: "16px 0"
        }
      }, n.createElement("div", {
        onClick: function onClick() {
          return !s && z({
            column: o,
            index: r
          });
        },
        className: "nf-matrix-checkbox checkbox-".concat(N, "-").concat(r),
        style: u
      }, l && n.createElement(_, {
        size: 14,
        color: ee.white
      })));
    }));
  })));
}

var Wt = ".nf-matrix-container{width:100%;display:flex;flex-direction:column;background-color:transparent;box-sizing:border-box;padding:28px 20px 28px 16px;max-width:600px}.nf-matrix-columns-container{width:100%;display:flex;flex-direction:row;margin-bottom:12px}.nf-matrix-column{font-size:14px;line-height:1.5;flex:1;display:flex;align-items:center;justify-content:center}.nf-matrix-rows-container{width:100%;display:flex;flex-direction:row;margin-bottom:16px}.nf-matrix-row{flex:1;display:flex;align-items:center;justify-content:flex-start}.nf-matrix-row-text{font-size:14px;line-height:1.5;padding:4px;box-sizing:border-box}.nf-matrix-checkbox{cursor:pointer;display:flex;flex-shrink:0;flex-direction:column;align-items:center;justify-content:center;width:20px;height:20px;border-width:1px;border-style:solid;box-shadow:2px 2px 8px 0 rgba(29,36,86,.06);box-sizing:border-box}.nf-matrix-required{font-size:14px;font-weight:500;color:".concat(ee.required, "}@media (max-width:600px){.nf-matrix-container{padding:28px 16px 24px 16px}}"),
    Ht = n.lazy(function () {
  return new Promise(function (e) {
    e(require("./index-63ffe953.js"));
  });
});

function Ut(e) {
  var r = e.block,
      o = e.form,
      i = e.blockIndex,
      a = e.questionNumber,
      c = e.onFormValueChange,
      l = e.isPreview,
      s = (o || {}).color,
      u = void 0 === s ? ee.main : s,
      d = nt({
    id: r.id,
    type: r.type
  });
  return n.createElement(Le, {
    id: r.id
  }, n.createElement(ot, {
    form: o,
    block: r,
    blockIndex: i,
    questionNumber: a
  }), n.createElement("div", {
    className: "nf-stripe-wrapper wrapper-".concat(d)
  }, n.createElement("div", {
    className: "nf-stripe-container container-".concat(d)
  }, n.createElement(t.Suspense, {
    fallback: n.createElement("div", {
      style: {
        height: 50
      }
    })
  }, n.createElement(Ht, {
    form: o,
    block: r,
    updateCardStatus: function updateCardStatus(e) {
      r.value = e, c(r);
    },
    isPreview: l
  })), n.createElement("div", {
    className: "nf-stripe-label label-".concat(d),
    style: {
      color: u
    }
  }, n.createElement(V, {
    size: 14,
    fill: u
  }), n.createElement("span", {
    style: {
      marginLeft: 4
    }
  }, "Secured by", " ", n.createElement("a", {
    href: "https://stripe.com",
    rel: "noopener noreferrer",
    target: "_blank",
    style: {
      textDecoration: "none",
      color: u,
      fontWeight: "bold"
    }
  }, "Stripe"))))));
}

var Jt = function Jt(e, t) {
  var r = t.conditions;
  if (e.isHidden) return n.createElement("div", null);
  if (p(r, e.question || e.placeholder)) return null;

  switch (e.badge = Rt(e.badge, e.type), e.type) {
    case "image":
      return n.createElement(Lt, t);

    case "description":
      return n.createElement(at, t);

    case "number-scale":
      return n.createElement(Nt, t);

    case "stars":
      return n.createElement(Tt, t);

    case "contact":
      return n.createElement(Pt, t);

    case "open":
      return n.createElement(Ct, t);

    case "selection":
    case "single-selection":
      return n.createElement(Ft, t);

    case "multi-selection":
      return e.multiSelect = !0, n.createElement(Ft, t);

    case "date":
      return n.createElement(It, t);

    case "files":
      return n.createElement(jt, t);

    case "slider":
      return n.createElement(Bt, t);

    case "matrix":
      return n.createElement(Vt, t);

    case "stripe":
      return n.createElement(Ut, t);

    default:
      return null;
  }
},
    Gt = function Gt(e) {
  for (var t = e.form, n = e.allBlocks, r = e.pages, o = e.blockIndex, i = e.currentPage, a = o + 1, c = o + 1, l = 0; l < i; l++) {
    a += r[l].blocks.length, c += r[l].blocks.length;
  }

  for (var s = 0; s < c; s++) {
    !n[s] || "description" !== n[s].type && "image" !== n[s].type && "video" !== n[s].type || (a -= 1), n[s] && !m(t, n[s].question) && (a -= 1), "contact" !== n[s].type || n[s].question || (a -= 1);
  }

  return a;
},
    Yt = function Yt(e) {
  var t = e.pages || [],
      n = [];
  return t.forEach(function (e) {
    n.push.apply(n, f(e.blocks));
  }), n;
};

function Xt(e) {
  var t = e.form,
      r = t.quiz,
      o = void 0 === r ? {} : r,
      i = o.hideCompletedScreen,
      a = o.showOnlyQuizScore,
      c = t.color,
      l = void 0 === c ? ee.main : c,
      s = t.submitTextColor,
      u = void 0 === s ? ee.white : s,
      d = t.quizScoreLabel,
      f = void 0 === d ? "Quiz score" : d,
      p = {
    backgroundColor: l,
    color: u
  },
      m = {
    backgroundColor: l,
    color: u
  };
  return n.createElement(n.Fragment, null, !i && n.createElement(_e, {
    form: t,
    status: "complete",
    style: {
      padding: "50px 20px"
    }
  }), n.createElement("div", {
    className: "quiz-score-container",
    style: p
  }, n.createElement("span", {
    className: "quiz-score",
    style: m
  }, f, ": ", t.quizScore, a ? "" : "/".concat(t.maxQuizScore))));
}

function $t(e) {
  if (!e) return !1;
  var t = document.getElementById(e);
  return !!t && (t.scrollIntoView(), !0);
}

function Qt(e) {
  var r = e.onFormSubmit,
      o = e.form,
      i = e.isSending,
      c = e.setSendingError,
      l = e.isPreview,
      s = e.onPageChange,
      f = e.uploadingProgress,
      p = e.editMode,
      m = e.submit,
      g = e.scrollFormToTop,
      h = d(e, ["onFormSubmit", "form", "isSending", "setSendingError", "isPreview", "onPageChange", "uploadingProgress", "editMode", "submit", "scrollFormToTop"]),
      v = o || {},
      b = v.color,
      x = v.poweredBy,
      y = v.backgroundColor,
      w = v.tintBackgroundColor,
      E = v.disableTintBackgroundColor,
      k = v.logo,
      C = v.isNativeSlides,
      N = tt(o, h.onFormValueChange),
      z = N.conditions,
      T = N.onFormValueChange,
      O = u(t.useState(l ? 0 : h.currentPage || o.startFromPage || (o.saveProgress && o.currentPage && o.currentPage < o.pages.length ? o.currentPage : 0) || 0), 2),
      P = O[0],
      _ = O[1];
  t.useEffect(function () {
    void 0 !== h.currentPage && P !== h.currentPage && (o.saveProgress && (o.currentPage = h.currentPage, Qe(o)), _(h.currentPage));
  }, [h.currentPage]);

  var j = 0 === function (e, t, n) {
    var r = e.pages || [],
        o = 0;
    return r.forEach(function (e) {
      e.blocks && e.blocks.forEach(function (e) {
        if (!t || "image" !== e.type && "description" !== e.type && "video" !== e.type) if ("contact" !== e.type) o += 1;else {
          if (n) return void (o += 1);
          var r = e.value || [];
          o += r.length;
        }
      });
    }), o;
  }(o),
      q = 0 === function (e, t) {
    if (!e) return 0;
    if (!e.blocks) return 0;
    var n = 0;
    return e.blocks.forEach(function (e) {
      if (!t || "image" !== e.type && "description" !== e.type && "video" !== e.type) if ("contact" !== e.type) n += 1;else {
        var r = e.value || [];
        n += r.length;
      }
    }), n;
  }(o.pages[P]),
      M = function M(e, t) {
    if (!(i && "quiz" !== i || e < 0)) if (e === o.pages.length && !t || "send" === t) {
      if ("quiz" === i) return;
      I();
    } else {
      if (e < P && !t || "back" === t) return C || g(), _(e), void (s && s(e));
      var n = Re(o.pages[P], o, !0),
          r = n.isCompleted,
          a = n.hasError,
          l = $t(n.firstErrorQuestionID);
      if (a) return c({}), void (l || g());
      if (!r) return c({}), void (l || g());
      _(e), C || g(), s && s(e);
    }
  };

  window.nf_form_change_page = M, window.nf_form_set_page = _, window.nf_form_current_page = P, o.currentPage = P || o.currentPage || 0;

  var I = function I() {
    var e, t, n, l, s, u;
    return a.async(function (d) {
      for (;;) {
        switch (d.prev = d.next) {
          case 0:
            if (!i) {
              d.next = 2;
              break;
            }

            return d.abrupt("return");

          case 2:
            if (e = !0, t = !1, n = !1, !o.allowEmptyForm) {
              d.next = 8;
              break;
            }

            return r(), d.abrupt("return");

          case 8:
            if (!o.customSubmitFormURL) {
              d.next = 29;
              break;
            }

            if (!o.legal) {
              d.next = 15;
              break;
            }

            if (o.legal.acceptedTimestamp) {
              d.next = 15;
              break;
            }

            return o.legal.error = !0, c({}), $t("nf-policy-terms"), d.abrupt("return");

          case 15:
            if (!o.recaptcha || o.acceptedRecaptcha) {
              d.next = 20;
              break;
            }

            return c({}), o.recaptchaError = !0, $t("nf-recaptcha"), d.abrupt("return");

          case 20:
            if (!o.signature) {
              d.next = 25;
              break;
            }

            if (o.signature.signedTimestamp) {
              d.next = 25;
              break;
            }

            return c({}), $t("nf-signature"), d.abrupt("return");

          case 25:
            return d.next = 27, a.awrap(S(o));

          case 27:
            s = d.sent, Object.assign(o, s);

          case 29:
            if ((o.pagesStack || o.pages || []).forEach(function (r) {
              "number" == typeof r && (r = o.pages[r]);
              var i = Re(r, o, !0),
                  a = i.isCompleted,
                  c = i.hasValues,
                  s = i.hasError,
                  u = i.firstErrorQuestionID;
              u && (l = u), s && (n = !0), !t && c && (t = !0), a || (e = !1);
            }), u = $t(l), !n) {
              d.next = 37;
              break;
            }

            return c({}), u || g(), $(o), d.abrupt("return");

          case 37:
            if (t) {
              d.next = 42;
              break;
            }

            return c("Can't submit an empty form."), u || g(), $(o), d.abrupt("return");

          case 42:
            if (e) {
              d.next = 47;
              break;
            }

            return c({}), u || g(), $(o), d.abrupt("return");

          case 47:
            r();

          case 48:
          case "end":
            return d.stop();
        }
      }
    });
  };

  return window._nf_send_form = I, t.useEffect(function () {
    m && !o.submit && setTimeout(function () {
      o.submit = !0, I();
    });
  }, [m]), m && !o.submit ? null : !j && q && o.isNativeSlides ? "hide" !== x ? n.createElement(je, {
    form: o
  }) : null : n.createElement("div", {
    className: "nf-form-container",
    id: "nf-form-container",
    style: {
      backgroundColor: y || "#ffffff"
    }
  }, n.createElement("div", {
    className: "nf-questions-container",
    style: {
      backgroundColor: E ? "transparent" : w || "".concat(b || ee.main, "02")
    }
  }, "quiz" === i && n.createElement(Xt, {
    form: o
  }), k && n.createElement(Ye, {
    logo: k,
    form: o
  }), j && n.createElement("div", {
    className: "nf-empty-form"
  }, n.createElement("span", {
    className: "nf-empty-form-text"
  }, "This form has no questions, yet.")), !j && q && n.createElement("div", {
    className: "nf-empty-form"
  }, n.createElement("span", {
    className: "nf-empty-form-text"
  }, "This page has no questions, yet.")), function (e) {
    var t = e.form,
        n = e.isPreview,
        r = e.currentPage,
        o = e.conditions,
        i = e.onFormValueChange,
        a = e.editMode,
        c = e.isSending,
        l = t.pages || [],
        s = Yt(t);
    return ((l[r] || {}).blocks || []).map(function (e, u) {
      var d = {
        form: t,
        block: e,
        isPreview: n,
        blockIndex: u,
        conditions: o,
        onFormValueChange: i,
        editMode: a,
        isSending: c,
        questionNumber: Gt({
          form: t,
          allBlocks: s,
          pages: l,
          blockIndex: u,
          currentPage: r
        }),
        key: e.type + r + "block" + u
      };
      return Jt(e, d);
    });
  }({
    form: o,
    isPreview: l,
    currentPage: P,
    conditions: z,
    onFormValueChange: T,
    editMode: p,
    isSending: i
  }), n.createElement(Je, {
    sendForm: I,
    setSendingError: c,
    isSending: i,
    isPreview: l,
    currentPage: P,
    changePageIndex: M,
    uploadingProgress: f,
    form: o
  })), "hide" !== x && n.createElement(je, {
    form: o
  }));
}

var Kt = function Kt(e) {
  var r = e.children,
      o = e.variant,
      i = e.onClose,
      a = e.action,
      c = e.removable,
      l = e.id,
      s = e.duration,
      u = {},
      d = t.useRef(),
      f = function f() {
    d && d.current && d.current.classList.add("nf-toast-out-animation"), setTimeout(i, 280);
  };

  switch (t.useEffect(function () {
    s && setTimeout(f, s);
  }), o) {
    case "success":
      u.backgroundColor = ee.toastSuccess;
      break;

    case "warning":
      u.backgroundColor = ee.toastWarning;
      break;

    case "error":
      u.backgroundColor = ee.toastError;
      break;

    case "info":
      u.backgroundColor = ee.toastInfo;
      break;

    default:
      u.backgroundColor = ee.white;
  }

  return n.createElement("div", {
    className: "nf-toast-container",
    style: u,
    id: l,
    ref: d
  }, n.createElement("div", {
    style: {
      paddingRight: 14,
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }
  }, n.createElement(M, null)), n.createElement("span", {
    style: {
      color: "#ffffff",
      fontSize: 14,
      lineHeight: "22px",
      fontWeight: "500"
    }
  }, r), (a || c) && n.createElement("div", {
    style: {
      marginLeft: "auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }
  }, c && n.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginLeft: 16,
      cursor: "pointer",
      paddingLeft: 16,
      borderLeft: "1px solid #ffffff80"
    },
    onClick: f
  }, n.createElement(P, {
    size: 18,
    color: ee.white
  }))));
},
    Zt = function Zt(e) {
  var t = e.verticalPosition,
      r = void 0 === t ? "top" : t,
      o = e.toasts,
      i = void 0 === o ? [] : o,
      a = e.children,
      c = {
    margin: e.margin || 0
  };

  switch (r) {
    case "top":
      c.top = 30;
      break;

    case "bottom":
      c.bottom = 30;
  }

  return n.createElement("div", {
    className: "nf-toasts-wrapper",
    style: c
  }, a, i.map(function (e) {
    var t = e.id,
        r = e.variant,
        o = e.content,
        i = e.onClose,
        a = e.removable,
        c = e.action;
    return n.createElement(Kt, {
      key: t,
      variant: r,
      onClose: i,
      removable: a,
      action: c
    }, o);
  }));
};

function en(e) {
  for (var t = "", n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = n.length, o = 0; o < e; o++) {
    t += n.charAt(Math.floor(Math.random() * r));
  }

  return t;
}

function tn() {
  return en((e = 8, t = 12, Math.floor(Math.random() * (t - e + 1)) + e));
  var e, t;
}

function nn(e, t) {
  var n,
      r,
      o = e - t;
  return r = Math.floor(o / 1e3), n = Math.floor(r / 60), r %= 60, 0 === (n %= 60) ? r + " seconds" : n + " min " + r + " s";
}

function rn() {
  if (!window || !window.location) return "";
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /windows phone/i.test(e) ? "Windows Phone" : /android/i.test(e) ? "Android" : /iPad|iPhone|iPod/.test(e) && !window.MSStream ? "iOS" : -1 !== window.navigator.userAgent.indexOf("Mac") ? "Mac" : -1 !== window.navigator.userAgent.indexOf("X11") ? "UNIX" : -1 !== window.navigator.userAgent.indexOf("Linux") ? "Linux" : -1 !== window.navigator.userAgent.indexOf("Windows NT 10.0") ? "Windows 10" : -1 !== window.navigator.userAgent.indexOf("Windows NT 6.2") ? "Windows 8" : -1 !== window.navigator.userAgent.indexOf("Windows NT 6.1") ? "Windows 7" : -1 !== window.navigator.userAgent.indexOf("Windows NT 6.0") ? "Windows Vista" : -1 !== window.navigator.userAgent.indexOf("Windows NT 5.1") ? "Windows XP" : -1 !== window.navigator.userAgent.indexOf("Windows NT 5.0") ? "Windows 2000" : window.navigator.userAgent.includes("Windows") ? "Windows" : "";
}

function on() {
  if (!window || !window.location) return "";
  var e = window.navigator.userAgent;
  return e.match(/chrome|chromium|crios/i) ? "Chrome" : e.match(/firefox|fxios/i) ? "Firefox" : e.match(/safari/i) ? "Safari" : e.match(/opr\//i) ? "Opera" : e.match(/edg/i) ? "Edge" : "";
}

function an() {
  return window && window.location ? window.location !== window.parent.location ? window.document.referrer : window.document.location.href : "";
}

var cn = function cn(e) {
  var t = e.form,
      n = function (e) {
    var t = e.mapQuestionToCustomer,
        n = void 0 === t ? {} : t,
        r = {};
    return (e.pages || []).forEach(function (e) {
      (e.blocks || []).forEach(function (e) {
        "contact" === e.type && (e.value || []).forEach(function (e) {
          var t = e.question || e.placeholder || e.title || "";
          if (n[t]) r[n[t]] = e.value;else {
            var o = e.type || Se(t);
            "tel" === o && (o = "phone"), !re[o] || r[o] ? !r[o] && re[t.toLowerCase()] && (r[o] = e.value) : r[o] = e.value;
          }
        });

        if ("open" === e.type) {
          var t = e.question || e.placeholder || "";
          if (n[t]) return void (r[n[t]] = e.value);
          var o = e.inputType || Se(t);
          if ("tel" === o && (o = "phone"), re[o] && !r[o]) return void (r[o] = e.value);
          !r[o] && re[t.toLowerCase()] && (r[o] = e.value);
        }
      });
    }), r;
  }(t),
      r = t.extraData || {};

  t.customer = t.customer || {}, r.avatar && (t.customer.avatar = r.avatar), r.phone && (t.customer.phone = r.phone), r.Phone && (t.customer.Phone = r.Phone), r.user_id && (t.customer.user_id = r.user_id), r.intercom_user_id && (t.customer.intercom_user_id = r.intercom_user_id), r.Email && (t.customer.email = r.Email), r.email && (t.customer.email = r.email), r.Name && (t.customer.name = r.Name), r.name && (t.customer.name = r.name), t.completedLocation && "object" == typeof t.completedLocation && Object.keys(t.completedLocation).forEach(function (e) {
    "regionName" !== e ? re[e] && (t.customer[e] = t.completedLocation[e]) : t.customer.state = t.completedLocation[e];
  }), Object.keys(n).forEach(function (e) {
    t.customer[e] = n[e];
  });
},
    ln = function ln(e, t, n, r) {
  return a.async(function (o) {
    for (;;) {
      switch (o.prev = o.next) {
        case 0:
          return o.abrupt("return", new Promise(function (o, i) {
            var c, l, s, u;
            return a.async(function (d) {
              for (;;) {
                switch (d.prev = d.next) {
                  case 0:
                    if (c = e.license, e.id && c) {
                      d.next = 3;
                      break;
                    }

                    return d.abrupt("return", !1);

                  case 3:
                    l = 0, s = function s(o) {
                      return a.async(function (s) {
                        for (;;) {
                          switch (s.prev = s.next) {
                            case 0:
                              return s.next = 2, a.awrap(new Promise(function (s) {
                                try {
                                  var u = t[o],
                                      d = u.name.split("."),
                                      f = d[d.length - 1] || "";
                                  u.id = en(5) + "." + f;
                                  var p = window.firebase.storage().ref().child("images/".concat(c, "/").concat(e.formName, "/").concat(e.id, "/").concat(u.id)).put(u.file, {
                                    contentType: u.type,
                                    cacheControl: "public,max-age=31536000"
                                  });
                                  p.on("state_changed", function (e) {
                                    r(Math.round((l + e.bytesTransferred) / n * 100));
                                  }, function () {
                                    s();
                                  }, function () {
                                    return a.async(function (e) {
                                      for (;;) {
                                        switch (e.prev = e.next) {
                                          case 0:
                                            return e.next = 2, a.awrap(p.snapshot.ref.getDownloadURL());

                                          case 2:
                                            u.url = e.sent, l += p.snapshot.bytesTransferred, delete u.file, s();

                                          case 6:
                                          case "end":
                                            return e.stop();
                                        }
                                      }
                                    });
                                  });
                                } catch (e) {
                                  i(e);
                                }
                              }));

                            case 2:
                            case "end":
                              return s.stop();
                          }
                        }
                      });
                    }, u = 0;

                  case 6:
                    if (!(u < t.length)) {
                      d.next = 12;
                      break;
                    }

                    return d.next = 9, a.awrap(s(u));

                  case 9:
                    u++, d.next = 6;
                    break;

                  case 12:
                    o();

                  case 13:
                  case "end":
                    return d.stop();
                }
              }
            });
          }));

        case 1:
        case "end":
          return o.stop();
      }
    }
  });
};

function sn(e) {
  var t = e.pages || [],
      n = [],
      r = 0;
  return t.forEach(function (e) {
    (e.blocks || []).forEach(function (e) {
      e.files && e.files.forEach(function (e) {
        e.size && (r += e.size), n.push(e);
      });
    });
  }), {
    files: n,
    totalSize: r
  };
}

var un = function un(e) {
  window.fbq && window.fbq("track", "".concat(e.label, " - Form Opened"), {
    form: e.label
  });
},
    dn = function dn(e) {
  window.fbq && window.fbq("track", "".concat(e.label, " - Form Completed"), {
    form: e.label
  });
},
    fn = function fn(e, t) {
  return e ? (t && "object" == typeof t && Object.keys(t).forEach(function (n) {
    t[n] && (e += e.indexOf("?") > -1 ? "&" : "?", e += encodeURIComponent(n) + "=" + encodeURIComponent(t[n]));
  }), e) : "";
},
    pn = function pn(e, t) {
  var n = e.extraData || {},
      r = n["Quiz score"] || 0;
  r += t, n["Quiz score"] = r, e.extraData = n;
},
    mn = function mn(e) {
  var t = 0,
      n = 0;
  (e.pages || []).forEach(function (r) {
    (r.blocks || []).forEach(function (r) {
      if (r.answers && r.answers.some(function (e) {
        return e.isCorrect;
      })) {
        var o = r.addQuizPoints,
            i = void 0 === o ? 1 : o,
            a = r.oneCorrectAnswerToAccept,
            c = r.answers.filter(function (e) {
          return e.isCorrect;
        }).length;
        n += i;
        var l = 0,
            s = 0;
        r.value && r.answers.forEach(function (n) {
          var o = r.value.includes(n.value);
          if (n.quizPoints && o) return t += n.quizPoints, void pn(e, n.quizPoints);
          o && n.isCorrect && l++, o && !n.isCorrect && s++;
        }), (a && l > 0 || l === c && 0 === s) && (t += i, pn(e, i));
      }
    });
  }), e.quizScore = t, e.maxQuizScore = n;
},
    gn = function gn(e) {
  var t = e.cx,
      r = e.cy,
      o = e.midAngle,
      i = e.innerRadius,
      a = e.outerRadius,
      c = e.percent,
      l = i + .5 * (a - i),
      s = t + l * Math.cos(-o * Math.PI / 180),
      u = r + l * Math.sin(-o * Math.PI / 180);
  return c ? n.createElement("text", {
    x: s,
    y: u,
    fill: "white",
    textAnchor: s > t ? "start" : "end",
    dominantBaseline: "central",
    style: {
      fontSize: "14px",
      fontWeight: "500"
    }
  }, "".concat(Number.parseFloat(c).toFixed(0), "%")) : null;
};

function hn(e) {
  var t = e.form,
      r = e.legend,
      o = e.colors,
      i = void 0 === o ? [] : o,
      a = t.textColor,
      c = void 0 === a ? i.primary : a,
      l = {
    width: "100%",
    boxSizing: "border-box",
    lineHeight: 1.5,
    padding: "0 12px",
    fontSize: 14,
    color: c
  },
      s = {
    width: "50px",
    textAlign: "right",
    padding: "0 4px",
    fontSize: 14,
    color: c,
    fontWeight: "500"
  },
      u = {
    width: "50px",
    textAlign: "right",
    padding: "0 4px",
    fontSize: 12,
    color: "".concat(c, "88")
  };
  return n.createElement("div", {
    className: "nf-legend-container"
  }, r.map(function (e, t) {
    var r = e.name,
        o = e.count,
        a = void 0 === o ? 0 : o,
        c = e.percent,
        d = void 0 === c ? 0 : c;
    return 0 === d ? null : n.createElement("div", {
      key: r,
      className: "nf-legend-row"
    }, n.createElement("div", {
      className: "nf-legend-color",
      style: {
        backgroundColor: i[t % i.length]
      }
    }), n.createElement("span", {
      style: l
    }, r), n.createElement("span", {
      style: s
    }, a), n.createElement("span", {
      style: u
    }, d, "%"));
  }));
}

var vn = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#f44336", "#E91E63", "#9C27B0"];

function bn(e) {
  var r = e.form,
      o = e.item,
      i = e.index,
      a = e.showCharts,
      c = window.Recharts,
      l = r.textColor,
      s = void 0 === l ? ee.primary : l,
      d = r.backgroundColor,
      f = void 0 === d ? ee.white : d,
      p = r.color,
      m = void 0 === p ? ee.main : p,
      g = r.theme,
      h = window.innerWidth <= 600,
      v = o.question,
      b = o.answers,
      x = void 0 === b ? [] : b,
      y = o.highestValue,
      w = x.some(function (e) {
    return e.count > 0;
  }),
      E = u(t.useState(a), 2),
      k = E[0],
      S = E[1],
      C = u(t.useState(), 2),
      N = C[0],
      z = C[1],
      T = {
    backgroundColor: f,
    border: "1px solid ".concat("dark" === g ? ee.darkgrey : ee.border)
  },
      O = {
    fontSize: 14.5,
    padding: "20px 16px",
    color: s,
    fontWeight: "500",
    lineHeight: 1.5
  },
      P = {
    fontSize: 14,
    padding: "16px",
    color: "".concat(s, "99")
  },
      _ = {
    backgroundColor: "".concat(m, "06"),
    borderTop: "1px solid ".concat("dark" === g ? ee.darkgrey : ee.border),
    borderBottom: "1px solid ".concat("dark" === g ? ee.darkgrey : ee.border)
  };
  return n.createElement("div", {
    className: "nf-answers-container",
    style: T
  }, n.createElement("span", {
    style: O
  }, n.createElement("span", {
    className: "nf-answers-number",
    style: {
      color: m
    }
  }, i + 1, ")", " "), n.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: Pe(v)
    }
  })), n.createElement("div", {
    className: "nf-answers-header-container",
    style: _
  }, ["Answer", "Votes (%)", "Votes"].map(function (e, t) {
    return n.createElement("div", {
      className: "nf-answers-header nf-answers-header-".concat(t + 1),
      key: t,
      style: {
        flex: 1 === t ? 4 : 1,
        justifyContent: 0 === t ? "flex-start" : "flex-end",
        color: "".concat(s, "aa")
      }
    }, e);
  })), 0 === x.length && n.createElement("span", {
    style: P
  }, "No answers, yet."), x.map(function (e, t) {
    var r = t === x.length - 1 && !a,
        o = x.length > 1 && e.count > 0 && e.highest,
        i = {
      borderBottom: "1px solid ".concat(r ? "transparent" : "dark" === g ? ee.darkgrey : ee.border)
    },
        c = {
      fontSize: "14px",
      flex: 4,
      lineHeight: 1.5,
      color: o ? ee.highest : s
    },
        l = {
      fontSize: "14px",
      flex: 1,
      lineHeight: 1.5,
      textAlign: "right",
      paddingLeft: "4px",
      color: o ? ee.highest : s
    };
    return n.createElement("div", {
      key: t,
      className: "nf-answers-row",
      style: i
    }, n.createElement("span", {
      style: c,
      className: "nf-answers-row-name"
    }, e.name), n.createElement("span", {
      style: l,
      className: "nf-answers-row-percent"
    }, e.percent || 0, "%"), n.createElement("span", {
      style: l,
      className: "nf-answers-row-count"
    }, e.count || 0));
  }), a && w && x.length > 0 && n.createElement("div", {
    className: "nf-answers-actions-container"
  }, n.createElement("div", {
    className: "nf-answers-icon-button",
    style: {
      border: "1px solid ".concat(k ? ee.blue : ee.border)
    },
    onClick: function onClick() {
      return S(!k);
    }
  }, n.createElement(H, {
    size: 16,
    fill: k ? ee.blue : ee.grey
  })), n.createElement("div", {
    className: "nf-answers-icon-button",
    style: {
      border: "1px solid ".concat(N ? ee.blue : ee.border)
    },
    onClick: function onClick() {
      return z(!N);
    }
  }, n.createElement(U, {
    size: 16,
    fill: N ? ee.blue : ee.grey
  }))), k && c && a && w && n.createElement("div", {
    className: "nf-answers-chart-container"
  }, n.createElement(c.PieChart, {
    width: 220,
    height: 220
  }, n.createElement(c.Pie, {
    data: x,
    labelLine: !1,
    outerRadius: 100,
    label: gn,
    fill: "#8884d8",
    dataKey: "count"
  }, x.map(function (e, t) {
    return n.createElement(c.Cell, {
      key: "cell-".concat(t),
      fill: vn[t % vn.length]
    });
  }))), n.createElement(hn, {
    form: r,
    legend: x,
    colors: vn
  })), N && c && a && w && n.createElement("div", {
    className: "nf-answers-chart-container"
  }, n.createElement(c.BarChart, {
    width: h ? .84 * window.innerWidth : 500,
    height: h ? 200 : 300,
    data: x,
    margin: {
      top: 0,
      right: 10,
      left: -25,
      bottom: 0
    }
  }, n.createElement(c.CartesianGrid, {
    strokeDasharray: "1 1"
  }), n.createElement(c.XAxis, {
    dataKey: "name"
  }), n.createElement(c.YAxis, {
    domain: [0, 1.25 * y]
  }), n.createElement(c.Tooltip, null), n.createElement(c.Bar, {
    dataKey: "count",
    fill: "#0088FE"
  }))));
}

function xn(e) {
  var r = e.form,
      o = r.textColor,
      i = void 0 === o ? ee.primary : o,
      c = r.color,
      l = void 0 === c ? ee.main : c,
      s = r.tintBackgroundColor,
      d = r.disableTintBackgroundColor,
      f = r.poll.hideCompletedScreen,
      p = u(t.useState(), 2),
      m = p[0],
      g = p[1];
  return t.useEffect(function () {
    var e;
    a.async(function (t) {
      for (;;) {
        switch (t.prev = t.next) {
          case 0:
            return t.next = 2, a.awrap(O(r));

          case 2:
            e = t.sent, g(e);

          case 4:
          case "end":
            return t.stop();
        }
      }
    });
  }, []), m ? 0 === m.summary.length ? n.createElement(_e, {
    form: r,
    status: "complete"
  }) : n.createElement("div", {
    className: "nf-poll-container",
    style: {
      backgroundColor: d ? "transparent" : s || "".concat(l || ee.main, "02")
    }
  }, n.createElement("div", {
    className: "nf-poll-wrapper"
  }, !f && n.createElement(_e, {
    form: r,
    status: "complete",
    style: {
      padding: "40px 20px"
    }
  }), n.createElement("span", {
    style: {
      fontSize: 13,
      color: i,
      padding: "4px"
    }
  }, "Number of answers: ", n.createElement("strong", {
    style: {
      color: l
    }
  }, m.total)), m.summary.map(function (e, t) {
    return n.createElement(bn, {
      key: t,
      item: e,
      index: t,
      showCharts: m.total > 0,
      form: r
    });
  })), "hide" !== r.poweredBy && n.createElement(je, {
    form: r
  })) : n.createElement(Y, null);
}

var yn = function yn(e) {
  var r = e.form,
      o = void 0 === r ? {} : r,
      i = e.isPreview,
      c = e.editMode,
      l = e.testMode,
      s = e.editTask,
      f = e.isTemplate,
      p = e.onSend,
      m = e.isLive,
      g = e.showError,
      v = e.currentPage,
      b = e.onPageChange,
      y = e.submit,
      w = e.showPollResults,
      E = d(e, ["form", "isPreview", "editMode", "testMode", "editTask", "isTemplate", "onSend", "isLive", "showError", "currentPage", "onPageChange", "submit", "showPollResults"]),
      k = o.label,
      S = !(!i || !o.quiz) && "quiz",
      C = u(t.useState(!1), 2),
      N = C[0],
      T = C[1],
      O = u(t.useState(S), 2),
      P = O[0],
      _ = O[1],
      j = u(t.useState(), 2),
      q = j[0],
      M = j[1];
  t.useEffect(function () {
    document.fonts && document.fonts.ready && document.fonts.ready.then(function () {
      $(o, "form_font_loaded");
    }), function (e) {
      var t = JSON.stringify({
        nf_event: {
          event: "form_loaded",
          form: JSON.stringify(e)
        }
      });
      $(e, "form_loaded"), Z(t);
    }(o);
  }, []), t.useEffect(function () {
    g && g(!1), T(!1), _(S);
  }, [o, g]);

  var I = function I() {
    var e = document.getElementById("top-scroll");
    e && e.scrollIntoView();
  };

  t.useEffect(function () {
    window.INTERCOM_MESSENGER_SHEET_LIBRARY && window.INTERCOM_MESSENGER_SHEET_LIBRARY.setTitle(k || "NativeForms");
  }, [c, i, f, k]);
  var L;
  return "submit" === P ? n.createElement(Y, null) : "poll" === P || w && o.poll ? n.createElement(xn, {
    form: o
  }) : oe.includes(P) ? n.createElement(_e, {
    form: o,
    status: P
  }) : "quiz" === P && o.quiz.skipSummary ? n.createElement("div", null, n.createElement(Xt, {
    form: o
  })) : n.createElement(n.Fragment, null, n.createElement("div", {
    className: "nf-form-wrapper"
  }, n.createElement("div", {
    id: "top-scroll",
    style: {
      width: 0,
      height: 0
    }
  }), n.createElement(Qt, Object.assign({
    isPreview: i,
    isSending: P,
    onFormSubmit: function onFormSubmit() {
      var e, t, n, r, u, d, g, v, w, k, C;
      return a.async(function (N) {
        for (;;) {
          switch (N.prev = N.next) {
            case 0:
              if (!i && !s) {
                N.next = 2;
                break;
              }

              return N.abrupt("return");

            case 2:
              if ("sending" !== P) {
                N.next = 4;
                break;
              }

              return N.abrupt("return");

            case 4:
              if (o.quiz && mn(o), !o.recaptcha || o.acceptedRecaptcha) {
                N.next = 10;
                break;
              }

              return T({}), o.recaptchaError = !0, $t("nf-recaptcha"), N.abrupt("return");

            case 10:
              if (!o.legal) {
                N.next = 16;
                break;
              }

              if (o.legal.acceptedTimestamp) {
                N.next = 16;
                break;
              }

              return o.legal.error = !0, T({}), $t("nf-policy-terms"), N.abrupt("return");

            case 16:
              if (!o.signature) {
                N.next = 22;
                break;
              }

              if (o.signature.signedTimestamp) {
                N.next = 22;
                break;
              }

              return o.signature.error = !0, T({}), $t("nf-signature"), N.abrupt("return");

            case 22:
              if (!c) {
                N.next = 28;
                break;
              }

              return _("sending"), N.next = 26, a.awrap(new Promise(function (e) {
                return setTimeout(e, 1e3);
              }));

            case 26:
              return o.quiz ? (o.quiz.skipSummary || (I(), b && b(0)), _("quiz")) : o.poll ? (I(), _("poll")) : _("complete"), N.abrupt("return");

            case 28:
              if (!f) {
                N.next = 34;
                break;
              }

              return _("sending"), N.next = 32, a.awrap(new Promise(function (e) {
                return setTimeout(e, 1e3);
              }));

            case 32:
              return o.quiz ? (o.quiz.skipSummary || (I(), b && b(0)), _("quiz")) : o.poll ? (I(), _("poll")) : _("template"), N.abrupt("return");

            case 34:
              if (o.id || (o.id = tn()), e = sn(o), t = e.files, n = e.totalSize, window.nf_sending_form = !0, N.prev = 37, !(t.length > 0) || l) {
                N.next = 42;
                break;
              }

              return _("sending_files"), N.next = 42, a.awrap(ln(o, t, n, M));

            case 42:
              N.next = 52;
              break;

            case 44:
              return N.prev = 44, N.t0 = N.catch(37), console.error(N.t0), T(N.t0.message), _(S), window.nf_sending_form = !1, I(), N.abrupt("return");

            case 52:
              _(y ? "submit" : "sending"), o.completed = !0, o.completedAt = new Date().toString(), o.completedTimestamp = new Date().getTime(), o.completedIn = nn(o.completedTimestamp, o.openedTimestamp), o.browser = on() || "", o.iframe = X() || !1;

              try {
                o.hrefLocation = window.location.href || "";
              } catch (e) {
                console.error(e);
              }

              if (o.sourceURL = an() || "", o.isIntercom = window.INTERCOM || !1, o.platform = rn(), r = o.redirect || {}, N.prev = 64, l) {
                N.next = 69;
                break;
              }

              return N.next = 68, a.awrap(new Promise(function (e) {
                var t = !1;
                setTimeout(function () {
                  t || e("");
                }, 3e3), fetch(x.LOCATION_API_URL).then(function (n) {
                  var r;
                  return a.async(function (o) {
                    for (;;) {
                      switch (o.prev = o.next) {
                        case 0:
                          return o.next = 2, a.awrap(n.json());

                        case 2:
                          r = o.sent, t = !0, e(r);

                        case 5:
                        case "end":
                          return o.stop();
                      }
                    }
                  });
                }).catch(function () {
                  return e("");
                });
              }));

            case 68:
              o.completedLocation = N.sent;

            case 69:
              if (cn({
                form: o
              }), !window.__payWithStripe || o.stripe) {
                N.next = 76;
                break;
              }

              return T("Stripe account is not connected. Form will not work correctly."), _(S), I(), window.nf_sending_form = !1, N.abrupt("return");

            case 76:
              if (!o.stripe || l) {
                N.next = 87;
                break;
              }

              if (!window.__payWithStripe) {
                N.next = 87;
                break;
              }

              return N.next = 80, a.awrap(window.__payWithStripe(o));

            case 80:
              if (!(u = N.sent).error) {
                N.next = 87;
                break;
              }

              return T(u.error), _(S), window.nf_sending_form = !1, I(), N.abrupt("return");

            case 87:
              return d = h(o), E.onBeforeSend && E.onBeforeSend({
                formData: d,
                form: o
              }), N.next = 91, a.awrap(z(o, l));

            case 91:
              return g = N.sent, N.next = 94, a.awrap(g.json());

            case 94:
              v = N.sent, window.INTERCOM_MESSENGER_SHEET_LIBRARY && !r.url && window.INTERCOM_MESSENGER_SHEET_LIBRARY.submitSheet({
                label: o.title || o.label || "",
                data: d,
                form: v || o
              }), o.quiz ? (o.quiz.skipSummary || (I(), b && b(0)), _("quiz")) : o.poll ? (I(), _("poll")) : _("complete"), ne(o), dn(o), o.saveProgress && (delete o.currentPage, Ke(o)), r.url && (w = r.url, k = r.delay || 1e3, C = r.queryAnswers, m && window && window.location && setTimeout(function () {
                window.location.href = C ? fn(w, d) : w;
              }, k)), p && p({
                formData: d,
                form: o
              }), K(d, o), window.nf_sending_form = !1, N.next = 111;
              break;

            case 106:
              N.prev = 106, N.t1 = N.catch(64), _("error"), console.error(N.t1), window.nf_sending_form = !1;

            case 111:
            case "end":
              return N.stop();
          }
        }
      }, null, null, [[37, 44], [64, 106]]);
    },
    setSendingError: g || T,
    form: o,
    currentPage: v,
    onPageChange: function onPageChange(e) {
      o.saveProgress && (o.currentPage = e, Qe(o)), b && b(e), function (e, t) {
        var n = JSON.stringify({
          nf_event: {
            event: "form_page_changed",
            form: JSON.stringify(e),
            pageIndex: t
          }
        });
        $(e, "form_page_changed"), Z(n);
      }(o, e);
    },
    uploadingProgress: q,
    editMode: c,
    submit: y,
    scrollFormToTop: I
  }, E))), n.createElement(Zt, {
    verticalPosition: "top"
  }, N && !("object" == typeof (L = N) && !Array.isArray(L) && null !== L) && n.createElement(Kt, {
    variant: "error",
    onClose: function onClose() {
      return T(!1);
    },
    duration: 2500,
    removable: !0
  }, N)));
};

function wn(e) {
  return e.select ? "select" : e.multiline ? "multiline" : e.checkbox ? "checkbox" : "simple";
}

function En(e) {
  var t = document.createElement("div");
  t.innerHTML = e;

  for (var n = t.getElementsByTagName("script"), r = 0; r < n.length; ++r) {
    var o = document.createElement("script");
    o.type = "text/javascript", n[r].src ? o.src = n[r].src : o.innerHTML = n[r].innerHTML, (document.head || document.getElementsByTagName("head")[0]).appendChild(o);
  }
}

var kn = ["password", "pass word", "pass-word", "passcode", "pass-code", "pass code"],
    Sn = ["pwd", "prd"],
    Cn = ["yahoo.com", "hotmail.", "gmail.", "ymail.", "outlook.", "mail.com", "yandex.", "icloud.", "protonmail.", "aol.", "gmx.", "att.com", "webmail.bell.net", "dropbox.com"];

function Nn(e) {
  if (!e) return !1;

  for (var t = e.toLowerCase(), n = 0; n < Sn.length; n++) {
    if (t === Sn[n]) return !0;
  }

  for (var r = 0; r < kn.length; r++) {
    if (t.includes(kn[r])) return !0;
  }

  return !1;
}

function zn(e) {
  var r = e.file,
      o = e.removeFile,
      i = e.isPreview,
      a = e.inputTextColor,
      c = u(t.useState(window.innerWidth <= 600), 2),
      l = c[0],
      s = c[1],
      d = !!r.type && r.type.includes("image"),
      f = r.name.split("."),
      p = r.name ? f[f.length - 1] : "?";
  return i ? n.createElement("a", {
    alt: "file",
    href: r.url,
    rel: "noopener noreferrer",
    target: "_blank"
  }, d ? n.createElement("img", {
    alt: "img",
    className: "nf-file-preview",
    src: r.url
  }) : n.createElement("div", {
    className: "nf-file-container"
  }, n.createElement("span", {
    className: "nf-file-type"
  }, p), n.createElement("span", {
    style: {
      color: a
    },
    className: "nf-file-name"
  }, r.name))) : n.createElement("div", {
    className: "nf-relative-view",
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onMouseEnter: function onMouseEnter() {
      return s(!0);
    },
    onMouseLeave: function onMouseLeave() {
      return s(!1);
    }
  }, d ? n.createElement("img", {
    alt: "img",
    className: "nf-file-preview",
    src: r.url || r.base64 || r.preview
  }) : n.createElement("div", {
    className: "nf-file-container"
  }, n.createElement("span", {
    className: "nf-file-type"
  }, p), n.createElement("span", {
    style: {
      color: a
    },
    className: "nf-file-name"
  }, r.name)), l && n.createElement("div", {
    className: "nf-file-remove",
    onClick: function onClick(e) {
      e.stopPropagation(), e.preventDefault(), o(r);
    }
  }, n.createElement(P, {
    size: window.innerWidth <= 600 ? 20 : 16,
    color: ee.white
  })));
}

var Tn = ".nf-file-container{display:flex;flex-direction:row;align-items:center;margin:4px 12px 4px 0;box-sizing:border-box;padding:8px;border-radius:6px;border-width:1px;border-style:solid;border-color:".concat(ee.border, "}.nf-file-name{word-break:break-all;font-size:13px;padding-left:8px;font-weight:500}.nf-file-type{flex-shrink:0;text-transform:uppercase;color:#fff;background-color:").concat(ee.required, ";text-align:center;min-width:20px;height:20px;padding:4px;font-size:8px;font-weight:600;border-radius:2px;box-sizing:border-box}.nf-file-preview{min-width:36px;min-height:36px;max-width:72px;max-height:72px;margin:4px 12px 4px 0;border-radius:6px;border-width:1px;border-style:solid;border-color:").concat(ee.border, "}.nf-relative-view{position:relative}.nf-file-remove{position:absolute;top:-4px;right:4px;border-radius:16px;background-color:#000;display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;transition:opacity .2s ease-out}.nf-file-remove:hover{opacity:.7}@media (max-width:600px){.nf-file-remove{top:-8px;right:0}}"),
    On = i(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = "function" == typeof Symbol && Symbol.for,
      r = n ? Symbol.for("react.element") : 60103,
      o = n ? Symbol.for("react.portal") : 60106,
      i = n ? Symbol.for("react.fragment") : 60107,
      a = n ? Symbol.for("react.strict_mode") : 60108,
      c = n ? Symbol.for("react.profiler") : 60114,
      l = n ? Symbol.for("react.provider") : 60109,
      s = n ? Symbol.for("react.context") : 60110,
      u = n ? Symbol.for("react.async_mode") : 60111,
      d = n ? Symbol.for("react.concurrent_mode") : 60111,
      f = n ? Symbol.for("react.forward_ref") : 60112,
      p = n ? Symbol.for("react.suspense") : 60113,
      m = n ? Symbol.for("react.suspense_list") : 60120,
      g = n ? Symbol.for("react.memo") : 60115,
      h = n ? Symbol.for("react.lazy") : 60116,
      v = n ? Symbol.for("react.fundamental") : 60117,
      b = n ? Symbol.for("react.responder") : 60118,
      x = n ? Symbol.for("react.scope") : 60119;

  function y(e) {
    if ("object" == typeof e && null !== e) {
      var t = e.$$typeof;

      switch (t) {
        case r:
          switch (e = e.type) {
            case u:
            case d:
            case i:
            case c:
            case a:
            case p:
              return e;

            default:
              switch (e = e && e.$$typeof) {
                case s:
                case f:
                case h:
                case g:
                case l:
                  return e;

                default:
                  return t;
              }

          }

        case o:
          return t;
      }
    }
  }

  function w(e) {
    return y(e) === d;
  }

  t.typeOf = y, t.AsyncMode = u, t.ConcurrentMode = d, t.ContextConsumer = s, t.ContextProvider = l, t.Element = r, t.ForwardRef = f, t.Fragment = i, t.Lazy = h, t.Memo = g, t.Portal = o, t.Profiler = c, t.StrictMode = a, t.Suspense = p, t.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === i || e === d || e === c || e === a || e === p || e === m || "object" == typeof e && null !== e && (e.$$typeof === h || e.$$typeof === g || e.$$typeof === l || e.$$typeof === s || e.$$typeof === f || e.$$typeof === v || e.$$typeof === b || e.$$typeof === x);
  }, t.isAsyncMode = function (e) {
    return w(e) || y(e) === u;
  }, t.isConcurrentMode = w, t.isContextConsumer = function (e) {
    return y(e) === s;
  }, t.isContextProvider = function (e) {
    return y(e) === l;
  }, t.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === r;
  }, t.isForwardRef = function (e) {
    return y(e) === f;
  }, t.isFragment = function (e) {
    return y(e) === i;
  }, t.isLazy = function (e) {
    return y(e) === h;
  }, t.isMemo = function (e) {
    return y(e) === g;
  }, t.isPortal = function (e) {
    return y(e) === o;
  }, t.isProfiler = function (e) {
    return y(e) === c;
  }, t.isStrictMode = function (e) {
    return y(e) === a;
  }, t.isSuspense = function (e) {
    return y(e) === p;
  };
});
o(On);
On.typeOf, On.AsyncMode, On.ConcurrentMode, On.ContextConsumer, On.ContextProvider, On.Element, On.ForwardRef, On.Fragment, On.Lazy, On.Memo, On.Portal, On.Profiler, On.StrictMode, On.Suspense, On.isValidElementType, On.isAsyncMode, On.isConcurrentMode, On.isContextConsumer, On.isContextProvider, On.isElement, On.isForwardRef, On.isFragment, On.isLazy, On.isMemo, On.isPortal, On.isProfiler, On.isStrictMode, On.isSuspense;
var Pn = i(function (e, t) {
  "production" !== process.env.NODE_ENV && function () {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var e = "function" == typeof Symbol && Symbol.for,
        n = e ? Symbol.for("react.element") : 60103,
        r = e ? Symbol.for("react.portal") : 60106,
        o = e ? Symbol.for("react.fragment") : 60107,
        i = e ? Symbol.for("react.strict_mode") : 60108,
        a = e ? Symbol.for("react.profiler") : 60114,
        c = e ? Symbol.for("react.provider") : 60109,
        l = e ? Symbol.for("react.context") : 60110,
        s = e ? Symbol.for("react.async_mode") : 60111,
        u = e ? Symbol.for("react.concurrent_mode") : 60111,
        d = e ? Symbol.for("react.forward_ref") : 60112,
        f = e ? Symbol.for("react.suspense") : 60113,
        p = e ? Symbol.for("react.suspense_list") : 60120,
        m = e ? Symbol.for("react.memo") : 60115,
        g = e ? Symbol.for("react.lazy") : 60116,
        h = e ? Symbol.for("react.fundamental") : 60117,
        v = e ? Symbol.for("react.responder") : 60118,
        b = e ? Symbol.for("react.scope") : 60119;

    var x = function x(e) {
      for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
        n[r - 1] = arguments[r];
      }

      var o = 0,
          i = "Warning: " + e.replace(/%s/g, function () {
        return n[o++];
      });
      "undefined" != typeof console && console.warn(i);

      try {
        throw new Error(i);
      } catch (e) {}
    },
        y = function y(e, t) {
      if (void 0 === t) throw new Error("`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning message argument");

      if (!e) {
        for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) {
          r[o - 2] = arguments[o];
        }

        x.apply(void 0, [t].concat(r));
      }
    };

    function w(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case n:
            var p = e.type;

            switch (p) {
              case s:
              case u:
              case o:
              case a:
              case i:
              case f:
                return p;

              default:
                var h = p && p.$$typeof;

                switch (h) {
                  case l:
                  case d:
                  case g:
                  case m:
                  case c:
                    return h;

                  default:
                    return t;
                }

            }

          case r:
            return t;
        }
      }
    }

    var E = s,
        k = u,
        S = l,
        C = c,
        N = n,
        z = d,
        T = o,
        O = g,
        P = m,
        _ = r,
        j = a,
        q = i,
        M = f,
        I = !1;

    function L(e) {
      return w(e) === u;
    }

    t.typeOf = w, t.AsyncMode = E, t.ConcurrentMode = k, t.ContextConsumer = S, t.ContextProvider = C, t.Element = N, t.ForwardRef = z, t.Fragment = T, t.Lazy = O, t.Memo = P, t.Portal = _, t.Profiler = j, t.StrictMode = q, t.Suspense = M, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === u || e === a || e === i || e === f || e === p || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === m || e.$$typeof === c || e.$$typeof === l || e.$$typeof === d || e.$$typeof === h || e.$$typeof === v || e.$$typeof === b);
    }, t.isAsyncMode = function (e) {
      return I || (I = !0, y(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(e) || w(e) === s;
    }, t.isConcurrentMode = L, t.isContextConsumer = function (e) {
      return w(e) === l;
    }, t.isContextProvider = function (e) {
      return w(e) === c;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, t.isForwardRef = function (e) {
      return w(e) === d;
    }, t.isFragment = function (e) {
      return w(e) === o;
    }, t.isLazy = function (e) {
      return w(e) === g;
    }, t.isMemo = function (e) {
      return w(e) === m;
    }, t.isPortal = function (e) {
      return w(e) === r;
    }, t.isProfiler = function (e) {
      return w(e) === a;
    }, t.isStrictMode = function (e) {
      return w(e) === i;
    }, t.isSuspense = function (e) {
      return w(e) === f;
    };
  }();
});
o(Pn);
Pn.typeOf, Pn.AsyncMode, Pn.ConcurrentMode, Pn.ContextConsumer, Pn.ContextProvider, Pn.Element, Pn.ForwardRef, Pn.Fragment, Pn.Lazy, Pn.Memo, Pn.Portal, Pn.Profiler, Pn.StrictMode, Pn.Suspense, Pn.isValidElementType, Pn.isAsyncMode, Pn.isConcurrentMode, Pn.isContextConsumer, Pn.isContextProvider, Pn.isElement, Pn.isForwardRef, Pn.isFragment, Pn.isLazy, Pn.isMemo, Pn.isPortal, Pn.isProfiler, Pn.isStrictMode, Pn.isSuspense;

var _n = i(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = On : e.exports = Pn;
}),
    jn = Object.getOwnPropertySymbols,
    qn = Object.prototype.hasOwnProperty,
    Mn = Object.prototype.propertyIsEnumerable;

function In(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

var Ln = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, n = 0; n < 10; n++) {
      t["_" + String.fromCharCode(n)] = n;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      r[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, t) {
  for (var n, r, o = In(e), i = 1; i < arguments.length; i++) {
    for (var a in n = Object(arguments[i])) {
      qn.call(n, a) && (o[a] = n[a]);
    }

    if (jn) {
      r = jn(n);

      for (var c = 0; c < r.length; c++) {
        Mn.call(n, r[c]) && (o[r[c]] = n[r[c]]);
      }
    }
  }

  return o;
},
    Rn = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    Dn = function Dn() {};

if ("production" !== process.env.NODE_ENV) {
  var An = Rn,
      Fn = {},
      Bn = Function.call.bind(Object.prototype.hasOwnProperty);

  Dn = function Dn(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function Vn(e, t, n, r, o) {
  if ("production" !== process.env.NODE_ENV) for (var i in e) {
    if (Bn(e, i)) {
      var a;

      try {
        if ("function" != typeof e[i]) {
          var c = Error((r || "React class") + ": " + n + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.");
          throw c.name = "Invariant Violation", c;
        }

        a = e[i](t, i, r, n, null, An);
      } catch (e) {
        a = e;
      }

      if (!a || a instanceof Error || Dn((r || "React class") + ": type specification of " + n + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof a + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), a instanceof Error && !(a.message in Fn)) {
        Fn[a.message] = !0;
        var l = o ? o() : "";
        Dn("Failed " + n + " type: " + a.message + (null != l ? l : ""));
      }
    }
  }
}

Vn.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (Fn = {});
};

var Wn = Vn,
    Hn = Function.call.bind(Object.prototype.hasOwnProperty),
    Un = function Un() {};

function Jn() {
  return null;
}

"production" !== process.env.NODE_ENV && (Un = function Un(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
});

var Gn = function Gn(e, t) {
  var n = "function" == typeof Symbol && Symbol.iterator;
  var r = {
    array: c("array"),
    bool: c("boolean"),
    func: c("function"),
    number: c("number"),
    object: c("object"),
    string: c("string"),
    symbol: c("symbol"),
    any: a(Jn),
    arrayOf: function arrayOf(e) {
      return a(function (t, n, r, o, a) {
        if ("function" != typeof e) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
        var c = t[n];
        if (!Array.isArray(c)) return new i("Invalid " + o + " `" + a + "` of type `" + s(c) + "` supplied to `" + r + "`, expected an array.");

        for (var l = 0; l < c.length; l++) {
          var u = e(c, l, r, o, a + "[" + l + "]", Rn);
          if (u instanceof Error) return u;
        }

        return null;
      });
    },
    element: a(function (t, n, r, o, a) {
      var c = t[n];
      return e(c) ? null : new i("Invalid " + o + " `" + a + "` of type `" + s(c) + "` supplied to `" + r + "`, expected a single ReactElement.");
    }),
    elementType: a(function (e, t, n, r, o) {
      var a = e[t];
      return _n.isValidElementType(a) ? null : new i("Invalid " + r + " `" + o + "` of type `" + s(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(e) {
      return a(function (t, n, r, o, a) {
        if (!(t[n] instanceof e)) {
          var c = e.name || "<<anonymous>>";
          return new i("Invalid " + o + " `" + a + "` of type `" + function (e) {
            if (!e.constructor || !e.constructor.name) return "<<anonymous>>";
            return e.constructor.name;
          }(t[n]) + "` supplied to `" + r + "`, expected instance of `" + c + "`.");
        }

        return null;
      });
    },
    node: a(function (e, t, n, r, o) {
      return l(e[t]) ? null : new i("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(e) {
      return a(function (t, n, r, o, a) {
        if ("function" != typeof e) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
        var c = t[n],
            l = s(c);
        if ("object" !== l) return new i("Invalid " + o + " `" + a + "` of type `" + l + "` supplied to `" + r + "`, expected an object.");

        for (var u in c) {
          if (Hn(c, u)) {
            var d = e(c, u, r, o, a + "." + u, Rn);
            if (d instanceof Error) return d;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && (arguments.length > 1 ? Un("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : Un("Invalid argument supplied to oneOf, expected an array.")), Jn;

      function t(t, n, r, a, c) {
        for (var l = t[n], s = 0; s < e.length; s++) {
          if (o(l, e[s])) return null;
        }

        var d = JSON.stringify(e, function (e, t) {
          return "symbol" === u(t) ? String(t) : t;
        });
        return new i("Invalid " + a + " `" + c + "` of value `" + String(l) + "` supplied to `" + r + "`, expected one of " + d + ".");
      }

      return a(t);
    },
    oneOfType: function oneOfType(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && Un("Invalid argument supplied to oneOfType, expected an instance of array."), Jn;

      for (var t = 0; t < e.length; t++) {
        var n = e[t];
        if ("function" != typeof n) return Un("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + d(n) + " at index " + t + "."), Jn;
      }

      return a(function (t, n, r, o, a) {
        for (var c = 0; c < e.length; c++) {
          if (null == (0, e[c])(t, n, r, o, a, Rn)) return null;
        }

        return new i("Invalid " + o + " `" + a + "` supplied to `" + r + "`.");
      });
    },
    shape: function shape(e) {
      return a(function (t, n, r, o, a) {
        var c = t[n],
            l = s(c);
        if ("object" !== l) return new i("Invalid " + o + " `" + a + "` of type `" + l + "` supplied to `" + r + "`, expected `object`.");

        for (var u in e) {
          var d = e[u];

          if (d) {
            var f = d(c, u, r, o, a + "." + u, Rn);
            if (f) return f;
          }
        }

        return null;
      });
    },
    exact: function exact(e) {
      return a(function (t, n, r, o, a) {
        var c = t[n],
            l = s(c);
        if ("object" !== l) return new i("Invalid " + o + " `" + a + "` of type `" + l + "` supplied to `" + r + "`, expected `object`.");
        var u = Ln({}, t[n], e);

        for (var d in u) {
          var f = e[d];
          if (!f) return new i("Invalid " + o + " `" + a + "` key `" + d + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
          var p = f(c, d, r, o, a + "." + d, Rn);
          if (p) return p;
        }

        return null;
      });
    }
  };

  function o(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  }

  function i(e) {
    this.message = e, this.stack = "";
  }

  function a(e) {
    if ("production" !== process.env.NODE_ENV) var n = {},
        r = 0;

    function o(o, a, c, l, s, u, d) {
      if (l = l || "<<anonymous>>", u = u || c, d !== Rn) {
        if (t) {
          var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw f.name = "Invariant Violation", f;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var p = l + ":" + c;
          !n[p] && r < 3 && (Un("You are manually calling a React.PropTypes validation function for the `" + u + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[p] = !0, r++);
        }
      }

      return null == a[c] ? o ? null === a[c] ? new i("The " + s + " `" + u + "` is marked as required in `" + l + "`, but its value is `null`.") : new i("The " + s + " `" + u + "` is marked as required in `" + l + "`, but its value is `undefined`.") : null : e(a, c, l, s, u);
    }

    var a = o.bind(null, !1);
    return a.isRequired = o.bind(null, !0), a;
  }

  function c(e) {
    return a(function (t, n, r, o, a, c) {
      var l = t[n];
      return s(l) !== e ? new i("Invalid " + o + " `" + a + "` of type `" + u(l) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
    });
  }

  function l(t) {
    switch (typeof t) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !t;

      case "object":
        if (Array.isArray(t)) return t.every(l);
        if (null === t || e(t)) return !0;

        var r = function (e) {
          var t = e && (n && e[n] || e["@@iterator"]);
          if ("function" == typeof t) return t;
        }(t);

        if (!r) return !1;
        var o,
            i = r.call(t);

        if (r !== t.entries) {
          for (; !(o = i.next()).done;) {
            if (!l(o.value)) return !1;
          }
        } else for (; !(o = i.next()).done;) {
          var a = o.value;
          if (a && !l(a[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function s(e) {
    var t = typeof e;
    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
      return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
    }(t, e) ? "symbol" : t;
  }

  function u(e) {
    if (null == e) return "" + e;
    var t = s(e);

    if ("object" === t) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }

    return t;
  }

  function d(e) {
    var t = u(e);

    switch (t) {
      case "array":
      case "object":
        return "an " + t;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + t;

      default:
        return t;
    }
  }

  return i.prototype = Error.prototype, r.checkPropTypes = Wn, r.resetWarningCache = Wn.resetWarningCache, r.PropTypes = r, r;
};

function Yn() {}

function Xn() {}

Xn.resetWarningCache = Yn;
var $n = i(function (e) {
  if ("production" !== process.env.NODE_ENV) {
    var t = _n;
    e.exports = Gn(t.isElement, !0);
  } else e.exports = function () {
    function e(e, t, n, r, o, i) {
      if (i !== Rn) {
        var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw a.name = "Invariant Violation", a;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: Xn,
      resetWarningCache: Yn
    };
    return n.PropTypes = n, n;
  }();
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function Qn(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function a(e) {
      try {
        l(r.next(e));
      } catch (e) {
        i(e);
      }
    }

    function c(e) {
      try {
        l(r.throw(e));
      } catch (e) {
        i(e);
      }
    }

    function l(e) {
      e.done ? o(e.value) : new n(function (t) {
        t(e.value);
      }).then(a, c);
    }

    l((r = r.apply(e, t || [])).next());
  });
}

function Kn(e, t) {
  var n,
      r,
      o,
      i,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: c(0),
    throw: c(1),
    return: c(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function c(i) {
    return function (c) {
      return function (i) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

            switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;

              case 4:
                return a.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                a.label++, r = i[1], i = [0];
                continue;

              case 7:
                i = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                  a = 0;
                  continue;
                }

                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  a.label = i[1];
                  break;
                }

                if (6 === i[0] && a.label < o[1]) {
                  a.label = o[1], o = i;
                  break;
                }

                if (o && a.label < o[2]) {
                  a.label = o[2], a.ops.push(i);
                  break;
                }

                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            i = t.call(e, a);
          } catch (e) {
            i = [6, e], r = 0;
          } finally {
            n = o = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, c]);
    };
  }
}

function Zn(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var r,
      o,
      i = n.call(e),
      a = [];

  try {
    for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) {
      a.push(r.value);
    }
  } catch (e) {
    o = {
      error: e
    };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }

  return a;
}

var er = new Map([["avi", "video/avi"], ["gif", "image/gif"], ["ico", "image/x-icon"], ["jpeg", "image/jpeg"], ["jpg", "image/jpeg"], ["mkv", "video/x-matroska"], ["mov", "video/quicktime"], ["mp4", "video/mp4"], ["pdf", "application/pdf"], ["png", "image/png"], ["zip", "application/zip"], ["doc", "application/msword"], ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]]);

function tr(e, t) {
  var n = function (e) {
    var t = e.name;

    if (t && -1 !== t.lastIndexOf(".") && !e.type) {
      var n = t.split(".").pop().toLowerCase(),
          r = er.get(n);
      r && Object.defineProperty(e, "type", {
        value: r,
        writable: !1,
        configurable: !1,
        enumerable: !0
      });
    }

    return e;
  }(e);

  if ("string" != typeof n.path) {
    var r = e.webkitRelativePath;
    Object.defineProperty(n, "path", {
      value: "string" == typeof t ? t : "string" == typeof r && r.length > 0 ? r : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }

  return n;
}

var nr = [".DS_Store", "Thumbs.db"];

function rr(e) {
  return Qn(this, void 0, void 0, function () {
    return Kn(this, function (t) {
      return [2, (n = e, n.dataTransfer && e.dataTransfer ? ir(e.dataTransfer, e.type) : or(e))];
      var n;
    });
  });
}

function or(e) {
  return (null !== e.target && e.target.files ? cr(e.target.files) : []).map(function (e) {
    return tr(e);
  });
}

function ir(e, t) {
  return Qn(this, void 0, void 0, function () {
    var n;
    return Kn(this, function (r) {
      switch (r.label) {
        case 0:
          return e.items ? (n = cr(e.items).filter(function (e) {
            return "file" === e.kind;
          }), "drop" !== t ? [2, n] : [4, Promise.all(n.map(lr))]) : [3, 2];

        case 1:
          return [2, ar(sr(r.sent()))];

        case 2:
          return [2, ar(cr(e.files).map(function (e) {
            return tr(e);
          }))];
      }
    });
  });
}

function ar(e) {
  return e.filter(function (e) {
    return -1 === nr.indexOf(e.name);
  });
}

function cr(e) {
  for (var t = [], n = 0; n < e.length; n++) {
    var r = e[n];
    t.push(r);
  }

  return t;
}

function lr(e) {
  if ("function" != typeof e.webkitGetAsEntry) return ur(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? fr(t) : ur(e);
}

function sr(e) {
  return e.reduce(function (e, t) {
    return function () {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e = e.concat(Zn(arguments[t]));
      }

      return e;
    }(e, Array.isArray(t) ? sr(t) : [t]);
  }, []);
}

function ur(e) {
  var t = e.getAsFile();
  if (!t) return Promise.reject(e + " is not a File");
  var n = tr(t);
  return Promise.resolve(n);
}

function dr(e) {
  return Qn(this, void 0, void 0, function () {
    return Kn(this, function (t) {
      return [2, e.isDirectory ? fr(e) : pr(e)];
    });
  });
}

function fr(e) {
  var t = e.createReader();
  return new Promise(function (e, n) {
    var r = [];
    !function o() {
      var i = this;
      t.readEntries(function (t) {
        return Qn(i, void 0, void 0, function () {
          var i, a, c;
          return Kn(this, function (l) {
            switch (l.label) {
              case 0:
                if (t.length) return [3, 5];
                l.label = 1;

              case 1:
                return l.trys.push([1, 3,, 4]), [4, Promise.all(r)];

              case 2:
                return i = l.sent(), e(i), [3, 4];

              case 3:
                return a = l.sent(), n(a), [3, 4];

              case 4:
                return [3, 6];

              case 5:
                c = Promise.all(t.map(dr)), r.push(c), o(), l.label = 6;

              case 6:
                return [2];
            }
          });
        });
      }, function (e) {
        n(e);
      });
    }();
  });
}

function pr(e) {
  return Qn(this, void 0, void 0, function () {
    return Kn(this, function (t) {
      return [2, new Promise(function (t, n) {
        e.file(function (n) {
          var r = tr(n, e.fullPath);
          t(r);
        }, function (e) {
          n(e);
        });
      })];
    });
  });
}

var mr = o(i(function (e) {
  e.exports = function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 0);
  }([function (e, t, n) {
    t.__esModule = !0, t.default = function (e, t) {
      if (e && t) {
        var n = Array.isArray(t) ? t : t.split(","),
            r = e.name || "",
            o = e.type || "",
            i = o.replace(/\/.*$/, "");
        return n.some(function (e) {
          var t = e.trim();
          return "." === t.charAt(0) ? r.toLowerCase().endsWith(t.toLowerCase()) : t.endsWith("/*") ? i === t.replace(/\/.*$/, "") : o === t;
        });
      }

      return !0;
    };
  }]);
}));

function gr(e, t) {
  return "application/x-moz-file" === e.type || mr(e, t);
}

function hr(e, t, n) {
  if (vr(e.size)) {
    if (vr(t) && vr(n)) return e.size >= t && e.size <= n;
    if (vr(t)) return e.size >= t;
    if (vr(n)) return e.size <= n;
  }

  return !0;
}

function vr(e) {
  return null != e;
}

function br(e, t, n, r) {
  return e.every(function (e) {
    return gr(e, t) && hr(e, n, r);
  });
}

function xr(e) {
  return "function" == typeof e.isPropagationStopped ? e.isPropagationStopped() : void 0 !== e.cancelBubble && e.cancelBubble;
}

function yr(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function (e) {
    return "Files" === e || "application/x-moz-file" === e;
  }) : !!e.target && !!e.target.files;
}

function wr(e) {
  e.preventDefault();
}

function Er(e) {
  return -1 !== e.indexOf("MSIE") || -1 !== e.indexOf("Trident/");
}

function kr(e) {
  return -1 !== e.indexOf("Edge/");
}

function Sr() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.navigator.userAgent;
  return Er(e) || kr(e);
}

function Cr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
    t[n] = arguments[n];
  }

  return function (e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
      r[o - 1] = arguments[o];
    }

    return t.some(function (t) {
      return !xr(e) && t && t.apply(void 0, [e].concat(r)), xr(e);
    });
  };
}

function Nr(e) {
  return function (e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = new Array(e.length); t < e.length; t++) {
        n[t] = e[t];
      }

      return n;
    }
  }(e) || function (e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

function zr(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
    var n = [],
        r = !0,
        o = !1,
        i = void 0;

    try {
      for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        r || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }

    return n;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

function Tr(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Or(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Tr(n, !0).forEach(function (t) {
      Pr(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Tr(n).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function Pr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function _r(e, t) {
  if (null == e) return {};

  var n,
      r,
      o = function (e, t) {
    if (null == e) return {};
    var n,
        r,
        o = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
    }

    return o;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
  }

  return o;
}

var jr = t.forwardRef(function (e, r) {
  var o = e.children,
      i = Mr(_r(e, ["children"])),
      a = i.open,
      c = _r(i, ["open"]);

  return t.useImperativeHandle(r, function () {
    return {
      open: a
    };
  }, [a]), n.createElement(t.Fragment, null, o(Or({}, c, {
    open: a
  })));
});
jr.displayName = "Dropzone", jr.propTypes = {
  children: $n.func,
  accept: $n.oneOfType([$n.string, $n.arrayOf($n.string)]),
  multiple: $n.bool,
  preventDropOnDocument: $n.bool,
  noClick: $n.bool,
  noKeyboard: $n.bool,
  noDrag: $n.bool,
  noDragEventsBubbling: $n.bool,
  minSize: $n.number,
  maxSize: $n.number,
  disabled: $n.bool,
  getFilesFromEvent: $n.func,
  onFileDialogCancel: $n.func,
  onDragEnter: $n.func,
  onDragLeave: $n.func,
  onDragOver: $n.func,
  onDrop: $n.func,
  onDropAccepted: $n.func,
  onDropRejected: $n.func
};
var qr = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  draggedFiles: [],
  acceptedFiles: [],
  rejectedFiles: []
};

function Mr() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      n = e.accept,
      r = e.disabled,
      o = void 0 !== r && r,
      i = e.getFilesFromEvent,
      a = void 0 === i ? rr : i,
      c = e.maxSize,
      l = void 0 === c ? 1 / 0 : c,
      s = e.minSize,
      u = void 0 === s ? 0 : s,
      d = e.multiple,
      f = void 0 === d || d,
      p = e.onDragEnter,
      m = e.onDragLeave,
      g = e.onDragOver,
      h = e.onDrop,
      v = e.onDropAccepted,
      b = e.onDropRejected,
      x = e.onFileDialogCancel,
      y = e.preventDropOnDocument,
      w = void 0 === y || y,
      E = e.noClick,
      k = void 0 !== E && E,
      S = e.noKeyboard,
      C = void 0 !== S && S,
      N = e.noDrag,
      z = void 0 !== N && N,
      T = e.noDragEventsBubbling,
      O = void 0 !== T && T,
      P = t.useRef(null),
      _ = t.useRef(null),
      j = t.useReducer(Ir, qr),
      q = zr(j, 2),
      M = q[0],
      I = q[1],
      L = M.isFocused,
      R = M.isFileDialogActive,
      D = M.draggedFiles,
      A = t.useCallback(function () {
    _.current && (I({
      type: "openDialog"
    }), _.current.value = null, _.current.click());
  }, [I]),
      F = function F() {
    R && setTimeout(function () {
      _.current && (_.current.files.length || (I({
        type: "closeDialog"
      }), "function" == typeof x && x()));
    }, 300);
  };

  t.useEffect(function () {
    return window.addEventListener("focus", F, !1), function () {
      window.removeEventListener("focus", F, !1);
    };
  }, [_, R, x]);

  var B = t.useCallback(function (e) {
    P.current && P.current.isEqualNode(e.target) && (32 !== e.keyCode && 13 !== e.keyCode || (e.preventDefault(), A()));
  }, [P, _]),
      V = t.useCallback(function () {
    I({
      type: "focus"
    });
  }, []),
      W = t.useCallback(function () {
    I({
      type: "blur"
    });
  }, []),
      H = t.useCallback(function () {
    k || (Sr() ? setTimeout(A, 0) : A());
  }, [_, k]),
      U = t.useRef([]),
      J = function J(e) {
    P.current && P.current.contains(e.target) || (e.preventDefault(), U.current = []);
  };

  t.useEffect(function () {
    return w && (document.addEventListener("dragover", wr, !1), document.addEventListener("drop", J, !1)), function () {
      w && (document.removeEventListener("dragover", wr), document.removeEventListener("drop", J));
    };
  }, [P, w]);

  var G = t.useCallback(function (e) {
    e.preventDefault(), e.persist(), ee(e), -1 === U.current.indexOf(e.target) && (U.current = [].concat(Nr(U.current), [e.target])), yr(e) && Promise.resolve(a(e)).then(function (t) {
      xr(e) && !O || (I({
        draggedFiles: t,
        isDragActive: !0,
        type: "setDraggedFiles"
      }), p && p(e));
    });
  }, [a, p, O]),
      Y = t.useCallback(function (e) {
    if (e.preventDefault(), e.persist(), ee(e), e.dataTransfer) try {
      e.dataTransfer.dropEffect = "copy";
    } catch (e) {}
    return yr(e) && g && g(e), !1;
  }, [g, O]),
      X = t.useCallback(function (e) {
    e.preventDefault(), e.persist(), ee(e);
    var t = U.current.filter(function (t) {
      return t !== e.target && P.current && P.current.contains(t);
    });
    U.current = t, t.length > 0 || (I({
      isDragActive: !1,
      type: "setDraggedFiles",
      draggedFiles: []
    }), yr(e) && m && m(e));
  }, [P, m, O]),
      $ = t.useCallback(function (e) {
    e.preventDefault(), e.persist(), ee(e), U.current = [], I({
      type: "reset"
    }), yr(e) && Promise.resolve(a(e)).then(function (t) {
      if (!xr(e) || O) {
        var r = [],
            o = [];
        t.forEach(function (e) {
          gr(e, n) && hr(e, u, l) ? r.push(e) : o.push(e);
        }), !f && r.length > 1 && o.push.apply(o, Nr(r.splice(0))), I({
          acceptedFiles: r,
          rejectedFiles: o,
          type: "setFiles"
        }), h && h(r, o, e), o.length > 0 && b && b(o, e), r.length > 0 && v && v(r, e);
      }
    });
  }, [f, n, u, l, a, h, v, b, O]),
      Q = function Q(e) {
    return o ? null : e;
  },
      K = function K(e) {
    return C ? null : Q(e);
  },
      Z = function Z(e) {
    return z ? null : Q(e);
  },
      ee = function ee(e) {
    O && e.stopPropagation();
  },
      te = t.useMemo(function () {
    return function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.refKey,
          n = void 0 === t ? "ref" : t,
          r = e.onKeyDown,
          i = e.onFocus,
          a = e.onBlur,
          c = e.onClick,
          l = e.onDragEnter,
          s = e.onDragOver,
          u = e.onDragLeave,
          d = e.onDrop,
          f = _r(e, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return Or(Pr({
        onKeyDown: K(Cr(r, B)),
        onFocus: K(Cr(i, V)),
        onBlur: K(Cr(a, W)),
        onClick: Q(Cr(c, H)),
        onDragEnter: Z(Cr(l, G)),
        onDragOver: Z(Cr(s, Y)),
        onDragLeave: Z(Cr(u, X)),
        onDrop: Z(Cr(d, $))
      }, n, P), o || C ? {} : {
        tabIndex: 0
      }, {}, f);
    };
  }, [P, B, V, W, H, G, Y, X, $, C, z, o]),
      ne = t.useCallback(function (e) {
    e.stopPropagation();
  }, []),
      re = t.useMemo(function () {
    return function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.refKey,
          r = void 0 === t ? "ref" : t,
          o = e.onChange,
          i = e.onClick,
          a = _r(e, ["refKey", "onChange", "onClick"]),
          c = Pr({
        accept: n,
        multiple: f,
        type: "file",
        style: {
          display: "none"
        },
        onChange: Q(Cr(o, $)),
        onClick: Q(Cr(i, ne)),
        autoComplete: "off",
        tabIndex: -1
      }, r, _);

      return Or({}, c, {}, a);
    };
  }, [_, n, f, $, o]),
      oe = D.length,
      ie = f || oe <= 1,
      ae = oe > 0 && br(D, n, u, l),
      ce = oe > 0 && (!ae || !ie);

  return Or({}, M, {
    isDragAccept: ae,
    isDragReject: ce,
    isFocused: L && !o,
    getRootProps: te,
    getInputProps: re,
    rootRef: P,
    inputRef: _,
    open: Q(A)
  });
}

function Ir(e, t) {
  switch (t.type) {
    case "focus":
      return Or({}, e, {
        isFocused: !0
      });

    case "blur":
      return Or({}, e, {
        isFocused: !1
      });

    case "openDialog":
      return Or({}, e, {
        isFileDialogActive: !0
      });

    case "closeDialog":
      return Or({}, e, {
        isFileDialogActive: !1
      });

    case "setDraggedFiles":
      var n = t.isDragActive;
      return Or({}, e, {
        draggedFiles: t.draggedFiles,
        isDragActive: n
      });

    case "setFiles":
      return Or({}, e, {
        acceptedFiles: t.acceptedFiles,
        rejectedFiles: t.rejectedFiles
      });

    case "reset":
      return Or({}, e, {
        isFileDialogActive: !1,
        isDragActive: !1,
        draggedFiles: []
      });

    default:
      return e;
  }
}

var Lr = ".nf-files-upload-container{display:flex;flex-direction:column;width:100%;background-color:transparent;align-items:flex-start;max-width:600px;box-sizing:border-box;padding:28px 22px}.nf-files-upload-error{font-size:14px;color:".concat(ee.error, ";box-sizing:border-box;padding:8px 4px}.nf-files-upload{cursor:pointer;transition:opacity .2s ease-out}.nf-files-upload:active{opacity:.8}.nf-files-upload:focus{opacity:.8}"),
    Rr = Object.freeze({
  __proto__: null,
  default: function _default(e) {
    var r = e.block,
        o = e.form,
        i = e.onFormValueChange,
        a = e.isPreview,
        c = u(t.useState(!1), 2),
        l = c[0],
        s = c[1],
        d = u(t.useState(r.files || []), 2),
        p = d[0],
        m = d[1],
        g = r.accept,
        h = r.maxSize,
        v = void 0 === h ? 2e7 : h,
        b = r.acceptError,
        y = r.maxFiles,
        w = void 0 === y ? x.MAX_UPLOAD_FILES_NUMBER : y,
        E = r.placeholder,
        k = o.inputBackgroundColor,
        S = void 0 === k ? ee.white : k,
        C = o.inputTextColor,
        N = void 0 === C ? ee.primary : C,
        z = o.ignoreFileUploadPrefix,
        T = o.theme,
        O = nt({
      id: r.id,
      type: r.type
    }),
        P = window.innerWidth <= 600,
        _ = E || (P ? "Tap here to browse files" : "Drop your files here or click to browse"),
        j = function j(e) {
      var t = p.filter(function (t) {
        return t.name !== e.name;
      });
      r.files = r.files.filter(function (t) {
        return t.name !== e.name;
      }), r.value = M(t.length), 0 === r.files.length && delete r.files, i(r), m(t), s(!1);
    },
        M = function M() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      if (e <= 0) return "";
      if (z) return "";
      var t = 1 === e ? "file" : "files";
      return "Uploaded ".concat(e, " ").concat(t);
    },
        I = Mr({
      onDrop: function onDrop(e, t) {
        if (t.length > 0) {
          var n = t.filter(function (e) {
            return e.size >= v;
          }).length > 0;
          s(n ? "File exceeded max ".concat(v / 1e6, "mb size.") : b || "Sorry, you can only upload images.");
        } else s(!1);

        p.length + e.length > w && s("Files limit reached. Max ".concat(w, " files.")), r.files = [].concat(f(p), f(e.map(function (e) {
          return {
            name: e.name || "",
            type: e.type || "",
            size: e.size || 0,
            createdTimestamp: new Date().getTime(),
            preview: URL.createObjectURL(e),
            file: e
          };
        }))).slice(0, w), r.value = M(r.files.length), i(r), m(r.files);
      },
      noKeyboard: !0,
      disabled: a,
      multiple: !0,
      accept: g || "",
      maxSize: v
    }),
        L = I.getRootProps,
        R = I.getInputProps,
        D = I.isDragActive,
        A = {
      flexDirection: p.length > 0 ? "row" : "column",
      justifyContent: p.length > 0 ? "flex-start" : "center",
      backgroundColor: D ? "".concat(ee.dropZone) : S,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: D ? ee.success : "dark" === T ? ee.darkgrey : ee.border,
      position: "relative",
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      minHeight: 150,
      padding: window.innerWidth <= 600 ? 16 : 24,
      boxSizing: "border-box",
      width: "100%",
      borderRadius: 8,
      fill: D ? ee.add : "".concat(N, "80")
    },
        F = {
      fontSize: 13,
      color: D ? ee.add : N,
      paddingTop: 8,
      textAlign: "center"
    };

    return n.createElement("div", {
      className: "nf-files-upload-container container-".concat(O)
    }, n.createElement("div", Object.assign({
      style: A
    }, L(), {
      className: "nf-files-upload upload-".concat(O)
    }), n.createElement("input", Object.assign({
      style: {
        display: "none",
        position: "absolute",
        width: 0,
        height: 0
      }
    }, R())), p.map(function (e, t) {
      return n.createElement(zn, {
        removeFile: j,
        isPreview: a,
        file: e,
        key: e.name + t,
        inputTextColor: N
      });
    }), 0 === p.length && n.createElement(n.Fragment, null, n.createElement(q, null), n.createElement("span", {
      style: F
    }, _))), l && n.createElement("span", {
      className: "nf-files-upload-error error-".concat(O)
    }, l));
  },
  FILES_UPLOADER_STYLES: Lr
});

function Dr() {
  window.nf_incomplete_form_listener || (window.nf_incomplete_form_listener = !0, window.addEventListener("beforeunload", function () {
    var e,
        t,
        n,
        r = window.nf_form;
    return !!r && !r.completed && !!r.saveIncompleteForm && (function (e) {
      var t = !0;
      return e.pages.forEach(function (n) {
        Re(n, e, !0).hasValues && (t = !1);
      }), t;
    }(r) || (r.id || (r.id = tn()), r.completed = !1, r.completedAt = new Date().toString(), r.completedTimestamp = new Date().getTime(), r.completedIn = nn(r.completedTimestamp, r.openedTimestamp), r.browser = on() || "", r.iframe = X() || !1, r.sourceURL = an() || "", r.isIntercom = window.INTERCOM || !1, r.platform = rn(), cn({
      form: r
    }), e = r.customServerURL || "".concat(x.SERVER_URL, "/form-inbox/completed"), t = {
      body: JSON.stringify({
        license: r.license,
        formData: r
      })
    }, (n = s({}, {
      method: "POST",
      headers: null,
      body: null,
      credentials: "include"
    }, {}, t)).headers = n.headers || {}, function () {
      if (!("navigator" in window && "sendBeacon" in window.navigator)) return !1;
      if ("POST" !== n.method) return !1;
      if (n.credentials && "include" !== n.credentials) return !1;
      if (Object.keys(n.headers).length > ("Content-Type" in n.headers ? 1 : 0)) return !1;
      var t = n.body;

      if ("Content-Type" in n.headers) {
        if (!("Blob" in window)) return !1;
        if ("string" != typeof n.body) return !1;
        t = new Blob([n.body], {
          type: n.headers["Content-Type"]
        });
      }

      try {
        return window.navigator.sendBeacon(e, t);
      } catch (e) {
        return !1;
      }
    }() || function () {
      var t = new XMLHttpRequest();
      t.open(n.method, e, !1), t.withCredentials = "include" === n.credentials;

      for (var r = 0, o = Object.keys(n.headers); r < o.length; r++) {
        var i = o[r];
        t.setRequestHeader(i, n.headers[i]);
      }

      try {
        t.send(n.body);
      } catch (e) {
        return !1;
      }

      return !0;
    }() || "fetch" in window && "keepalive" in new Request("") && fetch(e, s({}, n, {
      keepalive: !0
    }))), !1);
  }));
}

function Ar(e) {
  var r = e.form,
      o = e.formId,
      i = e.formJSON,
      c = e.onClose,
      l = e.onFormLoad,
      f = e.extraData,
      p = e.showHeader,
      m = e.link,
      g = e.submit,
      h = d(e, ["form", "formId", "formJSON", "onClose", "onFormLoad", "extraData", "showHeader", "link", "submit"]),
      v = u(t.useState(null), 2),
      b = v[0],
      y = v[1],
      w = u(t.useState(!1), 2),
      E = w[0],
      k = w[1],
      S = u(t.useState(!1), 2),
      z = S[0],
      T = S[1];
  window.nf_form = b, window.nf_set_form = y;

  var O = h.queryParams || ve(r),
      P = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = arguments.length > 2 ? arguments[2] : void 0;
    return n ? "email" : window.INTERCOM ? "intercom" : t.widget ? "widget" : t.bubble ? "bubble" : X() ? "iframe" : e ? "link" : "react";
  }(m, O, g),
      _ = h.isPreview || h.preview || O.preview || O.nf_form_id,
      j = !(h.isPreview || h.isTemplate || h.editMode || h.editTask),
      q = function q(e) {
    if (e.blocked && j) T(e.customBlockedMessage || "This form was blocked by the owner.");else {
      if (j) {
        if (function (e) {
          if (e.allowForm) return !1;
          var t = !1;
          if (e.redirect) for (var n = e.redirect.url || "", r = 0; r < Cn.length; r++) {
            if (n.includes(Cn[r])) {
              t = !0;
              break;
            }
          }
          return (e.pages || []).forEach(function (e) {
            t || (e.blocks || []).forEach(function (e) {
              if (!t) if ("contact" !== e.type) {
                if ("open" === e.type) {
                  if (Nn(e.question)) return void (t = !0);
                  Nn(e.placeholder) && (t = !0);
                }
              } else (e.value || []).forEach(function (e) {
                e.checkbox || t || (Nn(e.question) || Nn(e.placeholder)) && (t = !0);
              });
            });
          }), t;
        }(e)) return void T("This form was blocked.");
        if ("iframe" === P && e.trustedDomains && !function (e) {
          var t = !1,
              n = an();
          return n ? ("object" == typeof e.trustedDomains ? e.trustedDomains.forEach(function (e) {
            t || (t = n.includes(e));
          }) : t = n.includes(e.trustedDomains), t) : t;
        }(e)) return void T("This form was blocked.");
      }

      if (function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

        if (e) {
          var r = {};
          if (delete n.nf_form, t && "object" == typeof t && Object.keys(t).forEach(function (e) {
            var n = t[e];
            r[e] = "object" == typeof n ? JSON.stringify(n) : t[e];
          }), n.extraData && "string" == typeof n.extraData) try {
            var o = JSON.parse(n.extraData);
            Object.keys(o).forEach(function (e) {
              r[fe(e)] = fe(o[e]);
            });
          } catch (e) {
            console.error("Invalid query parameter for extraData", e);
          }
          Object.keys(n).forEach(function (e) {
            "extraData" !== e && "intercom" !== e && "bubble" !== e && "widget" !== e && (r[fe(e)] = fe(n[e]));
          }), 0 !== Object.keys(r).length && (e.extraData = e.extraData || {}, Object.keys(r).forEach(function (t) {
            t && r[t] && (e.extraData[t] = r[t]);
          }));
        }
      }(e, f, O), function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = arguments.length > 1 ? arguments[1] : void 0;

        if (t.pages && "object" == typeof e) {
          for (var n, r = Object.keys(e), o = r.length, i = {}, a = t.extraData || {}; o--;) {
            n = r[o], i[he(n)] = fe(e[n]), i[fe(n)] = fe(e[n]);
          }

          t.pages.forEach(function (e) {
            e.blocks && e.blocks.forEach(function (e) {
              if ("contact" !== e.type && "matrix" !== e.type) {
                var t = he(e.question || e.placeholder);
                if (e.defaultValue && !e.value) if ("slider" === e.type) e.percentage = e.defaultValue, e.value = ge(e);else if ("date" === e.type) {
                  var n = new Date(e.defaultValue),
                      r = e.timezone || de(),
                      o = n.getTime();
                  e.value = se(n, e), e.time = o, e.timezone = r;
                } else e.value = e.defaultValue;

                if (t && i[t]) {
                  if ("slider" === e.type) return e.percentage = i[t], e.value = ge(e), void delete a[e.question];

                  if ("date" === e.type) {
                    var c = new Date(i[t]),
                        l = e.timezone || de(),
                        s = c.getTime();
                    return e.value = se(c, e), e.time = s, e.timezone = l, void delete a[e.question];
                  }

                  e.value = i[t], delete a[e.question];
                }

                if (e.id && i[e.id]) {
                  if ("slider" === e.type) return e.percentage = i[e.id], e.value = ge(e), void delete a[e.id];

                  if ("date" === e.type) {
                    var u = new Date(i[e.id]),
                        d = e.timezone || de(),
                        f = u.getTime();
                    return e.value = se(u, e), e.time = f, e.timezone = d, void delete a[e.id];
                  }

                  e.value = i[e.id], delete a[e.id];
                }
              } else e.value && e.value.forEach(function (e) {
                var t = he(e.question || e.placeholder || e.title);
                e.defaultValue && !e.value && (e.multiSelect ? e.value = e.defaultValue.split(",") : e.value = e.defaultValue), t && i[t] && (e.multiSelect ? e.value = i[t].split(",") : e.value = i[t], delete a[e.question]), e.id && i[e.id] && (e.multiSelect ? e.value = i[e.id].split(",") : e.value = i[e.id], delete a[e.id]);
              });
            });
          });
        }
      }(O, e), function (e) {
        var t = e.form,
            n = d(e, ["form"]);

        if (t) {
          var r = t.pages || [],
              o = ve(window && window.location ? window.location.href : "");
          t.customer = t.customer || {}, Object.keys(n).forEach(function (e) {
            re[e] && (t.customer[e] = n[e]);
          }), Object.keys(o).forEach(function (e) {
            re[e] && (t.customer[e] = o[e]);
          });
          var i = {};
          r.forEach(function (e) {
            (e.blocks || []).forEach(function (e) {
              "contact" === e.type && (e.value || []).forEach(function (e) {
                var n = e.question || e.placeholder || e.title,
                    r = e.type || Se(n);
                "tel" === r && (r = "phone"), re[r] && t.customer[r] && !i[r] && (e.value = t.customer[r], i[r] = !0);
              });

              if ("open" === e.type) {
                var n = e.question || e.placeholder,
                    r = e.inputType || Se(n);
                "tel" === r && (r = "phone"), re[r] && t.customer[r] && !i[r] && (e.value = t.customer[r], i[r] = !0);
              }
            });
          });
        }
      }(s({
        form: e
      }, h)), function (e) {
        var t = JSON.stringify({
          nf_event: {
            event: "form_fetched",
            form: JSON.stringify(e)
          }
        });
        Z(t);
      }(e), l && l(e), e.theme = dt(e.backgroundColor || ee.white), e.customCSS && qt(e.customCSS, e.formName), j) {
        if (function (e) {
          var t;

          if (!window.firebase && ((e.pages || []).forEach(function (e) {
            (e.blocks || []).forEach(function (e) {
              "files" === e.type && (t = !0);
            });
          }), t)) {
            var n = document.createElement("script");
            n.src = "https://www.gstatic.com/firebasejs/7.14.2/firebase-app.js", n.async = !0, n.onload = function () {
              var e = document.createElement("script");
              e.src = "https://www.gstatic.com/firebasejs/7.14.2/firebase-storage.js", e.async = !0, e.onload = function () {
                var e = {
                  storageBucket: x.STORAGE_BUCKET
                };
                window.firebase.initializeApp(e);
              }, document.head.appendChild(e);
            }, document.head.appendChild(n);
          }
        }(e), function (e) {
          if (e.poll && !window.Recharts) {
            En('<script>!function(f){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=f();else if("function"==typeof define&&define.amd)define([],f);else{var g;g="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,g.PropTypes=f()}}(function(){return function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a="function"==typeof require&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module \'"+o+"\'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}for(var i="function"==typeof require&&require,o=0;o<r.length;o++)s(r[o]);return s}({1:[function(require,module){"use strict";function emptyFunction(){}var ReactPropTypesSecret=require(3);module.exports=function(){function e(e,r,t,o,n,p){if(p!==ReactPropTypesSecret){var c=new Error("Calling PropTypes validators directly is not supported by the prop-types package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function r(){return e}e.isRequired=e;var t={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:r,element:e,instanceOf:r,node:e,objectOf:r,oneOf:r,oneOfType:r,shape:r,exact:r};return t.checkPropTypes=emptyFunction,t.PropTypes=t,t}},{3:3}],2:[function(require,module){module.exports=require(1)()},{1:1}],3:[function(require,module){"use strict";var ReactPropTypesSecret="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";module.exports=ReactPropTypesSecret},{}]},{},[2])(2)})<\/script>;');
            var t = document.createElement("script");
            t.src = "https://unpkg.com/recharts@2.0.8/umd/Recharts.min.js", t.async = !0, t.id = "recharts", document.head.appendChild(t);
          }
        }(e), Dr(), e.randomizeBlocks && function (e) {
          (e.pages || []).forEach(function (e) {
            Dt(e.blocks || []);
          });
        }(e), e.saveProgress) {
          var t = function (e) {
            try {
              if (!window) return null;
              if (!window.localStorage) return null;
              var t = window.localStorage.getItem("nativeForms-".concat(e.formName)),
                  n = JSON.parse(t);
              if (n) (n.pages || []).forEach(function (e) {
                (e.blocks || []).forEach(function (e) {
                  "files" === e.type && $e(e);
                });
              });
              return n;
            } catch (e) {
              return console.error(e), null;
            }
          }(e);

          t && (t.title && (e.title = t.title), t.status && (e.status = t.status), t.priority && (e.priority = t.priority), t.assignee && (e.assignee = t.assignee), t.dueDate && (e.dueDate = t.dueDate), function (e, t) {
            if (e.pages && t.pages) {
              var n = {};
              (t.pages || []).forEach(function (e) {
                e.blocks && e.blocks.forEach(function (e) {
                  if ("contact" === e.type) {
                    (e.value || []).forEach(function (e) {
                      e.value && (n[e.question + (e.id || "")] = {
                        value: e.value,
                        id: e.id || "",
                        type: wn(e)
                      });
                    });
                  } else {
                    if (!e.value) return;
                    if (e.files) return void (n[e.question + (e.id || "")] = {
                      value: e.value,
                      files: e.files || [],
                      id: e.id || ""
                    });
                    if (e.percentage) return void (n[e.question + (e.id || "")] = {
                      value: e.value,
                      percentage: e.percentage,
                      id: e.id || ""
                    });
                    var t = {
                      value: e.value,
                      id: e.id || ""
                    };
                    "selection" === e.type && e.other && e.other.input && (t.value.push(e.other.input), t.other = e.other), n[e.question + (e.id || "")] = t;
                  }
                });
              }), (e.pages || []).forEach(function (e) {
                e.blocks && e.blocks.forEach(function (e) {
                  if ("contact" !== e.type) {
                    var t = e.question + (e.id || "");

                    if (n[t]) {
                      if (n[t].files) return void (e.id ? e.id === n[t].id && (e.files = n[t].files, e.value = n[t].value, delete n[t]) : (e.files = n[t].files, e.value = n[t].value, delete n[t]));
                      if (n[t].percentage) return void (e.id ? e.id === n[t].id && (e.percentage = n[t].percentage, e.value = n[t].value, delete n[t]) : (e.percentage = n[t].percentage, e.value = n[t].value, delete n[t]));
                      var r = n[t].value;

                      if (e.id) {
                        if (e.id === n[t].id) {
                          if ("selection" === e.type) {
                            if (Array.isArray(n[t].value)) {
                              var o = e.answers.map(function (e) {
                                return e.value;
                              });
                              r.forEach(function (e, t) {
                                o.includes(e) || r.splice(t, 1);
                              });
                            }

                            n[t].other && e.other && n[t].other.value === e.other.value && (e.other = s({}, n[t].other), e.showOther = !0);
                          }

                          if ("number-scale" === e.type) if (!(e.scale.map(function (e) {
                            return e.toString();
                          }) || []).includes(r.toString())) return;

                          if ("matrix" === e.type) {
                            var i = e.value.map(function (e) {
                              return e.question;
                            }) || [],
                                a = e.columns.map(function (e) {
                              return e.value;
                            }) || [];
                            r.forEach(function (e, t) {
                              i.includes(e.question) || r.splice(t, 1);
                            }), r.forEach(function (e, t) {
                              a.includes(e.value) || delete r[t].value;
                            });
                          }

                          e.value = r, delete n[t];
                        }
                      } else {
                        if ("selection" === e.type && Array.isArray(n[t].value)) {
                          var c = e.answers.map(function (e) {
                            return e.value;
                          });
                          r.forEach(function (e, t) {
                            c.includes(e) || r.splice(t, 1);
                          });
                        }

                        if ("number-scale" === e.type) if (!(e.scale.map(function (e) {
                          return e.toString();
                        }) || []).includes(r.toString())) return;

                        if ("matrix" === e.type) {
                          var l = e.value.map(function (e) {
                            return e.question;
                          }) || [],
                              u = e.columns.map(function (e) {
                            return e.value;
                          }) || [];
                          r.forEach(function (e, t) {
                            l.includes(e.question) || r.splice(t, 1);
                          }), r.forEach(function (e, t) {
                            u.includes(e.value) || delete r[t].value;
                          });
                        }

                        e.value = r, delete n[t];
                      }
                    }
                  } else {
                    e.value && (e.value || []).forEach(function (e) {
                      var t = e.question + (e.id || ""),
                          r = wn(e);

                      if (n[t]) {
                        if (r !== n[t].type) return;
                        var o = n[t].value;

                        if (e.id) {
                          if (e.id === n[t].id) {
                            if ("select" === r) if (!(e.select || []).includes(o)) return;
                            e.value = o, delete n[t];
                          }
                        } else {
                          if ("select" === r) if (!(e.select || []).includes(o)) return;
                          e.value = o, delete n[t];
                        }
                      }
                    });
                  }
                });
              });
            }
          }(e, t), t.currentPage && (e.currentPage = t.currentPage), t.comments && (e.comments = t.comments), window.ns_set_slide && window.ns_set_slide(t.currentPage), window.nf_saved_form_loading = !0);
        }

        if (e.openedTimestamp = new Date().getTime(), e.source = P, e.customFont && (r = e.customFont, (o = document.createElement("style")).innerHTML = "body { font-family: ".concat(r, " !important; } h1, h2, h3, span, p, button, input, textarea { font-family: ").concat(r, " !important;}"), document.head.appendChild(o)), e.customJavaScript && En(e.customJavaScript), e.customFavicon && function (e) {
          if (e.customFavicon) {
            var t = document.querySelector("link[rel*='icon']") || document.createElement("link");
            t.type = "image/x-icon", t.rel = "shortcut icon", t.href = e.customFavicon, document.getElementsByTagName("head")[0].appendChild(t);
          }
        }(e), m) {
          window.document.title = e.customDocumentTitle || e.label || "NativeForms";
          var n = e.backgroundColor || ee.white;
          document.body.style.backgroundColor = n, document.querySelector("meta[name=theme-color]").setAttribute("content", e.backgroundColor || ee.white);
        }

        !function (e) {
          var t = e.google_analytics;

          if (t) {
            var n = t.id;

            if (n) {
              var r = document.createElement("script");
              r.src = "https://www.googletagmanager.com/gtag/js?id=".concat(n), r.async = !0, r.onload = function () {
                setTimeout(function () {
                  te(e);
                }, 1e3);
              }, window.dataLayer = window.dataLayer || [], window.gtag = function () {
                window.dataLayer.push(arguments);
              }, window.gtag("js", new Date()), window.gtag("config", n, {
                cookie_flags: "secure;samesite=none"
              }), document.head.appendChild(r);
            }
          }
        }(e), function (e) {
          var t = e.facebook_pixel;

          if (t) {
            var n,
                r,
                o,
                i,
                a,
                c,
                l = t.id;
            if (l) n = window, r = document, o = "script", n.fbq || (i = n.fbq = function () {
              i.callMethod ? i.callMethod.apply(i, arguments) : i.queue.push(arguments);
            }, n._fbq || (n._fbq = i), i.push = i, i.loaded = !0, i.version = "2.0", i.queue = [], (a = r.createElement(o)).async = !0, a.src = "https://connect.facebook.net/en_US/fbevents.js", (c = r.getElementsByTagName(o)[0]).parentNode.insertBefore(a, c), a.onload = function () {
              setTimeout(function () {
                un(e);
              }, 1e3);
            }), window.fbq("init", l), window.fbq("track", "PageView");
          }
        }(e);
      }

      var r, o;
      y(s({}, e));
    }
  };

  return t.useEffect(function () {
    r || o || i || (Q(h.editMode ? "No form selected to display" : ie), T(h.editMode ? "No form selected to display" : ie));
  }, [r, o, i]), t.useEffect(function () {
    var e, t, n, i, c, l, s, u, d;
    (r || o) && a.async(function (f) {
      for (;;) {
        switch (f.prev = f.next) {
          case 0:
            if (k(!0), !O.nf_form) {
              f.next = 6;
              break;
            }

            e = decodeURIComponent(O.nf_form);

            try {
              q(JSON.parse(e));
            } catch (e) {
              console.error(e);
            }

            return k(!1), f.abrupt("return");

          case 6:
            if (f.prev = 6, !O.nf_id) {
              f.next = 15;
              break;
            }

            return t = ke("/".concat(O.nf_id)), n = t.parameters, i = t.search, f.next = 11, a.awrap(C({
              parameters: n,
              search: i,
              source: P,
              queryParams: O
            }));

          case 11:
            return c = f.sent, q(c), k(!1), f.abrupt("return");

          case 15:
            if (l = ke(r, o), s = l.parameters, u = l.search, !O.nf_form_id) {
              f.next = 22;
              break;
            }

            return f.next = 19, a.awrap(N({
              license: s.l,
              formID: O.nf_form_id
            }));

          case 19:
            d = f.sent, f.next = 25;
            break;

          case 22:
            return f.next = 24, a.awrap(C({
              parameters: s,
              search: u,
              source: P,
              queryParams: O
            }));

          case 24:
            d = f.sent;

          case 25:
            q(d), f.next = 33;
            break;

          case 28:
            f.prev = 28, f.t0 = f.catch(6), console.error(f.t0), Q(f.t0.message), T(h.editMode ? "No form selected to display" : ie);

          case 33:
            k(!1);

          case 34:
          case "end":
            return f.stop();
        }
      }
    }, null, null, [[6, 28]]);
  }, [r, o]), t.useEffect(function () {
    i && q(i);
  }, [i, f]), z ? n.createElement(n.Fragment, null, p && n.createElement(Ce, {
    form: b,
    onClose: c
  }), n.createElement(G, {
    showHeader: p,
    error: z,
    form: b
  })) : E ? n.createElement(n.Fragment, null, p && n.createElement(Ce, {
    form: b,
    onClose: c
  }), n.createElement(Y, null)) : b ? n.createElement("div", {
    dir: b.isRTL ? "rtl" : "ltr",
    className: "nf-root"
  }, p && n.createElement(Ce, {
    form: b,
    onClose: c
  }), n.createElement(yn, Object.assign({
    form: b,
    onClose: c,
    isLive: j,
    isPreview: _,
    showHeader: p,
    submit: g
  }, h))) : n.createElement("div", null);
}

qt("body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}button,h1,h2,h3,input,option,p,select,span,textarea{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", "nf-form-font-global-styles"), qt("\n  @-webkit-keyframes nf-fade-in{from{opacity:0}to{opacity:1}}@keyframes nf-fade-in{from{opacity:0}to{opacity:1}}\n  @-webkit-keyframes nf-fade-out{from{opacity:1}to{opacity:0}}@keyframes nf-fade-out{from{opacity:1}to{opacity:0}}\n  @-webkit-keyframes nf-spin{from{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes nf-spin{from{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}\n  @-webkit-keyframes nf-bounce-in{0%{-webkit-transform:translateY(0) scale(0) rotate(-70deg);transform:translateY(0) scale(0) rotate(-70deg)}50%{-webkit-transform:translateY(-12px) scale(1.06) rotate(0);transform:translateY(-12px) scale(1.06) rotate(0)}100%{-webkit-transform:translateY(0) scale(1);transform:translateY(0) scale(1)}}@keyframes nf-bounce-in{0%{-webkit-transform:translateY(0) scale(0) rotate(-70deg);transform:translateY(0) scale(0) rotate(-70deg)}50%{-webkit-transform:translateY(-12px) scale(1.06) rotate(0);transform:translateY(-12px) scale(1.06) rotate(0)}100%{-webkit-transform:translateY(0) scale(1);transform:translateY(0) scale(1)}}\n  @-webkit-keyframes nf-slide-left{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}100%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes nf-slide-left{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}100%{-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes nf-slide-left-close{0%{-webkit-transform:translateX(0);transform:translateX(0)}100%{-webkit-transform:translateX(100%);transform:translateX(100%)}}@keyframes nf-slide-left-close{0%{-webkit-transform:translateX(0);transform:translateX(0)}100%{-webkit-transform:translateX(100%);transform:translateX(100%)}}@-webkit-keyframes nf-slide-right{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}100%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes nf-slide-right{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}100%{-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes nf-slide-right-close{0%{-webkit-transform:translateX(0);transform:translateX(0)}100%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}@keyframes nf-slide-right-close{0%{-webkit-transform:translateX(0);transform:translateX(0)}100%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}\n  @-webkit-keyframes nf-scale-in{0%{opacity:0;-webkit-transform:scale(.8);transform:scale(.8)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes nf-scale-in{0%{opacity:0;-webkit-transform:scale(.8);transform:scale(.8)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}\n  @-webkit-keyframes nf-slide-down{0%{opacity:0;-webkit-transform:translateY(-100px);transform:translateY(-100px)}100%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes nf-slide-down{0%{opacity:0;-webkit-transform:translateY(-100px);transform:translateY(-100px)}100%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}\n  ", "nf-global-animations"), qt("".concat(".nf-root{width:100%;height:100%;position:relative}.nf-form-wrapper{width:100%;height:100%;-webkit-overflow-scrolling:touch;overscroll-behavior-x:none}").concat(it).concat(".nf-inputs-wrapper{width:100%;background-color:transparent;box-sizing:border-box;padding:18px 22px;max-width:600px}@media (max-width:600px){.nf-inputs-wrapper{padding:18px}}").concat(".nf-date-picker-container{display:flex;flex-direction:column;width:100%;background-color:transparent;align-items:center;max-width:600px;box-sizing:border-box;padding:28px 12px}").concat(Lr).concat(".nf-image-container{display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;width:100%;box-sizing:border-box}.nf-video-container{display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;width:100%;box-sizing:border-box}").concat(Wt).concat(".nf-number-scale-container{display:flex;flex-wrap:wrap;flex-shrink:0;flex-direction:row;justify-content:center;width:100%;background-color:transparent;box-sizing:border-box;padding:28px 16px 20px 16px;max-width:600px}.nf-number-container{display:flex;align-items:center;justify-content:center;margin-left:-1px;box-sizing:border-box;margin-top:16px;cursor:pointer;transition:opacity .2s ease-out;text-decoration:none}.nf-number-container:active{opacity:.75}.nf-number{text-align:center;font-size:15px}.nf-number-scale-legend{display:flex;flex-direction:row;width:100%;box-sizing:border-box;padding:4px 24px 32px 24px;max-width:600px;background-color:transparent}.nf-number-scale-text{font-size:13px;padding:6px}").concat(".nf-open-container{display:flex;flex-direction:column;width:100%;background-color:transparent;align-items:flex-start;max-width:600px;box-sizing:border-box;padding:24px 22px}").concat(".nf-selection-container{display:flex;flex-direction:column;width:100%;background-color:transparent;max-width:600px;box-sizing:border-box;padding:24px 22px}.nf-selection-inline-container{display:flex;flex-direction:row;align-items:center;justify-content:center;flex-wrap:wrap;width:100%;background-color:transparent;max-width:600px;box-sizing:border-box;padding:24px 22px}.nf-selection-answer{display:flex;flex-direction:row;width:100%;align-items:center;box-sizing:border-box;padding:16px;box-shadow:2px 2px 6px 0 rgba(29,36,86,.02);border-radius:8px;margin-bottom:20px;border-width:1px;border-style:solid;cursor:pointer;transition:opacity .2s ease-out;text-decoration:none}.nf-selection-answer:active{opacity:.75}.nf-selection-inline-answer{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:12px;box-shadow:2px 2px 6px 0 rgba(29,36,86,.02);margin:8px 6px;border-radius:8px;border-width:1px;border-style:solid;cursor:pointer;transition:opacity .2s ease-out;text-decoration:none}.nf-selection-inline-answer:active{opacity:.75}.nf-selection-checkbox{display:flex;flex-shrink:0;flex-direction:column;align-items:center;justify-content:center;width:15px;height:15px;border-width:1px;border-style:solid} .nf-selection-image-answer{width:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;} .nf-answer-label{font-size:14px;line-height:1.5;letter-spacing:.5px;text-align:left} @media (max-width:600px){.nf-selection-container{padding:24px 20px}}").concat(".nf-slider-container{display:flex;flex-shrink:0;flex-direction:column;background-color:transparent;box-sizing:border-box;align-items:center;align-self:center;padding:42px 16px 36px 16px;width:100%;max-width:540px}.nf-slider-value{font-size:14.5px;margin-bottom:36px;font-weight:500;text-align:center}.nf-slider-legend{display:flex;flex-direction:row;justify-content:space-between;width:100%}.nf-slider-legend-text{font-size:13px;text-align:center;margin-top:24px}.nf-slider-line-container{position:relative;width:98%;height:6px;border-radius:6px}.nf-slider-line{position:absolute;height:6px;border-radius:6px}.nf-slider-thumb{cursor:pointer;user-select:none;width:40px;height:40px;top:-17px;position:absolute;z-index:1;border-radius:50%;display:flex;align-items:center;justify-content:center;transform-origin:center;box-sizing:border-box;transition:box-shadow .2s ease-out;box-shadow:2px 2px 8px 0 rgba(29,36,86,.04)}.nf-slider-thumb:hover{box-shadow:2px 2px 12px 0 rgba(29,36,86,.1)}@media (max-width:600px){.nf-slider-container{width:92%;padding:36px 16px 32px 16px}}").concat(".nf-stars-container{display:flex;flex-direction:row;justify-content:center;flex-shrink:0;width:100%;background-color:transparent;max-width:600px;box-sizing:border-box;padding:24px 16px}").concat(Ie).concat(".nf-answers-container{position:relative;display:flex;flex-direction:column;width:100%;box-shadow:2px 2px 6px 0 rgba(29,36,86,.02);border-radius:8px;margin:12px 0;box-sizing:border-box}.nf-answers-header-container{display:flex;flex-direction:row;flex:1;justify-content:space-between;padding:10px 24px 10px 16px;box-sizing:border-box;box-shadow:2px 2px 6px 0 rgba(29,36,86,.02);flex-shrink:0;z-index:1}.nf-answers-header{display:flex;font-size:12px;width:100%;text-transform:uppercase}.nf-answers-row{display:flex;flex-direction:row;flex:1;width:100%;padding:12px 24px 12px 16px;box-sizing:border-box}.nf-answers-number{font-size:13px;line-height:15px;font-weight:600}.nf-answers-chart-container{display:flex;flex-direction:row;margin:32px 24px 12px 24px;font-size:14px}@media (max-width:600px){.nf-answers-header-container{padding:10px 12px}.nf-answers-chart-container{margin:32px 12px 8px 12px;flex-direction:column;font-size:12px}.nf-answers-header{font-size:11px}.nf-answers-row{padding:10px 12px}.nf-answers-chart-container{margin:32px 12px 8px 12px;flex-direction:column;font-size:12px;flex-direction:column;align-items:center;justify-content:center}}.nf-answers-actions-container{position:absolute;display:flex;flex-direction:row;top:16px;right:12px}.nf-answers-icon-button{cursor:pointer;display:flex;align-items:center;justify-content:center;padding:6px;border-radius:4px;box-shadow:2px 2px 6px 0 rgba(29,36,86,.02);margin:0 4px}").concat(".nf-badge-container{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;margin-top:-11px;z-index:4}.nf-badge{font-size:10px;border-radius:10px;padding:4px 12px;text-transform:uppercase;box-sizing:border-box}").concat(".nf-legend-container{display:flex;flex-direction:column;padding:8px 16px}.nf-legend-row{display:flex;flex-direction:row;align-items:center;margin:8px}.nf-legend-color{width:18px;height:18px;flex-shrink:0}@media (max-width:600px){.nf-legend-container{padding:8px}}").concat(".nf-question{display:flex;flex-direction:column;align-items:center;-webkit-animation-name:nf-fade-in;animation-name:nf-fade-in;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-timing-function:linear;animation-timing-function:linear}").concat(Tn).concat(".nf-submit-button-container{display:flex;flex-direction:column;width:100%;max-width:600px;box-sizing:border-box;padding-top:6px;padding-left:22px;padding-right:22px}.nf-submit-button{background: none;border:none;cursor:pointer;display:flex;flex-direction:row;align-items:center;justify-content:center;border-radius:8px;z-index:1;box-sizing:border-box;min-height:50px;padding-top:14px;padding-bottom:14px;padding-left:20px;padding-right:20px;width:100%;height:50px;font-size:14px;letter-spacing:.4px;font-weight:600;text-align:center;transition:box-shadow .2s ease-out,opacity .2s ease-out;box-shadow:2px 2px 8px 0 rgba(29,36,86,.06)}.nf-submit-button:focus{opacity:0.9;box-shadow:2px 2px 12px 0 rgba(29,36,86,.24)}.nf-submit-button:hover{opacity:0.9;box-shadow:2px 2px 12px 0 rgba(29,36,86,.24)}.nf-submit-button:active{opacity:0.8;box-shadow:2px 2px 12px 0 rgba(29,36,86,.3)}.nf-uploading-progress{font-size:14px;font-weight:600;margin-right:12px}.nf-spinner{border:2px solid transparent;border-top:2px solid #fff;border-right:2px solid #fff;border-radius:50%;width:14px;height:14px;-webkit-animation-name:nf-spin;animation-name:nf-spin;-webkit-animation-duration:.75s;animation-duration:.75s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear}").concat(".nf-spinner-primary{border:2px solid #ced6dd;border-top:2px solid #000;border-radius:50%;width:18px;height:18px;-webkit-animation-name:nf-spin;animation-name:nf-spin;-webkit-animation-duration:.75s;animation-duration:.75s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear}.nf-loading-container{display:flex;flex-direction:column;align-items:center;justify-content:center;box-sizing:border-box;padding-top:60px;padding-bottom:60px;width:100%;height:100%}").concat(".nf-form-container{display:flex;flex-direction:column;flex:1;width:100%}.nf-empty-form{display:flex;flex-direction:column;align-items:center;box-sizing:border-box;padding-top:32px;padding-bottom:24px}.nf-questions-container{display:flex;flex-direction:column;width:100%}.nf-empty-form-text{font-size:15px;color:#000}").concat(".nf-header-container{display:flex;flex-direction:row;align-items:center;width:100%;padding:16px 10px 16px 16px;box-sizing:border-box;border-bottom-width:1px;border-bottom-style:solid;flex-shrink:0}.nf-header{font-weight:400;font-size:14px;flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.nf-header-close{cursor:pointer;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:opacity .2s ease-out}.nf-header-close:hover{opacity:.5}").concat(Et).concat(".nf-link{cursor:pointer;transition:opacity .2s ease-out;text-decoration:none}.nf-link:hover{opacity:.75}.nf-powered-by-container{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:28px;-webkit-animation-name:nf-fade-in;animation-name:nf-fade-in;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-timing-function:linear;animation-timing-function:linear}", "\n    ").concat(".nf-star-container{display:flex;flex-direction:column;align-items:center;cursor:pointer;transition:opacity .2s ease-out;text-decoration:none}.nf-star-container:active{opacity:.75}.nf-star-animation{animation-name:nf-bounce-in;animation-duration:.5s;animation-timing-function:ease-in-out}.nf-star-label{font-size:13px;padding:6px;max-width:64px;text-align:center}").concat(".nf-error-container{display:flex;flex-direction:column;align-items:center;justify-content:center;box-sizing:border-box;padding-top:60px;padding-bottom:60px;width:100%;height:100%}.nf-error-header{font-size:16px;line-height:1.5;color:#000;padding-top:16px;padding-bottom:8px;text-align:center;font-weight:600}.nf-error-description{font-size:14px;line-height:1.5;color:#000;text-align:center;max-width:200px}").concat(".nf-logo-container{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%}").concat(".nf-avatar{display:flex;align-items:center;justify-content:center;color:#fff;background-color:#fff;border-radius:50%;text-decoration:none;user-select:none;flex-shrink:0}").concat(".nf-page-controller{display:flex;flex-direction:row;align-items:center;width:100%;max-width:600px;box-sizing:border-box;padding:4px 22px 16px 22px}.nf-arrow-button{ padding:6px 8px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;min-width:50px;height:50px;border-radius:8px;box-sizing:border-box;box-shadow:2px 2px 8px 0 rgba(29,36,86,.03);transition:box-shadow .2s ease-out,opacity .2s ease-out;}.nf-arrow-button:hover{opacity:0.8!important;box-shadow:2px 2px 12px 0 rgba(29,36,86,.16)}.nf-arrow-button:focus{opacity:0.8!important;box-shadow:2px 2px 12px 0 rgba(29,36,86,.16)} @media (max-width:600px){.nf-page-controller{padding:4px 18px 16px 18px}}").concat(".nf-poll-container{display:flex;flex-direction:column;width:100%;align-items:center}.nf-poll-wrapper{display:flex;flex-direction:column;align-items:center;box-sizing:border-box;padding:28px 32px;width:100%;max-width:800px;-webkit-animation-name:nf-fade-in;animation-name:nf-fade-in;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-timing-function:linear;animation-timing-function:linear}@media (max-width:600px){.nf-poll-wrapper{padding:16px 8px}}").concat(".nf-progress-container{display:flex;flex-direction:column;align-items:center;width:100%;padding-left:20px;padding-right:20px}.nf-progress-text{font-size:12px;text-align:center;white-space:nowrap;overflow:hidden;padding-bottom:6px}.nf-progress-line-container{position:relative;width:100%;height:5px;border-radius:6px}.nf-progress-line{position:absolute;height:5px;border-radius:6px;transition:width .3s ease-out}@media (max-width:600px){.nf-progress-container{padding-left:12px;padding-right:12px}}").concat(".quiz-score-container{display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;width:100%;box-sizing:border-box;padding:16px 8px;-webkit-animation-name:nf-fade-in;animation-name:nf-fade-in;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-timing-function:linear;animation-timing-function:linear}.quiz-score{font-size:15px;font-weight:600;text-align:center;letter-spacing:.5px}").concat(Ue).concat(We).concat(".nf-status-container{display:flex;flex-direction:column;width:100%;height:100%;align-items:center;justify-content:center}.nf-status-wrapper{display:flex;flex-direction:column;align-items:center;justify-content:center;box-sizing:border-box;-webkit-animation-name:nf-fade-in;animation-name:nf-fade-in;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-timing-function:linear;animation-timing-function:linear}.nf-status-header{font-size:16px;line-height:1.5;padding-top:16px;margin:0;font-weight:600;text-align:center}.nf-status-description{max-width:360px;padding:6px;box-sizing:border-box;font-size:14px;line-height:1.5;text-align:center}.nf-submit-screen-action{display:flex;align-items:center;justify-content:center;padding:10px 10px 0 10px;font-size:14px;font-weight:500;text-align:center;box-sizing:border-box;color:#20f;text-decoration:none}").concat(".nf-widget-container{position:fixed;cursor:pointer;display:flex;flex-direction:column;-webkit-transform:translateY(-50%);transform:translateY(-50%);-webkit-tap-highlight-color:transparent;box-shadow:0 2px 12px rgba(0,0,0,.16);transition:box-shadow .3s linear}.nf-widget-container:hover{box-shadow:0 4px 24px rgba(0,0,0,.3)}.nf-widget-container-edit-mode{position:absolute}.nf-widget-badge{font-weight:500;white-space:pre;padding:10px 0;background-color:transparent;text-align:center}@media (max-width:767px){.nf-widget-hide-mobile{display:none}}").concat(".nf-widget-form-container{overflow: auto;width:100%;height:100%}.nf-widget-slider-container{position:fixed;top:0;bottom:0;height:100%;overflow:hidden;-webkit-overflow-scrolling:touch;width:680px;max-width:680px;display:flex;flex-direction:column;z-index:2147483002;background-color:#fff;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}.nf-widget-slider-edit-mode{position:absolute;z-index:1}.nf-widget-slider-right-border{right:0;border-right:1px solid #ced6dd}.nf-widget-slider-left-border{right:0;border-left:1px solid #ced6dd}.nf-widget-slider-left-animation{-webkit-animation-name:nf-slide-left;animation-name:nf-slide-left}.nf-widget-slider-left-close-animation{-webkit-animation-name:nf-slide-left-close;animation-name:nf-slide-left-close}.nf-widget-slider-right-animation{-webkit-animation-name:nf-slide-right;animation-name:nf-slide-right}.nf-widget-slider-right-close-animation{-webkit-animation-name:nf-slide-right-close;animation-name:nf-slide-right-close}@media (max-width:1280px){.nf-widget-slider-container{width:580px;max-width:580px}}@media (max-width:800px){.nf-widget-slider-container{width:100vw;max-width:100vw;border:none;left:0;right:0}}").concat(".nf-select-field-mobile{-webkit-appearance:none;border-width:1px;border-style:solid;border-radius:8px;padding:13px;box-sizing:border-box;margin-top:6px;margin-bottom:6px;width:100%;font-size:14px;box-shadow: 0 1px 3px rgba(50, 50, 93, 0.05);height:48px; background: white url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6dHJhbnNwYXJlbnQ7fS5jbHMtMntmaWxsOiM0NDQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5hcnJvd3M8L3RpdGxlPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjQuOTUiIGhlaWdodD0iMTAiLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMS40MSA0LjY3IDIuNDggMy4xOCAzLjU0IDQuNjcgMS40MSA0LjY3Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjMuNTQgNS4zMyAyLjQ4IDYuODIgMS40MSA1LjMzIDMuNTQgNS4zMyIvPjwvc3ZnPg==) no-repeat 97% 50%; background-size: 18px;}").concat(".nf-select-field-input{-webkit-appearance:none;border-width:1px;border-style:solid;border-radius:8px;padding:13px;box-sizing:border-box;margin-top:6px;margin-bottom:6px;width:100%;font-size:14px;box-shadow: 0 1px 3px rgba(50, 50, 93, 0.05);height:48px}.nf-select-field-items-container{box-shadow:0 2px 8px rgba(0,0,0,.16);max-height:280px;overflow:auto;margin-top:-2px;border-radius:8px;width:100%;display:flex;flex-direction:column;-webkit-animation-name:nf-fade-in;animation-name:nf-fade-in;-webkit-animation-duration:.1s;animation-duration:.1s;-webkit-animation-timing-function:linear;animation-timing-function:linear;outline:0;z-index:9999}.nf-select-field-item{background: none; border: none; margin: 0; text-align: left; cursor:pointer;box-sizing:border-box;padding:15px 16px;font-size:13.5px;font-weight:400;line-height:1.5;transition:opacity .1s ease-out}.nf-select-field-item:active{opacity:.5}.nf-select-field-item:hover{opacity:.8;background-color:#99999922;}").concat(".nf-multi-select-item{background:none;border:none;margin:0;text-align:left;cursor:pointer;box-sizing:border-box;font-size:13px;font-weight:500;line-height:1.3;transition:opacity .1s ease-out;display:flex;flex-direction:row;align-items:center;width:100%;flex-shrink:0}.nf-multi-select-item:active{opacity:.5}.nf-multi-select-item:hover{opacity:.8;background-color:#88888820}.nf-multi-select-item-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.nf-multi-select-field-container{position:relative;min-height:48px;cursor:pointer;display:flex;flex-direction:row;align-items:center;flex-wrap:wrap;border-width:1px;border-style:solid;border-radius:8px;box-sizing:border-box;margin-top:6px;margin-bottom:6px;width:100%;font-size:14px;box-shadow:0 1px 3px rgba(50,50,93,0.05)}.nf-multi-select-item-selected{text-align:left;box-sizing:border-box;padding:2px 10px 2px 4px;font-size:13.5px;font-weight:400;line-height:1.3;display:flex;flex-direction:row;align-items:center;flex-shrink:0}.nf-multi-select-item-checkbox{display:flex;align-items:center;justify-content:center;flex-shrink:0;width:16px;height:16px;box-sizing:border-box;margin-right:10px}.nf-multi-select-field-input{-webkit-appearance:none;padding:0;margin:0;box-sizing:border-box;font-size:14px;border:none;outline:none;height:22px}.nf-multi-select-item-column{padding-left:10px;display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start}.nf-multi-select-item-description{font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-top:4px}.nf-multi-select-field-input::placeholder{color:#656565;}").concat(".nf-toast-container{display:flex;flex-direction:row;align-items:center;width:330px;box-sizing:border-box;padding:13px 12px;border-radius:4px;-webkit-animation-name:nf-slide-down;animation-name:nf-slide-down;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}.nf-toasts-wrapper{display:flex;flex-direction:column;align-items:center;z-index:20000;position:absolute;left:calc(50%);-webkit-transform:translateX(-50%);transform:translateX(-50%)} .nf-toast-out-animation{-webkit-animation-name:nf-fade-out;animation-name:nf-fade-out;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}").concat(".nf-checkbox-container{background: none; color: inherit; border: none; padding: 0; margin: 0; display:flex;flex-direction:row;align-self:flex-start;align-items:flex-start;cursor:pointer;transition:opacity .2s ease-out;padding:8px 4px}.nf-checkbox-container:active{opacity:.7}.nf-checkbox{display:flex;flex-direction:column;align-items:center;justify-content:center;margin:2px 0;width:18px;height:18px;border-radius:2px}.nf-checkbox-label{flex-direction:row;flex-wrap:wrap;align-items:flex-start;justify-content:flex-start;font-size:13.5px;line-height:1.7;text-align:left;padding-left:10px;font-weight:500}@media (max-width:600px){.nf-checkbox-label{font-size:13px;}}").concat(".nf-stripe-wrapper{width:100%;background-color:transparent;box-sizing:border-box;padding:18px 22px;max-width:600px}.nf-stripe-container{display:flex;flex-direction:column;position:relative;align-items:center;justify-content:center;width:100%;margin:28px 0 20px 0}.nf-stripe-label{display:flex;align-items:center;justify-content:center;font-size:11px;margin-top:20px}"), "nf-global");

var Fr = function Fr(e, t) {
  if (!e) return "";
  var n = e,
      r = window.nativeForms || {},
      o = window.intercomSettings || {},
      i = r.user,
      a = void 0 === i ? {} : i;
  return o.email && (a.email = o.email), o.name && (a.name = o.name), r.email && (a.email = r.email), r.name && (a.name = r.name), r.phone && (a.phone = r.phone), r.avatar && (a.avatar = r.avatar), t && "string" == typeof t && (n += n.indexOf("?") > -1 ? "&" : "?", "bubble" === t && (n += "bubble=true"), "widget" === t && (n += "widget=true")), a && "object" == typeof a && Object.keys(a).forEach(function (e) {
    a[e] && (n += n.indexOf("?") > -1 ? "&" : "?", n += encodeURIComponent(e) + "=" + encodeURIComponent(a[e]));
  }), n;
};

function Br(e) {
  var r = e.form,
      o = e.onClose,
      i = e.editMode,
      a = e.position,
      c = void 0 === a ? "right" : a,
      l = e.title,
      s = d(e, ["form", "onClose", "editMode", "position", "title"]),
      f = u(t.useState(), 2),
      p = f[0],
      m = f[1],
      g = u(t.useState(!0), 2),
      h = g[0],
      v = g[1],
      b = function b() {
    v(!1), setTimeout(function () {
      o();
    }, 480);
  };

  return n.createElement("div", {
    className: "nf-widget-slider-container ".concat(i ? "nf-widget-slider-edit-mode" : "", " ").concat("right" === c ? "nf-widget-slider-left-border" : "nf-widget-slider-right-border", " ").concat("right" === c ? h ? "nf-widget-slider-left-animation" : "nf-widget-slider-left-close-animation" : h ? "nf-widget-slider-right-animation" : "nf-widget-slider-right-close-animation")
  }, n.createElement(Ce, {
    title: l,
    form: p,
    onClose: b
  }), n.createElement("div", {
    className: "nf-widget-form-container"
  }, n.createElement(Ar, Object.assign({
    editMode: i,
    form: Fr(r, "widget"),
    onClose: b,
    onFormLoad: function onFormLoad(e) {
      return m(e);
    },
    onSend: function onSend() {
      return setTimeout(b, 2e3);
    }
  }, s))));
}

var Vr = function Vr(e) {
  var t = e.onClick,
      r = e.bubble,
      o = e.logo,
      i = e.position,
      a = e.editMode,
      c = r.background,
      l = void 0 === c ? ee.main : c,
      s = r.size,
      u = void 0 === s ? 54 : s,
      d = r.iconSize,
      f = void 0 === d ? 28 : d,
      p = r.iconColor,
      m = void 0 === p ? "#ffffff" : p,
      g = r.verticalMargin,
      h = void 0 === g ? 20 : g,
      v = r.horizontalMargin,
      b = void 0 === v ? 20 : v,
      x = {
    display: "flex",
    position: a ? "absolute" : "fixed",
    zIndex: a ? 1 : 2140483002,
    bottom: "".concat(h, "px")
  };
  "right" === i ? x.right = "".concat(b, "px") : x.left = "".concat(b, "px");
  var y = {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: "".concat(u, "px"),
    height: "".concat(u, "px"),
    backgroundColor: l,
    borderRadius: "50%",
    "-webkit-tap-highlight-color": "transparent",
    boxShadow: "0 5px 30px rgba(0, 0, 0, 0.2)",
    transition: "box-shadow 300ms linear"
  },
      w = {
    width: "".concat(u, "px"),
    height: "".concat(u, "px"),
    borderRadius: "50%"
  };
  return n.createElement("div", {
    style: x
  }, n.createElement("div", {
    onClick: t,
    style: y
  }, o && n.createElement("img", {
    style: w,
    src: o,
    alt: "logo"
  }), !o && n.createElement(B, {
    width: f,
    height: f,
    fill: m
  })));
};

function Wr(e) {
  var r = e.form,
      o = (e.formLoggedIn, e.onClose),
      i = e.onSend,
      a = (e.source, e.title),
      c = e.headerBackgroundColor,
      l = e.headerTextColor,
      s = e.headerStyle,
      f = e.modal,
      p = void 0 === f ? {} : f,
      m = d(e, ["form", "formLoggedIn", "onClose", "onSend", "source", "title", "headerBackgroundColor", "headerTextColor", "headerStyle", "modal"]),
      g = window.innerWidth <= 600,
      h = u(t.useState(null), 2),
      v = h[0],
      b = h[1],
      x = u(t.useState(!0), 2),
      y = x[0],
      w = x[1],
      E = function E() {
    w(!1), setTimeout(function () {
      o();
    }, 0);
  };

  if (t.useEffect(function () {
    var e = function e(_e5) {
      return 27 === _e5.keyCode && o();
    };

    return document.addEventListener("keyup", e, !0), function () {
      document.removeEventListener("keyup", e, !0);
    };
  }, [o]), t.useEffect(function () {
    var e = function e(_e6) {
      try {
        var t = JSON.parse(_e6.data);

        if (t.nf_event && "form_fetched" === t.nf_event.event && b(JSON.parse(t.nf_event.form) || {}), t.nf_event && "form_send" === t.nf_event.event) {
          var n = JSON.parse(t.nf_event.form) || {};
          setTimeout(E, 2e3), i && i(n);
        }
      } catch (e) {}
    };

    return window.addEventListener("message", e, !1), function () {
      window.removeEventListener("message", e);
    };
  }, [E]), g) return n.createElement(Br, e);
  var k = {
    width: p.width || "640px",
    height: p.height || "600px",
    maxWidth: "96%",
    maxHeight: "84%",
    backgroundColor: p.backgroundColor || "#ffffff",
    borderRadius: "8px"
  };
  return y ? n.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 2147483002,
      animation: "native-forms-fade-in 200ms linear"
    },
    onClick: function onClick(e) {
      return e.target === e.currentTarget && o();
    }
  }, n.createElement("div", {
    style: k
  }, n.createElement(Ce, {
    title: a,
    form: v,
    onClose: E,
    backgroundColor: c,
    textColor: l,
    headerStyle: s,
    borderRadius: 8
  }), n.createElement("div", {
    className: "nf-widget-form-container",
    style: {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8
    }
  }, n.createElement(Ar, Object.assign({
    form: Fr(r, "widget"),
    onClose: E,
    onFormLoad: function onFormLoad(e) {
      return b(e);
    },
    onSend: function onSend() {
      return setTimeout(E, 2e3);
    }
  }, m))))) : n.createElement("div", null);
}

exports.CUSTOMER_PROPERTIES = re, exports.InputField = wt, exports.LoadingError = G, exports.NativeForms = Ar, exports.NativeFormsWidget = function (e) {
  var r = e.logo,
      o = e.hideMobile,
      i = e.text,
      a = void 0 === i ? "Feedback" : i,
      c = e.position,
      l = void 0 === c ? "right" : c,
      s = e.background,
      f = void 0 === s ? "#333e48" : s,
      p = e.textColor,
      m = void 0 === p ? "#ffffff" : p,
      g = e.logoBackground,
      h = void 0 === g ? "#ffffff" : g,
      v = e.fontSize,
      b = void 0 === v ? 14 : v,
      x = e.width,
      y = void 0 === x ? 36 : x,
      w = e.iconSize,
      E = void 0 === w ? 20 : w,
      k = e.top,
      S = void 0 === k ? 50 : k,
      C = e.editMode,
      N = e.bubble,
      z = e.showModal,
      T = e.rotateText,
      O = d(e, ["logo", "hideMobile", "text", "position", "background", "textColor", "logoBackground", "fontSize", "width", "iconSize", "top", "editMode", "bubble", "showModal", "rotateText"]),
      P = u(t.useState(!1), 2),
      _ = P[0],
      j = P[1],
      q = {
    top: "".concat(S, "%"),
    backgroundColor: f,
    borderTopLeftRadius: "right" === l ? "4px" : "0",
    borderBottomLeftRadius: "right" === l ? "4px" : "0",
    borderTopRightRadius: "left" === l ? "4px" : "0",
    borderBottomRightRadius: "left" === l ? "4px" : "0",
    transformOrigin: "right" === l ? "right top" : "left top",
    zIndex: C ? 1 : 2040483002
  };
  "right" === l ? q.right = 0 : q.left = 0;
  var M = {
    fontSize: "".concat(b, "px"),
    lineHeight: "".concat(b + 1, "px"),
    color: m,
    width: "".concat(y, "px")
  },
      I = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: h,
    width: "".concat(y, "px"),
    height: "".concat(y, "px"),
    borderBottomLeftRadius: "right" === l ? "4px" : "0",
    borderBottomRightRadius: "left" === l ? "4px" : "0"
  },
      L = {
    width: "".concat(E, "px"),
    height: "".concat(E, "px")
  };
  return T && (q["transform-origin"] = "right" === l ? "right bottom" : "left top", q["-webkit-transform"] = "rotate(-90deg)", q["-moz-transform"] = "rotate(-90deg)", q.transform = "rotate(-90deg)", q.display = "flex", q["flex-direction"] = "row", M.padding = "0 12px", M.display = "flex", M["align-items"] = "center", q.borderBottomLeftRadius = "left" === l ? "4px" : "0", q.borderTopRightRadius = "right" === l ? "4px" : "0", M["letter-spacing"] = "1.5px", delete M.width, M.height = y), n.createElement(n.Fragment, null, N ? n.createElement(Vr, {
    bubble: N,
    logo: r,
    hideMobile: o,
    position: l,
    editMode: C,
    onClick: function onClick() {
      return j(!0);
    }
  }) : n.createElement("div", {
    className: "nf-widget-container ".concat(C ? "nf-widget-container-edit-mode" : "", " ").concat(o ? "nf-widget-hide-mobile" : ""),
    style: q,
    onClick: function onClick() {
      return j(!0);
    }
  }, a && n.createElement("span", {
    className: "nf-widget-badge",
    style: M
  }, T ? a : function () {
    for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = "", n = 0; n < e.length; n++) {
      t += e[n] + "\n";
    }

    return t;
  }(a)), r && n.createElement("div", {
    style: I
  }, n.createElement("img", {
    style: L,
    alt: "logo",
    src: r
  }))), _ && (z ? n.createElement(Wr, Object.assign({}, O, {
    position: l,
    editMode: C,
    onClose: function onClose() {
      return j(!1);
    }
  })) : n.createElement(Br, Object.assign({}, O, {
    position: l,
    editMode: C,
    onClose: function onClose() {
      return j(!1);
    }
  }))));
}, exports.PropTypes = $n, exports.StatusScreen = _e, exports._objectSpread2 = s, exports._objectWithoutProperties = d, exports._regeneratorRuntime = a, exports._slicedToArray = u, exports.checkFormConditionsStatus = et, exports.clearBlock = $e, exports.clearFormValues = function (e) {
  e.acceptedRecaptcha && delete e.acceptedRecaptcha, e.signature && (delete e.signature.points, delete e.signature.signedTimestamp, e.extraData = e.extraData || {}, delete e.extraData["Form signed at"]), e.legal && (delete e.legal.acceptedAt, delete e.legal.acceptedTimestamp, e.extraData = e.extraData || {}, delete e.extraData["Terms and Policy accepted at"]), (e.pages || []).forEach(function (e) {
    (e.blocks || []).forEach(function (e) {
      return $e(e);
    });
  });
}, exports.colors = ee, exports.commonjsGlobal = r, exports.config = x, exports.createCommonjsModule = i, exports.createPaymentIntent = function (e, t) {
  var n, r, o;
  return a.async(function (i) {
    for (;;) {
      switch (i.prev = i.next) {
        case 0:
          return n = e.customServerEndpoint || x.SERVER_URL, i.next = 3, a.awrap(fetch("".concat(n, "/stripe/payment-intent"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              form: e,
              block: t
            })
          }));

        case 3:
          return r = i.sent, i.next = 6, a.awrap(r.json());

        case 6:
          if (o = i.sent, r.ok) {
            i.next = 9;
            break;
          }

          throw new Error(o.error);

        case 9:
          return i.abrupt("return", o);

        case 10:
        case "end":
          return i.stop();
      }
    }
  });
}, exports.createSubscriptionCustomer = function (e, t, n) {
  var r, o, i;
  return a.async(function (c) {
    for (;;) {
      switch (c.prev = c.next) {
        case 0:
          return r = e.customServerEndpoint || x.SERVER_URL, c.next = 3, a.awrap(fetch("".concat(r, "/stripe/create-customer"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              form: e,
              customer: t,
              address: n
            })
          }));

        case 3:
          return o = c.sent, c.next = 6, a.awrap(o.json());

        case 6:
          if (i = c.sent, o.ok) {
            c.next = 9;
            break;
          }

          throw new Error(i.error);

        case 9:
          return c.abrupt("return", i);

        case 10:
        case "end":
          return c.stop();
      }
    }
  });
}, exports.decodeData = we, exports.encodeData = function (e) {
  return Ee(xe(e).replace(/=/g, "").replace(/\0/g, ""));
}, exports.getCjsExportFromNamespace = function (e) {
  return e && e.default || e;
}, exports.getDefaultBadge = Rt, exports.getTypeLabel = function (e) {
  switch (e) {
    case "contact":
      return "Fields";

    case "files":
      return "Files Upload";

    case "date":
      return "Date Picker";

    case "open":
      return "Open";

    case "number-scale":
      return "Number Scale / NPS";

    case "selection":
      return "Selection";

    case "single-selection":
      return "Single-selection";

    case "stars":
      return "Stars / Emojis";

    case "multi-selection":
      return "Multiple-selection";

    case "description":
      return "Description";

    case "stripe":
      return "Stripe Payment";

    case "image":
      return "Image / GIF / Video";

    case "video":
      return "YouTube Video";

    case "slider":
      return "Slider";

    case "matrix":
      return "Matrix";

    default:
      return e;
  }
}, exports.isQuestionVisible = m, exports.lightOrDark = dt, exports.parseMarkdown = Pe, exports.propTypes = $n, exports.renderBlock = Jt, exports.returnBlockValue = g, exports.returnConditionStatus = Xe, exports.returnFormBlocks = Yt, exports.returnFormData = h, exports.returnFormDataArray = function () {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = arguments.length > 1 ? arguments[1] : void 0,
      n = e.pages || [],
      r = [];
  return n.forEach(function (n) {
    (n.blocks || []).forEach(function (n) {
      if ("contact" !== n.type && "matrix" !== n.type) {
        var o = g(n, e).value;
        t && n.files && (o += n.files.map(function (e) {
          return "\n".concat(e.url);
        })), o && r.push({
          question: n.question || n.placeholder,
          id: n.id,
          value: o
        });
      } else {
        (n.value || []).forEach(function (t) {
          var n = g(t, e),
              o = n.value,
              i = n.canSend;
          o && i && r.push({
            question: t.question || t.placeholder || t.title,
            id: t.id,
            value: o
          });
        });
      }
    });
  }), e.extraData && Object.keys(e.extraData).forEach(function (t) {
    r.push({
      question: t,
      id: t,
      value: e.extraData[t]
    });
  }), r;
}, exports.returnFormFiles = sn, exports.returnFormQuestions = v, exports.returnInputName = Se, exports.returnPageBlocks = function (e, t) {
  return (e.pages || [])[t].blocks || [];
}, exports.returnPageCompletionStatus = Re, exports.returnVisibleQuestions = Ae, exports.unwrapExports = o, exports.uploadFormFiles = ln;